"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: rocketchat/api/model.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Region = exports.User_ScoreBadge = exports.User_KarrotScore = exports.User = exports.Smb = exports.Article = exports.Channel_Input_Text = exports.Channel_Input = exports.Channel_EnabledFeature = exports.Channel = exports.StickerPromotion = exports.StickerIcon = exports.StickerPack = exports.StickerPackMeta = exports.StickerTemplate = exports.Sticker = exports.VideoTemplate = exports.Video = exports.Image = exports.Promise_Location = exports.Promise = exports.Link = exports.MessageContext = exports.Message_MentionedNicknameMapEntry = exports.Message_SeenEntry = exports.Message = exports.UserID_Type = exports.ChannelListHeader_BasicBanner_Button_Type = exports.ChannelListHeader_BasicBanner_Color = exports.BizAccount_Type = exports.ButtonPostbackPayload_Webhook_HttpMethod = exports.ButtonPostbackPayload_Type = exports.Button_Type = exports.SystemMessage_Type = exports.User_IdentificationStatus = exports.User_Role = exports.User_Type = exports.Channel_Type = exports.Video_State = exports.ChannelType = exports.UserRole = exports.SearchAnalyzerType = exports.SearchSortOption = exports.Badge = exports.FilterID = exports.NativeAction = exports.Visible = exports.ImageAspectRatio = exports.TemplateType = exports.protobufPackage = void 0;
exports.ReactionTarget = exports.TopBar = exports.MoreMenu = exports.BlockTemplate = exports.BlockNode = exports.TextNode_PlainText = exports.TextNode_Markdown = exports.TextNode = exports.SectionBlock = exports.Announcement = exports.AutoReply = exports.AutoReplyAnswer = exports.AutoReplyQuestion = exports.AutoReplyMetadata = exports.PersistentMenu = exports.PersistentMenuItem_OpenURLAction = exports.PersistentMenuItem_PostbackAction = exports.PersistentMenuItem = exports.ChannelListHeader_BasicBanner_Button = exports.ChannelListHeader_BasicBanner = exports.ChannelListHeader_NoticeWithLink = exports.ChannelListHeader_Notice = exports.ChannelListHeader = exports.ToolboxButton = exports.ImageButton = exports.Introduction_Row = exports.Introduction = exports.BubbleGroup_TagsEntry = exports.BubbleGroup = exports.TextShortcut = exports.WebView = exports.BizAccountUser = exports.BizAccount = exports.Snackbar = exports.ButtonPostbackAction = exports.ButtonPostbackPayload_Webhook = exports.ButtonPostbackPayload_WebLogout = exports.ButtonPostbackPayload_HoianPromise = exports.ButtonPostbackPayload = exports.ButtonTargetURI = exports.Button = exports.InlineTemplate = exports.IconTemplate = exports.LocationTemplate = exports.ArticleTemplate = exports.GenericTemplate = exports.SystemMessage = exports.UnreadCount_BizMessageEntry = exports.UnreadCount = exports.Notice = void 0;
exports.ChannelSummary = exports.ChannelPreview_UnreadCount = exports.ChannelPreview_PreviewMessage = exports.ChannelPreview = exports.ChannelDetail = exports.ChannelInput_Text = exports.ChannelInput = exports.EnabledFeature = exports.SavedMessagePagingKey = exports.SavedMessage = exports.UniqueMessageID = exports.UserSessionInfo = exports.UserID = exports.SearchPagingKey = exports.SearchMessageHit = exports.SearchResultMessage_Token = exports.SearchResultMessage = exports.SearchResultReactionSummary = exports.SearchResultUser = exports.SearchResultChannel = exports.Filter = exports.Reaction = exports.ReactionSummary = exports.Emoji = exports.ReactionTarget_MessageID = void 0;
exports.templateTypeFromJSON = templateTypeFromJSON;
exports.templateTypeToJSON = templateTypeToJSON;
exports.templateTypeToNumber = templateTypeToNumber;
exports.imageAspectRatioFromJSON = imageAspectRatioFromJSON;
exports.imageAspectRatioToJSON = imageAspectRatioToJSON;
exports.imageAspectRatioToNumber = imageAspectRatioToNumber;
exports.visibleFromJSON = visibleFromJSON;
exports.visibleToJSON = visibleToJSON;
exports.visibleToNumber = visibleToNumber;
exports.nativeActionFromJSON = nativeActionFromJSON;
exports.nativeActionToJSON = nativeActionToJSON;
exports.nativeActionToNumber = nativeActionToNumber;
exports.filterIDFromJSON = filterIDFromJSON;
exports.filterIDToJSON = filterIDToJSON;
exports.filterIDToNumber = filterIDToNumber;
exports.badgeFromJSON = badgeFromJSON;
exports.badgeToJSON = badgeToJSON;
exports.badgeToNumber = badgeToNumber;
exports.searchSortOptionFromJSON = searchSortOptionFromJSON;
exports.searchSortOptionToJSON = searchSortOptionToJSON;
exports.searchSortOptionToNumber = searchSortOptionToNumber;
exports.searchAnalyzerTypeFromJSON = searchAnalyzerTypeFromJSON;
exports.searchAnalyzerTypeToJSON = searchAnalyzerTypeToJSON;
exports.searchAnalyzerTypeToNumber = searchAnalyzerTypeToNumber;
exports.userRoleFromJSON = userRoleFromJSON;
exports.userRoleToJSON = userRoleToJSON;
exports.userRoleToNumber = userRoleToNumber;
exports.channelTypeFromJSON = channelTypeFromJSON;
exports.channelTypeToJSON = channelTypeToJSON;
exports.channelTypeToNumber = channelTypeToNumber;
exports.video_StateFromJSON = video_StateFromJSON;
exports.video_StateToJSON = video_StateToJSON;
exports.video_StateToNumber = video_StateToNumber;
exports.channel_TypeFromJSON = channel_TypeFromJSON;
exports.channel_TypeToJSON = channel_TypeToJSON;
exports.channel_TypeToNumber = channel_TypeToNumber;
exports.user_TypeFromJSON = user_TypeFromJSON;
exports.user_TypeToJSON = user_TypeToJSON;
exports.user_TypeToNumber = user_TypeToNumber;
exports.user_RoleFromJSON = user_RoleFromJSON;
exports.user_RoleToJSON = user_RoleToJSON;
exports.user_RoleToNumber = user_RoleToNumber;
exports.user_IdentificationStatusFromJSON = user_IdentificationStatusFromJSON;
exports.user_IdentificationStatusToJSON = user_IdentificationStatusToJSON;
exports.user_IdentificationStatusToNumber = user_IdentificationStatusToNumber;
exports.systemMessage_TypeFromJSON = systemMessage_TypeFromJSON;
exports.systemMessage_TypeToJSON = systemMessage_TypeToJSON;
exports.systemMessage_TypeToNumber = systemMessage_TypeToNumber;
exports.button_TypeFromJSON = button_TypeFromJSON;
exports.button_TypeToJSON = button_TypeToJSON;
exports.button_TypeToNumber = button_TypeToNumber;
exports.buttonPostbackPayload_TypeFromJSON = buttonPostbackPayload_TypeFromJSON;
exports.buttonPostbackPayload_TypeToJSON = buttonPostbackPayload_TypeToJSON;
exports.buttonPostbackPayload_TypeToNumber = buttonPostbackPayload_TypeToNumber;
exports.buttonPostbackPayload_Webhook_HttpMethodFromJSON = buttonPostbackPayload_Webhook_HttpMethodFromJSON;
exports.buttonPostbackPayload_Webhook_HttpMethodToJSON = buttonPostbackPayload_Webhook_HttpMethodToJSON;
exports.buttonPostbackPayload_Webhook_HttpMethodToNumber = buttonPostbackPayload_Webhook_HttpMethodToNumber;
exports.bizAccount_TypeFromJSON = bizAccount_TypeFromJSON;
exports.bizAccount_TypeToJSON = bizAccount_TypeToJSON;
exports.bizAccount_TypeToNumber = bizAccount_TypeToNumber;
exports.channelListHeader_BasicBanner_ColorFromJSON = channelListHeader_BasicBanner_ColorFromJSON;
exports.channelListHeader_BasicBanner_ColorToJSON = channelListHeader_BasicBanner_ColorToJSON;
exports.channelListHeader_BasicBanner_ColorToNumber = channelListHeader_BasicBanner_ColorToNumber;
exports.channelListHeader_BasicBanner_Button_TypeFromJSON = channelListHeader_BasicBanner_Button_TypeFromJSON;
exports.channelListHeader_BasicBanner_Button_TypeToJSON = channelListHeader_BasicBanner_Button_TypeToJSON;
exports.channelListHeader_BasicBanner_Button_TypeToNumber = channelListHeader_BasicBanner_Button_TypeToNumber;
exports.userID_TypeFromJSON = userID_TypeFromJSON;
exports.userID_TypeToJSON = userID_TypeToJSON;
exports.userID_TypeToNumber = userID_TypeToNumber;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../../google/protobuf/duration");
const timestamp_1 = require("../../google/protobuf/timestamp");
exports.protobufPackage = "api";
/** Template type */
var TemplateType;
(function (TemplateType) {
    TemplateType["TEMPLATE_TYPE_UNSPECIFIED"] = "TEMPLATE_TYPE_UNSPECIFIED";
    /**
     * TEMPLATE_TYPE_ARTICLE - Deprecated.
     *
     * @deprecated
     */
    TemplateType["TEMPLATE_TYPE_ARTICLE"] = "TEMPLATE_TYPE_ARTICLE";
    TemplateType["TEMPLATE_TYPE_GENERIC"] = "TEMPLATE_TYPE_GENERIC";
    TemplateType["TEMPLATE_TYPE_LOCATION"] = "TEMPLATE_TYPE_LOCATION";
    TemplateType["TEMPLATE_TYPE_ICON"] = "TEMPLATE_TYPE_ICON";
    TemplateType["TEMPLATE_TYPE_INLINE"] = "TEMPLATE_TYPE_INLINE";
    TemplateType["TEMPLATE_TYPE_BLOCK"] = "TEMPLATE_TYPE_BLOCK";
    TemplateType["TEMPLATE_TYPE_VIDEO"] = "TEMPLATE_TYPE_VIDEO";
    TemplateType["TEMPLATE_TYPE_STICKER"] = "TEMPLATE_TYPE_STICKER";
})(TemplateType || (exports.TemplateType = TemplateType = {}));
function templateTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TEMPLATE_TYPE_UNSPECIFIED":
            return TemplateType.TEMPLATE_TYPE_UNSPECIFIED;
        case 1:
        case "TEMPLATE_TYPE_ARTICLE":
            return TemplateType.TEMPLATE_TYPE_ARTICLE;
        case 2:
        case "TEMPLATE_TYPE_GENERIC":
            return TemplateType.TEMPLATE_TYPE_GENERIC;
        case 3:
        case "TEMPLATE_TYPE_LOCATION":
            return TemplateType.TEMPLATE_TYPE_LOCATION;
        case 4:
        case "TEMPLATE_TYPE_ICON":
            return TemplateType.TEMPLATE_TYPE_ICON;
        case 5:
        case "TEMPLATE_TYPE_INLINE":
            return TemplateType.TEMPLATE_TYPE_INLINE;
        case 6:
        case "TEMPLATE_TYPE_BLOCK":
            return TemplateType.TEMPLATE_TYPE_BLOCK;
        case 7:
        case "TEMPLATE_TYPE_VIDEO":
            return TemplateType.TEMPLATE_TYPE_VIDEO;
        case 8:
        case "TEMPLATE_TYPE_STICKER":
            return TemplateType.TEMPLATE_TYPE_STICKER;
        default:
            return TemplateType.TEMPLATE_TYPE_UNSPECIFIED;
    }
}
function templateTypeToJSON(object) {
    switch (object) {
        case TemplateType.TEMPLATE_TYPE_UNSPECIFIED:
            return "TEMPLATE_TYPE_UNSPECIFIED";
        case TemplateType.TEMPLATE_TYPE_ARTICLE:
            return "TEMPLATE_TYPE_ARTICLE";
        case TemplateType.TEMPLATE_TYPE_GENERIC:
            return "TEMPLATE_TYPE_GENERIC";
        case TemplateType.TEMPLATE_TYPE_LOCATION:
            return "TEMPLATE_TYPE_LOCATION";
        case TemplateType.TEMPLATE_TYPE_ICON:
            return "TEMPLATE_TYPE_ICON";
        case TemplateType.TEMPLATE_TYPE_INLINE:
            return "TEMPLATE_TYPE_INLINE";
        case TemplateType.TEMPLATE_TYPE_BLOCK:
            return "TEMPLATE_TYPE_BLOCK";
        case TemplateType.TEMPLATE_TYPE_VIDEO:
            return "TEMPLATE_TYPE_VIDEO";
        case TemplateType.TEMPLATE_TYPE_STICKER:
            return "TEMPLATE_TYPE_STICKER";
        default:
            return "TEMPLATE_TYPE_UNSPECIFIED";
    }
}
function templateTypeToNumber(object) {
    switch (object) {
        case TemplateType.TEMPLATE_TYPE_UNSPECIFIED:
            return 0;
        case TemplateType.TEMPLATE_TYPE_ARTICLE:
            return 1;
        case TemplateType.TEMPLATE_TYPE_GENERIC:
            return 2;
        case TemplateType.TEMPLATE_TYPE_LOCATION:
            return 3;
        case TemplateType.TEMPLATE_TYPE_ICON:
            return 4;
        case TemplateType.TEMPLATE_TYPE_INLINE:
            return 5;
        case TemplateType.TEMPLATE_TYPE_BLOCK:
            return 6;
        case TemplateType.TEMPLATE_TYPE_VIDEO:
            return 7;
        case TemplateType.TEMPLATE_TYPE_STICKER:
            return 8;
        default:
            return 0;
    }
}
/** Image 비율 */
var ImageAspectRatio;
(function (ImageAspectRatio) {
    ImageAspectRatio["IMAGE_ASPECT_RATIO_UNSPECIFIED"] = "IMAGE_ASPECT_RATIO_UNSPECIFIED";
    /** IMAGE_ASPECT_RATIO_HORIZONTAL - 4:3 비율, 권장 사이즈: 720x540px 이내 */
    ImageAspectRatio["IMAGE_ASPECT_RATIO_HORIZONTAL"] = "IMAGE_ASPECT_RATIO_HORIZONTAL";
    /** IMAGE_ASPECT_RATIO_SQUARE - 1:1 비율, 권장 사이즈: 720x720px 이내 */
    ImageAspectRatio["IMAGE_ASPECT_RATIO_SQUARE"] = "IMAGE_ASPECT_RATIO_SQUARE";
    /**
     * IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE - 16:9 비율, 권장 사이즈: 720x405px 이내
     * 23.29.0 버전부터 사용 가능
     * 23.29.0 미만 버전에서는 가운데 크롭된 이미지로
     * IMAGE_ASPECT_RATIO_HORIZONTAL과 동일하게 동작
     */
    ImageAspectRatio["IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE"] = "IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE";
})(ImageAspectRatio || (exports.ImageAspectRatio = ImageAspectRatio = {}));
function imageAspectRatioFromJSON(object) {
    switch (object) {
        case 0:
        case "IMAGE_ASPECT_RATIO_UNSPECIFIED":
            return ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED;
        case 1:
        case "IMAGE_ASPECT_RATIO_HORIZONTAL":
            return ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL;
        case 2:
        case "IMAGE_ASPECT_RATIO_SQUARE":
            return ImageAspectRatio.IMAGE_ASPECT_RATIO_SQUARE;
        case 3:
        case "IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE":
            return ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE;
        default:
            return ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED;
    }
}
function imageAspectRatioToJSON(object) {
    switch (object) {
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED:
            return "IMAGE_ASPECT_RATIO_UNSPECIFIED";
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL:
            return "IMAGE_ASPECT_RATIO_HORIZONTAL";
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_SQUARE:
            return "IMAGE_ASPECT_RATIO_SQUARE";
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE:
            return "IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE";
        default:
            return "IMAGE_ASPECT_RATIO_UNSPECIFIED";
    }
}
function imageAspectRatioToNumber(object) {
    switch (object) {
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED:
            return 0;
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL:
            return 1;
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_SQUARE:
            return 2;
        case ImageAspectRatio.IMAGE_ASPECT_RATIO_HORIZONTAL_WIDE:
            return 3;
        default:
            return 0;
    }
}
/** 메시지를 보여줄 대상을 설정 */
var Visible;
(function (Visible) {
    Visible["VISIBLE_UNSPECIFIED"] = "VISIBLE_UNSPECIFIED";
    /** VISIBLE_SENDER - 보내는 사람에게만 메시지가 보임 */
    Visible["VISIBLE_SENDER"] = "VISIBLE_SENDER";
    /** VISIBLE_RECEIVER - 받는 사람에게만 메시지가 보임 */
    Visible["VISIBLE_RECEIVER"] = "VISIBLE_RECEIVER";
    /** VISIBLE_ALL - 모두에게 메시지가 보임 */
    Visible["VISIBLE_ALL"] = "VISIBLE_ALL";
})(Visible || (exports.Visible = Visible = {}));
function visibleFromJSON(object) {
    switch (object) {
        case 0:
        case "VISIBLE_UNSPECIFIED":
            return Visible.VISIBLE_UNSPECIFIED;
        case 1:
        case "VISIBLE_SENDER":
            return Visible.VISIBLE_SENDER;
        case 2:
        case "VISIBLE_RECEIVER":
            return Visible.VISIBLE_RECEIVER;
        case 3:
        case "VISIBLE_ALL":
            return Visible.VISIBLE_ALL;
        default:
            return Visible.VISIBLE_UNSPECIFIED;
    }
}
function visibleToJSON(object) {
    switch (object) {
        case Visible.VISIBLE_UNSPECIFIED:
            return "VISIBLE_UNSPECIFIED";
        case Visible.VISIBLE_SENDER:
            return "VISIBLE_SENDER";
        case Visible.VISIBLE_RECEIVER:
            return "VISIBLE_RECEIVER";
        case Visible.VISIBLE_ALL:
            return "VISIBLE_ALL";
        default:
            return "VISIBLE_UNSPECIFIED";
    }
}
function visibleToNumber(object) {
    switch (object) {
        case Visible.VISIBLE_UNSPECIFIED:
            return 0;
        case Visible.VISIBLE_SENDER:
            return 1;
        case Visible.VISIBLE_RECEIVER:
            return 2;
        case Visible.VISIBLE_ALL:
            return 3;
        default:
            return 0;
    }
}
var NativeAction;
(function (NativeAction) {
    NativeAction["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    NativeAction["PICTURE"] = "PICTURE";
    NativeAction["CAMERA"] = "CAMERA";
    NativeAction["SHARE_LOCATION"] = "SHARE_LOCATION";
    NativeAction["PROMISE"] = "PROMISE";
    NativeAction["FAVORITE_PHRASES"] = "FAVORITE_PHRASES";
    /**
     * SAFE_NUMBER - Deprecated.
     *
     * @deprecated
     */
    NativeAction["SAFE_NUMBER"] = "SAFE_NUMBER";
    NativeAction["VOIP"] = "VOIP";
    NativeAction["SEND_MONEY"] = "SEND_MONEY";
})(NativeAction || (exports.NativeAction = NativeAction = {}));
function nativeActionFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return NativeAction.TYPE_UNSPECIFIED;
        case 1:
        case "PICTURE":
            return NativeAction.PICTURE;
        case 2:
        case "CAMERA":
            return NativeAction.CAMERA;
        case 3:
        case "SHARE_LOCATION":
            return NativeAction.SHARE_LOCATION;
        case 4:
        case "PROMISE":
            return NativeAction.PROMISE;
        case 5:
        case "FAVORITE_PHRASES":
            return NativeAction.FAVORITE_PHRASES;
        case 6:
        case "SAFE_NUMBER":
            return NativeAction.SAFE_NUMBER;
        case 7:
        case "VOIP":
            return NativeAction.VOIP;
        case 8:
        case "SEND_MONEY":
            return NativeAction.SEND_MONEY;
        default:
            return NativeAction.TYPE_UNSPECIFIED;
    }
}
function nativeActionToJSON(object) {
    switch (object) {
        case NativeAction.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case NativeAction.PICTURE:
            return "PICTURE";
        case NativeAction.CAMERA:
            return "CAMERA";
        case NativeAction.SHARE_LOCATION:
            return "SHARE_LOCATION";
        case NativeAction.PROMISE:
            return "PROMISE";
        case NativeAction.FAVORITE_PHRASES:
            return "FAVORITE_PHRASES";
        case NativeAction.SAFE_NUMBER:
            return "SAFE_NUMBER";
        case NativeAction.VOIP:
            return "VOIP";
        case NativeAction.SEND_MONEY:
            return "SEND_MONEY";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function nativeActionToNumber(object) {
    switch (object) {
        case NativeAction.TYPE_UNSPECIFIED:
            return 0;
        case NativeAction.PICTURE:
            return 1;
        case NativeAction.CAMERA:
            return 2;
        case NativeAction.SHARE_LOCATION:
            return 3;
        case NativeAction.PROMISE:
            return 4;
        case NativeAction.FAVORITE_PHRASES:
            return 5;
        case NativeAction.SAFE_NUMBER:
            return 6;
        case NativeAction.VOIP:
            return 7;
        case NativeAction.SEND_MONEY:
            return 8;
        default:
            return 0;
    }
}
var FilterID;
(function (FilterID) {
    FilterID["FILTER_ID_UNSPECIFIED"] = "FILTER_ID_UNSPECIFIED";
    FilterID["FILTER_ID_ALL"] = "FILTER_ID_ALL";
    /** FILTER_ID_FLEAMARKET - 서비스 필터 목록 */
    FilterID["FILTER_ID_FLEAMARKET"] = "FILTER_ID_FLEAMARKET";
    FilterID["FILTER_ID_COMMUNITY"] = "FILTER_ID_COMMUNITY";
    FilterID["FILTER_ID_JOBS"] = "FILTER_ID_JOBS";
    FilterID["FILTER_ID_CARS"] = "FILTER_ID_CARS";
    FilterID["FILTER_ID_REALTY"] = "FILTER_ID_REALTY";
    /** FILTER_ID_BUY - 공통 필터 목록 */
    FilterID["FILTER_ID_BUY"] = "FILTER_ID_BUY";
    FilterID["FILTER_ID_SELL"] = "FILTER_ID_SELL";
    FilterID["FILTER_ID_UNREAD_COUNT"] = "FILTER_ID_UNREAD_COUNT";
})(FilterID || (exports.FilterID = FilterID = {}));
function filterIDFromJSON(object) {
    switch (object) {
        case 0:
        case "FILTER_ID_UNSPECIFIED":
            return FilterID.FILTER_ID_UNSPECIFIED;
        case 0:
        case "FILTER_ID_ALL":
            return FilterID.FILTER_ID_ALL;
        case 1:
        case "FILTER_ID_FLEAMARKET":
            return FilterID.FILTER_ID_FLEAMARKET;
        case 2:
        case "FILTER_ID_COMMUNITY":
            return FilterID.FILTER_ID_COMMUNITY;
        case 3:
        case "FILTER_ID_JOBS":
            return FilterID.FILTER_ID_JOBS;
        case 4:
        case "FILTER_ID_CARS":
            return FilterID.FILTER_ID_CARS;
        case 5:
        case "FILTER_ID_REALTY":
            return FilterID.FILTER_ID_REALTY;
        case 20:
        case "FILTER_ID_BUY":
            return FilterID.FILTER_ID_BUY;
        case 21:
        case "FILTER_ID_SELL":
            return FilterID.FILTER_ID_SELL;
        case 40:
        case "FILTER_ID_UNREAD_COUNT":
            return FilterID.FILTER_ID_UNREAD_COUNT;
        default:
            return FilterID.FILTER_ID_ALL;
    }
}
function filterIDToJSON(object) {
    switch (object) {
        case FilterID.FILTER_ID_UNSPECIFIED:
            return "FILTER_ID_UNSPECIFIED";
        case FilterID.FILTER_ID_ALL:
            return "FILTER_ID_ALL";
        case FilterID.FILTER_ID_FLEAMARKET:
            return "FILTER_ID_FLEAMARKET";
        case FilterID.FILTER_ID_COMMUNITY:
            return "FILTER_ID_COMMUNITY";
        case FilterID.FILTER_ID_JOBS:
            return "FILTER_ID_JOBS";
        case FilterID.FILTER_ID_CARS:
            return "FILTER_ID_CARS";
        case FilterID.FILTER_ID_REALTY:
            return "FILTER_ID_REALTY";
        case FilterID.FILTER_ID_BUY:
            return "FILTER_ID_BUY";
        case FilterID.FILTER_ID_SELL:
            return "FILTER_ID_SELL";
        case FilterID.FILTER_ID_UNREAD_COUNT:
            return "FILTER_ID_UNREAD_COUNT";
        default:
            return "FILTER_ID_ALL";
    }
}
function filterIDToNumber(object) {
    switch (object) {
        case FilterID.FILTER_ID_UNSPECIFIED:
            return 0;
        case FilterID.FILTER_ID_ALL:
            return 0;
        case FilterID.FILTER_ID_FLEAMARKET:
            return 1;
        case FilterID.FILTER_ID_COMMUNITY:
            return 2;
        case FilterID.FILTER_ID_JOBS:
            return 3;
        case FilterID.FILTER_ID_CARS:
            return 4;
        case FilterID.FILTER_ID_REALTY:
            return 5;
        case FilterID.FILTER_ID_BUY:
            return 20;
        case FilterID.FILTER_ID_SELL:
            return 21;
        case FilterID.FILTER_ID_UNREAD_COUNT:
            return 40;
        default:
            return 0;
    }
}
var Badge;
(function (Badge) {
    Badge["BADGE_UNSPECIFIED"] = "BADGE_UNSPECIFIED";
    Badge["BADGE_PROMISED"] = "BADGE_PROMISED";
    Badge["BADGE_RESERVED"] = "BADGE_RESERVED";
    Badge["BADGE_ESCROW"] = "BADGE_ESCROW";
})(Badge || (exports.Badge = Badge = {}));
function badgeFromJSON(object) {
    switch (object) {
        case 0:
        case "BADGE_UNSPECIFIED":
            return Badge.BADGE_UNSPECIFIED;
        case 1:
        case "BADGE_PROMISED":
            return Badge.BADGE_PROMISED;
        case 2:
        case "BADGE_RESERVED":
            return Badge.BADGE_RESERVED;
        case 3:
        case "BADGE_ESCROW":
            return Badge.BADGE_ESCROW;
        default:
            return Badge.BADGE_UNSPECIFIED;
    }
}
function badgeToJSON(object) {
    switch (object) {
        case Badge.BADGE_UNSPECIFIED:
            return "BADGE_UNSPECIFIED";
        case Badge.BADGE_PROMISED:
            return "BADGE_PROMISED";
        case Badge.BADGE_RESERVED:
            return "BADGE_RESERVED";
        case Badge.BADGE_ESCROW:
            return "BADGE_ESCROW";
        default:
            return "BADGE_UNSPECIFIED";
    }
}
function badgeToNumber(object) {
    switch (object) {
        case Badge.BADGE_UNSPECIFIED:
            return 0;
        case Badge.BADGE_PROMISED:
            return 1;
        case Badge.BADGE_RESERVED:
            return 2;
        case Badge.BADGE_ESCROW:
            return 3;
        default:
            return 0;
    }
}
/** 검색 결과 정렬 옵션 */
var SearchSortOption;
(function (SearchSortOption) {
    SearchSortOption["SEARCH_SORT_UNSPECIFIED"] = "SEARCH_SORT_UNSPECIFIED";
    /** SEARCH_SORT_MESSAGE_ID_DESCENDING - message_id 기준 최신순 */
    SearchSortOption["SEARCH_SORT_MESSAGE_ID_DESCENDING"] = "SEARCH_SORT_MESSAGE_ID_DESCENDING";
    /** SEARCH_SORT_MESSAGE_ID_ASCENDING - message_id 기준 오래된순 */
    SearchSortOption["SEARCH_SORT_MESSAGE_ID_ASCENDING"] = "SEARCH_SORT_MESSAGE_ID_ASCENDING";
})(SearchSortOption || (exports.SearchSortOption = SearchSortOption = {}));
function searchSortOptionFromJSON(object) {
    switch (object) {
        case 0:
        case "SEARCH_SORT_UNSPECIFIED":
            return SearchSortOption.SEARCH_SORT_UNSPECIFIED;
        case 1:
        case "SEARCH_SORT_MESSAGE_ID_DESCENDING":
            return SearchSortOption.SEARCH_SORT_MESSAGE_ID_DESCENDING;
        case 2:
        case "SEARCH_SORT_MESSAGE_ID_ASCENDING":
            return SearchSortOption.SEARCH_SORT_MESSAGE_ID_ASCENDING;
        default:
            return SearchSortOption.SEARCH_SORT_UNSPECIFIED;
    }
}
function searchSortOptionToJSON(object) {
    switch (object) {
        case SearchSortOption.SEARCH_SORT_UNSPECIFIED:
            return "SEARCH_SORT_UNSPECIFIED";
        case SearchSortOption.SEARCH_SORT_MESSAGE_ID_DESCENDING:
            return "SEARCH_SORT_MESSAGE_ID_DESCENDING";
        case SearchSortOption.SEARCH_SORT_MESSAGE_ID_ASCENDING:
            return "SEARCH_SORT_MESSAGE_ID_ASCENDING";
        default:
            return "SEARCH_SORT_UNSPECIFIED";
    }
}
function searchSortOptionToNumber(object) {
    switch (object) {
        case SearchSortOption.SEARCH_SORT_UNSPECIFIED:
            return 0;
        case SearchSortOption.SEARCH_SORT_MESSAGE_ID_DESCENDING:
            return 1;
        case SearchSortOption.SEARCH_SORT_MESSAGE_ID_ASCENDING:
            return 2;
        default:
            return 0;
    }
}
/** 검색할 텍스트의 분석기 타입 */
var SearchAnalyzerType;
(function (SearchAnalyzerType) {
    SearchAnalyzerType["SEARCH_ANALYZER_TYPE_UNSPECIFIED"] = "SEARCH_ANALYZER_TYPE_UNSPECIFIED";
    SearchAnalyzerType["SEARCH_ANALYZER_TYPE_NGRAM"] = "SEARCH_ANALYZER_TYPE_NGRAM";
    SearchAnalyzerType["SEARCH_ANALYZER_TYPE_KARROT"] = "SEARCH_ANALYZER_TYPE_KARROT";
})(SearchAnalyzerType || (exports.SearchAnalyzerType = SearchAnalyzerType = {}));
function searchAnalyzerTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "SEARCH_ANALYZER_TYPE_UNSPECIFIED":
            return SearchAnalyzerType.SEARCH_ANALYZER_TYPE_UNSPECIFIED;
        case 1:
        case "SEARCH_ANALYZER_TYPE_NGRAM":
            return SearchAnalyzerType.SEARCH_ANALYZER_TYPE_NGRAM;
        case 2:
        case "SEARCH_ANALYZER_TYPE_KARROT":
            return SearchAnalyzerType.SEARCH_ANALYZER_TYPE_KARROT;
        default:
            return SearchAnalyzerType.SEARCH_ANALYZER_TYPE_UNSPECIFIED;
    }
}
function searchAnalyzerTypeToJSON(object) {
    switch (object) {
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_UNSPECIFIED:
            return "SEARCH_ANALYZER_TYPE_UNSPECIFIED";
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_NGRAM:
            return "SEARCH_ANALYZER_TYPE_NGRAM";
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_KARROT:
            return "SEARCH_ANALYZER_TYPE_KARROT";
        default:
            return "SEARCH_ANALYZER_TYPE_UNSPECIFIED";
    }
}
function searchAnalyzerTypeToNumber(object) {
    switch (object) {
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_UNSPECIFIED:
            return 0;
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_NGRAM:
            return 1;
        case SearchAnalyzerType.SEARCH_ANALYZER_TYPE_KARROT:
            return 2;
        default:
            return 0;
    }
}
/** 유저의 역할 */
var UserRole;
(function (UserRole) {
    UserRole["USER_ROLE_UNSPECIFIED"] = "USER_ROLE_UNSPECIFIED";
    /** USER_ROLE_NORMAL - 일반 멤버 */
    UserRole["USER_ROLE_NORMAL"] = "USER_ROLE_NORMAL";
    /** USER_ROLE_SUPERHOST - 방장 */
    UserRole["USER_ROLE_SUPERHOST"] = "USER_ROLE_SUPERHOST";
    /** USER_ROLE_MANAGER - 관리권한이 있는 멤버 */
    UserRole["USER_ROLE_MANAGER"] = "USER_ROLE_MANAGER";
})(UserRole || (exports.UserRole = UserRole = {}));
function userRoleFromJSON(object) {
    switch (object) {
        case 0:
        case "USER_ROLE_UNSPECIFIED":
            return UserRole.USER_ROLE_UNSPECIFIED;
        case 1:
        case "USER_ROLE_NORMAL":
            return UserRole.USER_ROLE_NORMAL;
        case 2:
        case "USER_ROLE_SUPERHOST":
            return UserRole.USER_ROLE_SUPERHOST;
        case 3:
        case "USER_ROLE_MANAGER":
            return UserRole.USER_ROLE_MANAGER;
        default:
            return UserRole.USER_ROLE_UNSPECIFIED;
    }
}
function userRoleToJSON(object) {
    switch (object) {
        case UserRole.USER_ROLE_UNSPECIFIED:
            return "USER_ROLE_UNSPECIFIED";
        case UserRole.USER_ROLE_NORMAL:
            return "USER_ROLE_NORMAL";
        case UserRole.USER_ROLE_SUPERHOST:
            return "USER_ROLE_SUPERHOST";
        case UserRole.USER_ROLE_MANAGER:
            return "USER_ROLE_MANAGER";
        default:
            return "USER_ROLE_UNSPECIFIED";
    }
}
function userRoleToNumber(object) {
    switch (object) {
        case UserRole.USER_ROLE_UNSPECIFIED:
            return 0;
        case UserRole.USER_ROLE_NORMAL:
            return 1;
        case UserRole.USER_ROLE_SUPERHOST:
            return 2;
        case UserRole.USER_ROLE_MANAGER:
            return 3;
        default:
            return 0;
    }
}
/** Type of channel */
var ChannelType;
(function (ChannelType) {
    ChannelType["CHANNEL_TYPE_UNSPECIFIED"] = "CHANNEL_TYPE_UNSPECIFIED";
    /** CHANNEL_TYPE_DIRECT - 1:1 Direct */
    ChannelType["CHANNEL_TYPE_DIRECT"] = "CHANNEL_TYPE_DIRECT";
    /** CHANNEL_TYPE_GROUP - Group */
    ChannelType["CHANNEL_TYPE_GROUP"] = "CHANNEL_TYPE_GROUP";
})(ChannelType || (exports.ChannelType = ChannelType = {}));
function channelTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CHANNEL_TYPE_UNSPECIFIED":
            return ChannelType.CHANNEL_TYPE_UNSPECIFIED;
        case 1:
        case "CHANNEL_TYPE_DIRECT":
            return ChannelType.CHANNEL_TYPE_DIRECT;
        case 2:
        case "CHANNEL_TYPE_GROUP":
            return ChannelType.CHANNEL_TYPE_GROUP;
        default:
            return ChannelType.CHANNEL_TYPE_UNSPECIFIED;
    }
}
function channelTypeToJSON(object) {
    switch (object) {
        case ChannelType.CHANNEL_TYPE_UNSPECIFIED:
            return "CHANNEL_TYPE_UNSPECIFIED";
        case ChannelType.CHANNEL_TYPE_DIRECT:
            return "CHANNEL_TYPE_DIRECT";
        case ChannelType.CHANNEL_TYPE_GROUP:
            return "CHANNEL_TYPE_GROUP";
        default:
            return "CHANNEL_TYPE_UNSPECIFIED";
    }
}
function channelTypeToNumber(object) {
    switch (object) {
        case ChannelType.CHANNEL_TYPE_UNSPECIFIED:
            return 0;
        case ChannelType.CHANNEL_TYPE_DIRECT:
            return 1;
        case ChannelType.CHANNEL_TYPE_GROUP:
            return 2;
        default:
            return 0;
    }
}
var Video_State;
(function (Video_State) {
    Video_State["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    /** STATE_READY - 재생 가능 */
    Video_State["STATE_READY"] = "STATE_READY";
    /** STATE_INSPECTING - 검수중 */
    Video_State["STATE_INSPECTING"] = "STATE_INSPECTING";
    /** STATE_EXPIRED - 만료됨 */
    Video_State["STATE_EXPIRED"] = "STATE_EXPIRED";
    /** STATE_BLOCKED - 제재됨 */
    Video_State["STATE_BLOCKED"] = "STATE_BLOCKED";
})(Video_State || (exports.Video_State = Video_State = {}));
function video_StateFromJSON(object) {
    switch (object) {
        case 0:
        case "STATE_UNSPECIFIED":
            return Video_State.STATE_UNSPECIFIED;
        case 1:
        case "STATE_READY":
            return Video_State.STATE_READY;
        case 2:
        case "STATE_INSPECTING":
            return Video_State.STATE_INSPECTING;
        case 3:
        case "STATE_EXPIRED":
            return Video_State.STATE_EXPIRED;
        case 4:
        case "STATE_BLOCKED":
            return Video_State.STATE_BLOCKED;
        default:
            return Video_State.STATE_UNSPECIFIED;
    }
}
function video_StateToJSON(object) {
    switch (object) {
        case Video_State.STATE_UNSPECIFIED:
            return "STATE_UNSPECIFIED";
        case Video_State.STATE_READY:
            return "STATE_READY";
        case Video_State.STATE_INSPECTING:
            return "STATE_INSPECTING";
        case Video_State.STATE_EXPIRED:
            return "STATE_EXPIRED";
        case Video_State.STATE_BLOCKED:
            return "STATE_BLOCKED";
        default:
            return "STATE_UNSPECIFIED";
    }
}
function video_StateToNumber(object) {
    switch (object) {
        case Video_State.STATE_UNSPECIFIED:
            return 0;
        case Video_State.STATE_READY:
            return 1;
        case Video_State.STATE_INSPECTING:
            return 2;
        case Video_State.STATE_EXPIRED:
            return 3;
        case Video_State.STATE_BLOCKED:
            return 4;
        default:
            return 0;
    }
}
/** Type of channel */
var Channel_Type;
(function (Channel_Type) {
    Channel_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /** DIRECT - 1:1 Direct */
    Channel_Type["DIRECT"] = "DIRECT";
    /** GROUP - Group */
    Channel_Type["GROUP"] = "GROUP";
})(Channel_Type || (exports.Channel_Type = Channel_Type = {}));
function channel_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return Channel_Type.TYPE_UNSPECIFIED;
        case 1:
        case "DIRECT":
            return Channel_Type.DIRECT;
        case 2:
        case "GROUP":
            return Channel_Type.GROUP;
        default:
            return Channel_Type.TYPE_UNSPECIFIED;
    }
}
function channel_TypeToJSON(object) {
    switch (object) {
        case Channel_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case Channel_Type.DIRECT:
            return "DIRECT";
        case Channel_Type.GROUP:
            return "GROUP";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function channel_TypeToNumber(object) {
    switch (object) {
        case Channel_Type.TYPE_UNSPECIFIED:
            return 0;
        case Channel_Type.DIRECT:
            return 1;
        case Channel_Type.GROUP:
            return 2;
        default:
            return 0;
    }
}
/** 유저의 종류 */
var User_Type;
(function (User_Type) {
    User_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /** NORMAL - 일반 */
    User_Type["NORMAL"] = "NORMAL";
    /** BIZ_ACCOUNT - 비즈니스 */
    User_Type["BIZ_ACCOUNT"] = "BIZ_ACCOUNT";
    /** BIZ_USER - 비즈유저 */
    User_Type["BIZ_USER"] = "BIZ_USER";
})(User_Type || (exports.User_Type = User_Type = {}));
function user_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return User_Type.TYPE_UNSPECIFIED;
        case 1:
        case "NORMAL":
            return User_Type.NORMAL;
        case 2:
        case "BIZ_ACCOUNT":
            return User_Type.BIZ_ACCOUNT;
        case 3:
        case "BIZ_USER":
            return User_Type.BIZ_USER;
        default:
            return User_Type.TYPE_UNSPECIFIED;
    }
}
function user_TypeToJSON(object) {
    switch (object) {
        case User_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case User_Type.NORMAL:
            return "NORMAL";
        case User_Type.BIZ_ACCOUNT:
            return "BIZ_ACCOUNT";
        case User_Type.BIZ_USER:
            return "BIZ_USER";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function user_TypeToNumber(object) {
    switch (object) {
        case User_Type.TYPE_UNSPECIFIED:
            return 0;
        case User_Type.NORMAL:
            return 1;
        case User_Type.BIZ_ACCOUNT:
            return 2;
        case User_Type.BIZ_USER:
            return 3;
        default:
            return 0;
    }
}
/** 유저의 역할 */
var User_Role;
(function (User_Role) {
    User_Role["ROLE_UNSPECIFIED"] = "ROLE_UNSPECIFIED";
    /** ROLE_SUPERHOST - 방장 */
    User_Role["ROLE_SUPERHOST"] = "ROLE_SUPERHOST";
    /** ROLE_NORMAL - member */
    User_Role["ROLE_NORMAL"] = "ROLE_NORMAL";
    /** ROLE_MANAGER - 관리권한이 있는 멤버 */
    User_Role["ROLE_MANAGER"] = "ROLE_MANAGER";
})(User_Role || (exports.User_Role = User_Role = {}));
function user_RoleFromJSON(object) {
    switch (object) {
        case 0:
        case "ROLE_UNSPECIFIED":
            return User_Role.ROLE_UNSPECIFIED;
        case 2:
        case "ROLE_SUPERHOST":
            return User_Role.ROLE_SUPERHOST;
        case 1:
        case "ROLE_NORMAL":
            return User_Role.ROLE_NORMAL;
        case 3:
        case "ROLE_MANAGER":
            return User_Role.ROLE_MANAGER;
        default:
            return User_Role.ROLE_UNSPECIFIED;
    }
}
function user_RoleToJSON(object) {
    switch (object) {
        case User_Role.ROLE_UNSPECIFIED:
            return "ROLE_UNSPECIFIED";
        case User_Role.ROLE_SUPERHOST:
            return "ROLE_SUPERHOST";
        case User_Role.ROLE_NORMAL:
            return "ROLE_NORMAL";
        case User_Role.ROLE_MANAGER:
            return "ROLE_MANAGER";
        default:
            return "ROLE_UNSPECIFIED";
    }
}
function user_RoleToNumber(object) {
    switch (object) {
        case User_Role.ROLE_UNSPECIFIED:
            return 0;
        case User_Role.ROLE_SUPERHOST:
            return 2;
        case User_Role.ROLE_NORMAL:
            return 1;
        case User_Role.ROLE_MANAGER:
            return 3;
        default:
            return 0;
    }
}
var User_IdentificationStatus;
(function (User_IdentificationStatus) {
    User_IdentificationStatus["IDENTIFICATION_STATUS_UNSPECIFIED"] = "IDENTIFICATION_STATUS_UNSPECIFIED";
    /** IDENTIFICATION_STATUS_VERIFIED - 본인인증 완료 */
    User_IdentificationStatus["IDENTIFICATION_STATUS_VERIFIED"] = "IDENTIFICATION_STATUS_VERIFIED";
    /** IDENTIFICATION_STATUS_NOT_VERIFIED - 본인인증 미완료 */
    User_IdentificationStatus["IDENTIFICATION_STATUS_NOT_VERIFIED"] = "IDENTIFICATION_STATUS_NOT_VERIFIED";
    /** IDENTIFICATION_STATUS_EXPIRED - 본인인증 만료 */
    User_IdentificationStatus["IDENTIFICATION_STATUS_EXPIRED"] = "IDENTIFICATION_STATUS_EXPIRED";
})(User_IdentificationStatus || (exports.User_IdentificationStatus = User_IdentificationStatus = {}));
function user_IdentificationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "IDENTIFICATION_STATUS_UNSPECIFIED":
            return User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED;
        case 1:
        case "IDENTIFICATION_STATUS_VERIFIED":
            return User_IdentificationStatus.IDENTIFICATION_STATUS_VERIFIED;
        case 2:
        case "IDENTIFICATION_STATUS_NOT_VERIFIED":
            return User_IdentificationStatus.IDENTIFICATION_STATUS_NOT_VERIFIED;
        case 3:
        case "IDENTIFICATION_STATUS_EXPIRED":
            return User_IdentificationStatus.IDENTIFICATION_STATUS_EXPIRED;
        default:
            return User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED;
    }
}
function user_IdentificationStatusToJSON(object) {
    switch (object) {
        case User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED:
            return "IDENTIFICATION_STATUS_UNSPECIFIED";
        case User_IdentificationStatus.IDENTIFICATION_STATUS_VERIFIED:
            return "IDENTIFICATION_STATUS_VERIFIED";
        case User_IdentificationStatus.IDENTIFICATION_STATUS_NOT_VERIFIED:
            return "IDENTIFICATION_STATUS_NOT_VERIFIED";
        case User_IdentificationStatus.IDENTIFICATION_STATUS_EXPIRED:
            return "IDENTIFICATION_STATUS_EXPIRED";
        default:
            return "IDENTIFICATION_STATUS_UNSPECIFIED";
    }
}
function user_IdentificationStatusToNumber(object) {
    switch (object) {
        case User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED:
            return 0;
        case User_IdentificationStatus.IDENTIFICATION_STATUS_VERIFIED:
            return 1;
        case User_IdentificationStatus.IDENTIFICATION_STATUS_NOT_VERIFIED:
            return 2;
        case User_IdentificationStatus.IDENTIFICATION_STATUS_EXPIRED:
            return 3;
        default:
            return 0;
    }
}
var SystemMessage_Type;
(function (SystemMessage_Type) {
    SystemMessage_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    SystemMessage_Type["TIP"] = "TIP";
    SystemMessage_Type["ALERT"] = "ALERT";
    SystemMessage_Type["WARNING"] = "WARNING";
})(SystemMessage_Type || (exports.SystemMessage_Type = SystemMessage_Type = {}));
function systemMessage_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return SystemMessage_Type.TYPE_UNSPECIFIED;
        case 1:
        case "TIP":
            return SystemMessage_Type.TIP;
        case 2:
        case "ALERT":
            return SystemMessage_Type.ALERT;
        case 3:
        case "WARNING":
            return SystemMessage_Type.WARNING;
        default:
            return SystemMessage_Type.TYPE_UNSPECIFIED;
    }
}
function systemMessage_TypeToJSON(object) {
    switch (object) {
        case SystemMessage_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case SystemMessage_Type.TIP:
            return "TIP";
        case SystemMessage_Type.ALERT:
            return "ALERT";
        case SystemMessage_Type.WARNING:
            return "WARNING";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function systemMessage_TypeToNumber(object) {
    switch (object) {
        case SystemMessage_Type.TYPE_UNSPECIFIED:
            return 0;
        case SystemMessage_Type.TIP:
            return 1;
        case SystemMessage_Type.ALERT:
            return 2;
        case SystemMessage_Type.WARNING:
            return 3;
        default:
            return 0;
    }
}
var Button_Type;
(function (Button_Type) {
    Button_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    Button_Type["SECONDARY"] = "SECONDARY";
    /**
     * PRIMARY - 구버전 클라이언트에서 여러 버튼을 지원하지 않을 때 대표 버튼으로 선발하기 위한 용도
     * Secondary 타입과 색이 주황색으로 다른 점 외에는 기능 상 다르지 않음.
     */
    Button_Type["PRIMARY"] = "PRIMARY";
})(Button_Type || (exports.Button_Type = Button_Type = {}));
function button_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return Button_Type.TYPE_UNSPECIFIED;
        case 1:
        case "SECONDARY":
            return Button_Type.SECONDARY;
        case 2:
        case "PRIMARY":
            return Button_Type.PRIMARY;
        default:
            return Button_Type.TYPE_UNSPECIFIED;
    }
}
function button_TypeToJSON(object) {
    switch (object) {
        case Button_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case Button_Type.SECONDARY:
            return "SECONDARY";
        case Button_Type.PRIMARY:
            return "PRIMARY";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function button_TypeToNumber(object) {
    switch (object) {
        case Button_Type.TYPE_UNSPECIFIED:
            return 0;
        case Button_Type.SECONDARY:
            return 1;
        case Button_Type.PRIMARY:
            return 2;
        default:
            return 0;
    }
}
var ButtonPostbackPayload_Type;
(function (ButtonPostbackPayload_Type) {
    ButtonPostbackPayload_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    ButtonPostbackPayload_Type["PROMISE"] = "PROMISE";
    ButtonPostbackPayload_Type["WEB_LOGOUT"] = "WEB_LOGOUT";
    ButtonPostbackPayload_Type["WEBHOOK"] = "WEBHOOK";
})(ButtonPostbackPayload_Type || (exports.ButtonPostbackPayload_Type = ButtonPostbackPayload_Type = {}));
function buttonPostbackPayload_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return ButtonPostbackPayload_Type.TYPE_UNSPECIFIED;
        case 1:
        case "PROMISE":
            return ButtonPostbackPayload_Type.PROMISE;
        case 2:
        case "WEB_LOGOUT":
            return ButtonPostbackPayload_Type.WEB_LOGOUT;
        case 3:
        case "WEBHOOK":
            return ButtonPostbackPayload_Type.WEBHOOK;
        default:
            return ButtonPostbackPayload_Type.TYPE_UNSPECIFIED;
    }
}
function buttonPostbackPayload_TypeToJSON(object) {
    switch (object) {
        case ButtonPostbackPayload_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case ButtonPostbackPayload_Type.PROMISE:
            return "PROMISE";
        case ButtonPostbackPayload_Type.WEB_LOGOUT:
            return "WEB_LOGOUT";
        case ButtonPostbackPayload_Type.WEBHOOK:
            return "WEBHOOK";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function buttonPostbackPayload_TypeToNumber(object) {
    switch (object) {
        case ButtonPostbackPayload_Type.TYPE_UNSPECIFIED:
            return 0;
        case ButtonPostbackPayload_Type.PROMISE:
            return 1;
        case ButtonPostbackPayload_Type.WEB_LOGOUT:
            return 2;
        case ButtonPostbackPayload_Type.WEBHOOK:
            return 3;
        default:
            return 0;
    }
}
var ButtonPostbackPayload_Webhook_HttpMethod;
(function (ButtonPostbackPayload_Webhook_HttpMethod) {
    ButtonPostbackPayload_Webhook_HttpMethod["UNSPECIFIED"] = "UNSPECIFIED";
    ButtonPostbackPayload_Webhook_HttpMethod["GET"] = "GET";
    ButtonPostbackPayload_Webhook_HttpMethod["POST"] = "POST";
})(ButtonPostbackPayload_Webhook_HttpMethod || (exports.ButtonPostbackPayload_Webhook_HttpMethod = ButtonPostbackPayload_Webhook_HttpMethod = {}));
function buttonPostbackPayload_Webhook_HttpMethodFromJSON(object) {
    switch (object) {
        case 0:
        case "UNSPECIFIED":
            return ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED;
        case 1:
        case "GET":
            return ButtonPostbackPayload_Webhook_HttpMethod.GET;
        case 2:
        case "POST":
            return ButtonPostbackPayload_Webhook_HttpMethod.POST;
        default:
            return ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED;
    }
}
function buttonPostbackPayload_Webhook_HttpMethodToJSON(object) {
    switch (object) {
        case ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED:
            return "UNSPECIFIED";
        case ButtonPostbackPayload_Webhook_HttpMethod.GET:
            return "GET";
        case ButtonPostbackPayload_Webhook_HttpMethod.POST:
            return "POST";
        default:
            return "UNSPECIFIED";
    }
}
function buttonPostbackPayload_Webhook_HttpMethodToNumber(object) {
    switch (object) {
        case ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED:
            return 0;
        case ButtonPostbackPayload_Webhook_HttpMethod.GET:
            return 1;
        case ButtonPostbackPayload_Webhook_HttpMethod.POST:
            return 2;
        default:
            return 0;
    }
}
var BizAccount_Type;
(function (BizAccount_Type) {
    BizAccount_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    BizAccount_Type["DEFAULT"] = "DEFAULT";
    BizAccount_Type["INDIVIDUAL"] = "INDIVIDUAL";
    BizAccount_Type["WIDGET"] = "WIDGET";
    BizAccount_Type["MANDATORY"] = "MANDATORY";
    BizAccount_Type["OFFICIAL"] = "OFFICIAL";
    BizAccount_Type["BRAND"] = "BRAND";
})(BizAccount_Type || (exports.BizAccount_Type = BizAccount_Type = {}));
function bizAccount_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return BizAccount_Type.TYPE_UNSPECIFIED;
        case 1:
        case "DEFAULT":
            return BizAccount_Type.DEFAULT;
        case 2:
        case "INDIVIDUAL":
            return BizAccount_Type.INDIVIDUAL;
        case 3:
        case "WIDGET":
            return BizAccount_Type.WIDGET;
        case 4:
        case "MANDATORY":
            return BizAccount_Type.MANDATORY;
        case 5:
        case "OFFICIAL":
            return BizAccount_Type.OFFICIAL;
        case 6:
        case "BRAND":
            return BizAccount_Type.BRAND;
        default:
            return BizAccount_Type.TYPE_UNSPECIFIED;
    }
}
function bizAccount_TypeToJSON(object) {
    switch (object) {
        case BizAccount_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case BizAccount_Type.DEFAULT:
            return "DEFAULT";
        case BizAccount_Type.INDIVIDUAL:
            return "INDIVIDUAL";
        case BizAccount_Type.WIDGET:
            return "WIDGET";
        case BizAccount_Type.MANDATORY:
            return "MANDATORY";
        case BizAccount_Type.OFFICIAL:
            return "OFFICIAL";
        case BizAccount_Type.BRAND:
            return "BRAND";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function bizAccount_TypeToNumber(object) {
    switch (object) {
        case BizAccount_Type.TYPE_UNSPECIFIED:
            return 0;
        case BizAccount_Type.DEFAULT:
            return 1;
        case BizAccount_Type.INDIVIDUAL:
            return 2;
        case BizAccount_Type.WIDGET:
            return 3;
        case BizAccount_Type.MANDATORY:
            return 4;
        case BizAccount_Type.OFFICIAL:
            return 5;
        case BizAccount_Type.BRAND:
            return 6;
        default:
            return 0;
    }
}
var ChannelListHeader_BasicBanner_Color;
(function (ChannelListHeader_BasicBanner_Color) {
    ChannelListHeader_BasicBanner_Color["COLOR_UNSPECIFIED"] = "COLOR_UNSPECIFIED";
    ChannelListHeader_BasicBanner_Color["COLOR_GRAY"] = "COLOR_GRAY";
    ChannelListHeader_BasicBanner_Color["COLOR_YELLOW"] = "COLOR_YELLOW";
    ChannelListHeader_BasicBanner_Color["COLOR_GREEN"] = "COLOR_GREEN";
    ChannelListHeader_BasicBanner_Color["COLOR_CARROT"] = "COLOR_CARROT";
    ChannelListHeader_BasicBanner_Color["COLOR_BLUE"] = "COLOR_BLUE";
})(ChannelListHeader_BasicBanner_Color || (exports.ChannelListHeader_BasicBanner_Color = ChannelListHeader_BasicBanner_Color = {}));
function channelListHeader_BasicBanner_ColorFromJSON(object) {
    switch (object) {
        case 0:
        case "COLOR_UNSPECIFIED":
            return ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED;
        case 0:
        case "COLOR_GRAY":
            return ChannelListHeader_BasicBanner_Color.COLOR_GRAY;
        case 1:
        case "COLOR_YELLOW":
            return ChannelListHeader_BasicBanner_Color.COLOR_YELLOW;
        case 2:
        case "COLOR_GREEN":
            return ChannelListHeader_BasicBanner_Color.COLOR_GREEN;
        case 3:
        case "COLOR_CARROT":
            return ChannelListHeader_BasicBanner_Color.COLOR_CARROT;
        case 4:
        case "COLOR_BLUE":
            return ChannelListHeader_BasicBanner_Color.COLOR_BLUE;
        default:
            return ChannelListHeader_BasicBanner_Color.COLOR_GRAY;
    }
}
function channelListHeader_BasicBanner_ColorToJSON(object) {
    switch (object) {
        case ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED:
            return "COLOR_UNSPECIFIED";
        case ChannelListHeader_BasicBanner_Color.COLOR_GRAY:
            return "COLOR_GRAY";
        case ChannelListHeader_BasicBanner_Color.COLOR_YELLOW:
            return "COLOR_YELLOW";
        case ChannelListHeader_BasicBanner_Color.COLOR_GREEN:
            return "COLOR_GREEN";
        case ChannelListHeader_BasicBanner_Color.COLOR_CARROT:
            return "COLOR_CARROT";
        case ChannelListHeader_BasicBanner_Color.COLOR_BLUE:
            return "COLOR_BLUE";
        default:
            return "COLOR_GRAY";
    }
}
function channelListHeader_BasicBanner_ColorToNumber(object) {
    switch (object) {
        case ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED:
            return 0;
        case ChannelListHeader_BasicBanner_Color.COLOR_GRAY:
            return 0;
        case ChannelListHeader_BasicBanner_Color.COLOR_YELLOW:
            return 1;
        case ChannelListHeader_BasicBanner_Color.COLOR_GREEN:
            return 2;
        case ChannelListHeader_BasicBanner_Color.COLOR_CARROT:
            return 3;
        case ChannelListHeader_BasicBanner_Color.COLOR_BLUE:
            return 4;
        default:
            return 0;
    }
}
var ChannelListHeader_BasicBanner_Button_Type;
(function (ChannelListHeader_BasicBanner_Button_Type) {
    ChannelListHeader_BasicBanner_Button_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    ChannelListHeader_BasicBanner_Button_Type["TYPE_TEXT"] = "TYPE_TEXT";
    ChannelListHeader_BasicBanner_Button_Type["TYPE_BASIC"] = "TYPE_BASIC";
})(ChannelListHeader_BasicBanner_Button_Type || (exports.ChannelListHeader_BasicBanner_Button_Type = ChannelListHeader_BasicBanner_Button_Type = {}));
function channelListHeader_BasicBanner_Button_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED;
        case 0:
        case "TYPE_TEXT":
            return ChannelListHeader_BasicBanner_Button_Type.TYPE_TEXT;
        case 1:
        case "TYPE_BASIC":
            return ChannelListHeader_BasicBanner_Button_Type.TYPE_BASIC;
        default:
            return ChannelListHeader_BasicBanner_Button_Type.TYPE_TEXT;
    }
}
function channelListHeader_BasicBanner_Button_TypeToJSON(object) {
    switch (object) {
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_TEXT:
            return "TYPE_TEXT";
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_BASIC:
            return "TYPE_BASIC";
        default:
            return "TYPE_TEXT";
    }
}
function channelListHeader_BasicBanner_Button_TypeToNumber(object) {
    switch (object) {
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED:
            return 0;
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_TEXT:
            return 0;
        case ChannelListHeader_BasicBanner_Button_Type.TYPE_BASIC:
            return 1;
        default:
            return 0;
    }
}
var UserID_Type;
(function (UserID_Type) {
    UserID_Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /** NORMAL - 일반 */
    UserID_Type["NORMAL"] = "NORMAL";
    /** BIZ_ACCOUNT - 비즈니스 */
    UserID_Type["BIZ_ACCOUNT"] = "BIZ_ACCOUNT";
    /** BIZ_USER - 비즈유저 */
    UserID_Type["BIZ_USER"] = "BIZ_USER";
})(UserID_Type || (exports.UserID_Type = UserID_Type = {}));
function userID_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "TYPE_UNSPECIFIED":
            return UserID_Type.TYPE_UNSPECIFIED;
        case 1:
        case "NORMAL":
            return UserID_Type.NORMAL;
        case 2:
        case "BIZ_ACCOUNT":
            return UserID_Type.BIZ_ACCOUNT;
        case 3:
        case "BIZ_USER":
            return UserID_Type.BIZ_USER;
        default:
            return UserID_Type.TYPE_UNSPECIFIED;
    }
}
function userID_TypeToJSON(object) {
    switch (object) {
        case UserID_Type.TYPE_UNSPECIFIED:
            return "TYPE_UNSPECIFIED";
        case UserID_Type.NORMAL:
            return "NORMAL";
        case UserID_Type.BIZ_ACCOUNT:
            return "BIZ_ACCOUNT";
        case UserID_Type.BIZ_USER:
            return "BIZ_USER";
        default:
            return "TYPE_UNSPECIFIED";
    }
}
function userID_TypeToNumber(object) {
    switch (object) {
        case UserID_Type.TYPE_UNSPECIFIED:
            return 0;
        case UserID_Type.NORMAL:
            return 1;
        case UserID_Type.BIZ_ACCOUNT:
            return 2;
        case UserID_Type.BIZ_USER:
            return 3;
        default:
            return 0;
    }
}
function createBaseMessage() {
    return {
        id: "0",
        type: "",
        channel_id: "",
        sender_id: "0",
        content: "",
        create_time: undefined,
        seen: {},
        data: "",
        receiver_id: "0",
        link: undefined,
        promise: undefined,
        system_message: undefined,
        template_type: TemplateType.TEMPLATE_TYPE_UNSPECIFIED,
        visible: Visible.VISIBLE_UNSPECIFIED,
        sender: undefined,
        receiver: undefined,
        images: [],
        delete_time: undefined,
        message_context: undefined,
        reactions: [],
        is_saved: false,
        mentioned_nickname_map: {},
        article_template: undefined,
        generic_template: undefined,
        location_template: undefined,
        icon_template: undefined,
        inline_template: undefined,
        block_template: undefined,
        video_template: undefined,
        sticker_template: undefined,
    };
}
exports.Message = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        if (message.channel_id !== "") {
            writer.uint32(26).string(message.channel_id);
        }
        if (message.sender_id !== "0") {
            writer.uint32(32).int64(message.sender_id);
        }
        if (message.content !== "") {
            writer.uint32(42).string(message.content);
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(50).fork()).ldelim();
        }
        Object.entries(message.seen).forEach(([key, value]) => {
            exports.Message_SeenEntry.encode({ key: key, value }, writer.uint32(58).fork()).ldelim();
        });
        if (message.data !== "") {
            writer.uint32(66).string(message.data);
        }
        if (message.receiver_id !== "0") {
            writer.uint32(72).int64(message.receiver_id);
        }
        if (message.link !== undefined) {
            exports.Link.encode(message.link, writer.uint32(98).fork()).ldelim();
        }
        if (message.promise !== undefined) {
            exports.Promise.encode(message.promise, writer.uint32(106).fork()).ldelim();
        }
        if (message.system_message !== undefined) {
            exports.SystemMessage.encode(message.system_message, writer.uint32(122).fork())
                .ldelim();
        }
        if (message.template_type !== TemplateType.TEMPLATE_TYPE_UNSPECIFIED) {
            writer.uint32(128).int32(templateTypeToNumber(message.template_type));
        }
        if (message.visible !== Visible.VISIBLE_UNSPECIFIED) {
            writer.uint32(136).int32(visibleToNumber(message.visible));
        }
        if (message.sender !== undefined) {
            exports.User.encode(message.sender, writer.uint32(146).fork()).ldelim();
        }
        if (message.receiver !== undefined) {
            exports.User.encode(message.receiver, writer.uint32(154).fork()).ldelim();
        }
        for (const v of message.images) {
            exports.Image.encode(v, writer.uint32(162).fork()).ldelim();
        }
        if (message.delete_time !== undefined) {
            timestamp_1.Timestamp.encode(message.delete_time, writer.uint32(170).fork()).ldelim();
        }
        if (message.message_context !== undefined) {
            exports.MessageContext.encode(message.message_context, writer.uint32(178).fork())
                .ldelim();
        }
        for (const v of message.reactions) {
            exports.ReactionSummary.encode(v, writer.uint32(186).fork()).ldelim();
        }
        if (message.is_saved !== false) {
            writer.uint32(192).bool(message.is_saved);
        }
        Object.entries(message.mentioned_nickname_map).forEach(([key, value]) => {
            exports.Message_MentionedNicknameMapEntry.encode({ key: key, value }, writer.uint32(202).fork()).ldelim();
        });
        if (message.article_template !== undefined) {
            exports.ArticleTemplate.encode(message.article_template, writer.uint32(402).fork()).ldelim();
        }
        if (message.generic_template !== undefined) {
            exports.GenericTemplate.encode(message.generic_template, writer.uint32(410).fork()).ldelim();
        }
        if (message.location_template !== undefined) {
            exports.LocationTemplate.encode(message.location_template, writer.uint32(418).fork()).ldelim();
        }
        if (message.icon_template !== undefined) {
            exports.IconTemplate.encode(message.icon_template, writer.uint32(426).fork())
                .ldelim();
        }
        if (message.inline_template !== undefined) {
            exports.InlineTemplate.encode(message.inline_template, writer.uint32(434).fork())
                .ldelim();
        }
        if (message.block_template !== undefined) {
            exports.BlockTemplate.encode(message.block_template, writer.uint32(442).fork())
                .ldelim();
        }
        if (message.video_template !== undefined) {
            exports.VideoTemplate.encode(message.video_template, writer.uint32(450).fork())
                .ldelim();
        }
        if (message.sticker_template !== undefined) {
            exports.StickerTemplate.encode(message.sticker_template, writer.uint32(458).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.sender_id = longToString(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    const entry7 = exports.Message_SeenEntry.decode(reader, reader.uint32());
                    if (entry7.value !== undefined) {
                        message.seen[entry7.key] = entry7.value;
                    }
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.data = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.receiver_id = longToString(reader.int64());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.link = exports.Link.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.promise = exports.Promise.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.system_message = exports.SystemMessage.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.template_type = templateTypeFromJSON(reader.int32());
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.visible = visibleFromJSON(reader.int32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.sender = exports.User.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.receiver = exports.User.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.images.push(exports.Image.decode(reader, reader.uint32()));
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.delete_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.message_context = exports.MessageContext.decode(reader, reader.uint32());
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.reactions.push(exports.ReactionSummary.decode(reader, reader.uint32()));
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.is_saved = reader.bool();
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    const entry25 = exports.Message_MentionedNicknameMapEntry.decode(reader, reader.uint32());
                    if (entry25.value !== undefined) {
                        message.mentioned_nickname_map[entry25.key] = entry25.value;
                    }
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.article_template = exports.ArticleTemplate.decode(reader, reader.uint32());
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.generic_template = exports.GenericTemplate.decode(reader, reader.uint32());
                    continue;
                case 52:
                    if (tag !== 418) {
                        break;
                    }
                    message.location_template = exports.LocationTemplate.decode(reader, reader.uint32());
                    continue;
                case 53:
                    if (tag !== 426) {
                        break;
                    }
                    message.icon_template = exports.IconTemplate.decode(reader, reader.uint32());
                    continue;
                case 54:
                    if (tag !== 434) {
                        break;
                    }
                    message.inline_template = exports.InlineTemplate.decode(reader, reader.uint32());
                    continue;
                case 55:
                    if (tag !== 442) {
                        break;
                    }
                    message.block_template = exports.BlockTemplate.decode(reader, reader.uint32());
                    continue;
                case 56:
                    if (tag !== 450) {
                        break;
                    }
                    message.video_template = exports.VideoTemplate.decode(reader, reader.uint32());
                    continue;
                case 57:
                    if (tag !== 458) {
                        break;
                    }
                    message.sticker_template = exports.StickerTemplate.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            sender_id: isSet(object.sender_id)
                ? globalThis.String(object.sender_id)
                : "0",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            seen: isObject(object.seen)
                ? Object.entries(object.seen).reduce((acc, [key, value]) => {
                    acc[key] = fromJsonTimestamp(value);
                    return acc;
                }, {})
                : {},
            data: isSet(object.data) ? globalThis.String(object.data) : "",
            receiver_id: isSet(object.receiver_id)
                ? globalThis.String(object.receiver_id)
                : "0",
            link: isSet(object.link) ? exports.Link.fromJSON(object.link) : undefined,
            promise: isSet(object.promise)
                ? exports.Promise.fromJSON(object.promise)
                : undefined,
            system_message: isSet(object.system_message)
                ? exports.SystemMessage.fromJSON(object.system_message)
                : undefined,
            template_type: isSet(object.template_type)
                ? templateTypeFromJSON(object.template_type)
                : TemplateType.TEMPLATE_TYPE_UNSPECIFIED,
            visible: isSet(object.visible)
                ? visibleFromJSON(object.visible)
                : Visible.VISIBLE_UNSPECIFIED,
            sender: isSet(object.sender) ? exports.User.fromJSON(object.sender) : undefined,
            receiver: isSet(object.receiver)
                ? exports.User.fromJSON(object.receiver)
                : undefined,
            images: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.images)
                ? object.images.map((e) => exports.Image.fromJSON(e))
                : [],
            delete_time: isSet(object.delete_time)
                ? fromJsonTimestamp(object.delete_time)
                : undefined,
            message_context: isSet(object.message_context)
                ? exports.MessageContext.fromJSON(object.message_context)
                : undefined,
            reactions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.reactions)
                ? object.reactions.map((e) => exports.ReactionSummary.fromJSON(e))
                : [],
            is_saved: isSet(object.is_saved)
                ? globalThis.Boolean(object.is_saved)
                : false,
            mentioned_nickname_map: isObject(object.mentioned_nickname_map)
                ? Object.entries(object.mentioned_nickname_map).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            article_template: isSet(object.article_template)
                ? exports.ArticleTemplate.fromJSON(object.article_template)
                : undefined,
            generic_template: isSet(object.generic_template)
                ? exports.GenericTemplate.fromJSON(object.generic_template)
                : undefined,
            location_template: isSet(object.location_template)
                ? exports.LocationTemplate.fromJSON(object.location_template)
                : undefined,
            icon_template: isSet(object.icon_template)
                ? exports.IconTemplate.fromJSON(object.icon_template)
                : undefined,
            inline_template: isSet(object.inline_template)
                ? exports.InlineTemplate.fromJSON(object.inline_template)
                : undefined,
            block_template: isSet(object.block_template)
                ? exports.BlockTemplate.fromJSON(object.block_template)
                : undefined,
            video_template: isSet(object.video_template)
                ? exports.VideoTemplate.fromJSON(object.video_template)
                : undefined,
            sticker_template: isSet(object.sticker_template)
                ? exports.StickerTemplate.fromJSON(object.sticker_template)
                : undefined,
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.sender_id !== "0") {
            obj.sender_id = message.sender_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.seen) {
            const entries = Object.entries(message.seen);
            if (entries.length > 0) {
                obj.seen = {};
                entries.forEach(([k, v]) => {
                    obj.seen[k] = fromTimestamp(v).toISOString();
                });
            }
        }
        if (message.data !== "") {
            obj.data = message.data;
        }
        if (message.receiver_id !== "0") {
            obj.receiver_id = message.receiver_id;
        }
        if (message.link !== undefined) {
            obj.link = exports.Link.toJSON(message.link);
        }
        if (message.promise !== undefined) {
            obj.promise = exports.Promise.toJSON(message.promise);
        }
        if (message.system_message !== undefined) {
            obj.system_message = exports.SystemMessage.toJSON(message.system_message);
        }
        if (message.template_type !== TemplateType.TEMPLATE_TYPE_UNSPECIFIED) {
            obj.template_type = templateTypeToJSON(message.template_type);
        }
        if (message.visible !== Visible.VISIBLE_UNSPECIFIED) {
            obj.visible = visibleToJSON(message.visible);
        }
        if (message.sender !== undefined) {
            obj.sender = exports.User.toJSON(message.sender);
        }
        if (message.receiver !== undefined) {
            obj.receiver = exports.User.toJSON(message.receiver);
        }
        if ((_a = message.images) === null || _a === void 0 ? void 0 : _a.length) {
            obj.images = message.images.map((e) => exports.Image.toJSON(e));
        }
        if (message.delete_time !== undefined) {
            obj.delete_time = fromTimestamp(message.delete_time).toISOString();
        }
        if (message.message_context !== undefined) {
            obj.message_context = exports.MessageContext.toJSON(message.message_context);
        }
        if ((_b = message.reactions) === null || _b === void 0 ? void 0 : _b.length) {
            obj.reactions = message.reactions.map((e) => exports.ReactionSummary.toJSON(e));
        }
        if (message.is_saved !== false) {
            obj.is_saved = message.is_saved;
        }
        if (message.mentioned_nickname_map) {
            const entries = Object.entries(message.mentioned_nickname_map);
            if (entries.length > 0) {
                obj.mentioned_nickname_map = {};
                entries.forEach(([k, v]) => {
                    obj.mentioned_nickname_map[k] = v;
                });
            }
        }
        if (message.article_template !== undefined) {
            obj.article_template = exports.ArticleTemplate.toJSON(message.article_template);
        }
        if (message.generic_template !== undefined) {
            obj.generic_template = exports.GenericTemplate.toJSON(message.generic_template);
        }
        if (message.location_template !== undefined) {
            obj.location_template = exports.LocationTemplate.toJSON(message.location_template);
        }
        if (message.icon_template !== undefined) {
            obj.icon_template = exports.IconTemplate.toJSON(message.icon_template);
        }
        if (message.inline_template !== undefined) {
            obj.inline_template = exports.InlineTemplate.toJSON(message.inline_template);
        }
        if (message.block_template !== undefined) {
            obj.block_template = exports.BlockTemplate.toJSON(message.block_template);
        }
        if (message.video_template !== undefined) {
            obj.video_template = exports.VideoTemplate.toJSON(message.video_template);
        }
        if (message.sticker_template !== undefined) {
            obj.sticker_template = exports.StickerTemplate.toJSON(message.sticker_template);
        }
        return obj;
    },
    create(base) {
        return exports.Message.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const message = createBaseMessage();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        message.channel_id = (_c = object.channel_id) !== null && _c !== void 0 ? _c : "";
        message.sender_id = (_d = object.sender_id) !== null && _d !== void 0 ? _d : "0";
        message.content = (_e = object.content) !== null && _e !== void 0 ? _e : "";
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.seen = Object.entries((_f = object.seen) !== null && _f !== void 0 ? _f : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = timestamp_1.Timestamp.fromPartial(value);
            }
            return acc;
        }, {});
        message.data = (_g = object.data) !== null && _g !== void 0 ? _g : "";
        message.receiver_id = (_h = object.receiver_id) !== null && _h !== void 0 ? _h : "0";
        message.link = (object.link !== undefined && object.link !== null)
            ? exports.Link.fromPartial(object.link)
            : undefined;
        message.promise = (object.promise !== undefined && object.promise !== null)
            ? exports.Promise.fromPartial(object.promise)
            : undefined;
        message.system_message =
            (object.system_message !== undefined && object.system_message !== null)
                ? exports.SystemMessage.fromPartial(object.system_message)
                : undefined;
        message.template_type = (_j = object.template_type) !== null && _j !== void 0 ? _j : TemplateType.TEMPLATE_TYPE_UNSPECIFIED;
        message.visible = (_k = object.visible) !== null && _k !== void 0 ? _k : Visible.VISIBLE_UNSPECIFIED;
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? exports.User.fromPartial(object.sender)
            : undefined;
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? exports.User.fromPartial(object.receiver)
                : undefined;
        message.images = ((_l = object.images) === null || _l === void 0 ? void 0 : _l.map((e) => exports.Image.fromPartial(e))) || [];
        message.delete_time =
            (object.delete_time !== undefined && object.delete_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.delete_time)
                : undefined;
        message.message_context =
            (object.message_context !== undefined && object.message_context !== null)
                ? exports.MessageContext.fromPartial(object.message_context)
                : undefined;
        message.reactions =
            ((_m = object.reactions) === null || _m === void 0 ? void 0 : _m.map((e) => exports.ReactionSummary.fromPartial(e))) || [];
        message.is_saved = (_o = object.is_saved) !== null && _o !== void 0 ? _o : false;
        message.mentioned_nickname_map = Object.entries((_p = object.mentioned_nickname_map) !== null && _p !== void 0 ? _p : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.article_template = (object.article_template !== undefined &&
            object.article_template !== null)
            ? exports.ArticleTemplate.fromPartial(object.article_template)
            : undefined;
        message.generic_template = (object.generic_template !== undefined &&
            object.generic_template !== null)
            ? exports.GenericTemplate.fromPartial(object.generic_template)
            : undefined;
        message.location_template = (object.location_template !== undefined &&
            object.location_template !== null)
            ? exports.LocationTemplate.fromPartial(object.location_template)
            : undefined;
        message.icon_template =
            (object.icon_template !== undefined && object.icon_template !== null)
                ? exports.IconTemplate.fromPartial(object.icon_template)
                : undefined;
        message.inline_template =
            (object.inline_template !== undefined && object.inline_template !== null)
                ? exports.InlineTemplate.fromPartial(object.inline_template)
                : undefined;
        message.block_template =
            (object.block_template !== undefined && object.block_template !== null)
                ? exports.BlockTemplate.fromPartial(object.block_template)
                : undefined;
        message.video_template =
            (object.video_template !== undefined && object.video_template !== null)
                ? exports.VideoTemplate.fromPartial(object.video_template)
                : undefined;
        message.sticker_template = (object.sticker_template !== undefined &&
            object.sticker_template !== null)
            ? exports.StickerTemplate.fromPartial(object.sticker_template)
            : undefined;
        return message;
    },
};
function createBaseMessage_SeenEntry() {
    return { key: "0", value: undefined };
}
exports.Message_SeenEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "0") {
            writer.uint32(8).int64(message.key);
        }
        if (message.value !== undefined) {
            timestamp_1.Timestamp.encode(message.value, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessage_SeenEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.key = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "0",
            value: isSet(object.value) ? fromJsonTimestamp(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "0") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = fromTimestamp(message.value).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.Message_SeenEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMessage_SeenEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "0";
        message.value = (object.value !== undefined && object.value !== null)
            ? timestamp_1.Timestamp.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseMessage_MentionedNicknameMapEntry() {
    return { key: "0", value: "" };
}
exports.Message_MentionedNicknameMapEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "0") {
            writer.uint32(8).int64(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessage_MentionedNicknameMapEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.key = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "0",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "0") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.Message_MentionedNicknameMapEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMessage_MentionedNicknameMapEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "0";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMessageContext() {
    return {
        message_id: "0",
        sender: undefined,
        content: "",
        image_url: undefined,
    };
}
exports.MessageContext = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message_id !== "0") {
            writer.uint32(8).int64(message.message_id);
        }
        if (message.sender !== undefined) {
            exports.User.encode(message.sender, writer.uint32(18).fork()).ldelim();
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.image_url !== undefined) {
            writer.uint32(34).string(message.image_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMessageContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.sender = exports.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            sender: isSet(object.sender) ? exports.User.fromJSON(object.sender) : undefined,
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.sender !== undefined) {
            obj.sender = exports.User.toJSON(message.sender);
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.image_url !== undefined) {
            obj.image_url = message.image_url;
        }
        return obj;
    },
    create(base) {
        return exports.MessageContext.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMessageContext();
        message.message_id = (_a = object.message_id) !== null && _a !== void 0 ? _a : "0";
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? exports.User.fromPartial(object.sender)
            : undefined;
        message.content = (_b = object.content) !== null && _b !== void 0 ? _b : "";
        message.image_url = (_c = object.image_url) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseLink() {
    return {
        kind: "",
        target_uri: "",
        image_url: "",
        button_text: "",
        article_id: "0",
        price: 0,
        has_price: false,
    };
}
exports.Link = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.kind !== "") {
            writer.uint32(10).string(message.kind);
        }
        if (message.target_uri !== "") {
            writer.uint32(18).string(message.target_uri);
        }
        if (message.image_url !== "") {
            writer.uint32(26).string(message.image_url);
        }
        if (message.button_text !== "") {
            writer.uint32(34).string(message.button_text);
        }
        if (message.article_id !== "0") {
            writer.uint32(40).int64(message.article_id);
        }
        if (message.price !== 0) {
            writer.uint32(49).double(message.price);
        }
        if (message.has_price !== false) {
            writer.uint32(56).bool(message.has_price);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.kind = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.button_text = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.article_id = longToString(reader.int64());
                    continue;
                case 6:
                    if (tag !== 49) {
                        break;
                    }
                    message.price = reader.double();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.has_price = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind) ? globalThis.String(object.kind) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            button_text: isSet(object.button_text)
                ? globalThis.String(object.button_text)
                : "",
            article_id: isSet(object.article_id)
                ? globalThis.String(object.article_id)
                : "0",
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            has_price: isSet(object.has_price)
                ? globalThis.Boolean(object.has_price)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== "") {
            obj.kind = message.kind;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.button_text !== "") {
            obj.button_text = message.button_text;
        }
        if (message.article_id !== "0") {
            obj.article_id = message.article_id;
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.has_price !== false) {
            obj.has_price = message.has_price;
        }
        return obj;
    },
    create(base) {
        return exports.Link.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseLink();
        message.kind = (_a = object.kind) !== null && _a !== void 0 ? _a : "";
        message.target_uri = (_b = object.target_uri) !== null && _b !== void 0 ? _b : "";
        message.image_url = (_c = object.image_url) !== null && _c !== void 0 ? _c : "";
        message.button_text = (_d = object.button_text) !== null && _d !== void 0 ? _d : "";
        message.article_id = (_e = object.article_id) !== null && _e !== void 0 ? _e : "0";
        message.price = (_f = object.price) !== null && _f !== void 0 ? _f : 0;
        message.has_price = (_g = object.has_price) !== null && _g !== void 0 ? _g : false;
        return message;
    },
};
function createBasePromise() {
    return {
        id: "0",
        time: undefined,
        deleted: false,
        type: "",
        notify_before_minutes: 0,
        channel_id: "",
        location: undefined,
    };
}
exports.Promise = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        }
        if (message.deleted !== false) {
            writer.uint32(24).bool(message.deleted);
        }
        if (message.type !== "") {
            writer.uint32(34).string(message.type);
        }
        if (message.notify_before_minutes !== 0) {
            writer.uint32(40).int32(message.notify_before_minutes);
        }
        if (message.channel_id !== "") {
            writer.uint32(50).string(message.channel_id);
        }
        if (message.location !== undefined) {
            exports.Promise_Location.encode(message.location, writer.uint32(58).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePromise();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.deleted = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.notify_before_minutes = reader.int32();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.location = exports.Promise_Location.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            deleted: isSet(object.deleted)
                ? globalThis.Boolean(object.deleted)
                : false,
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            notify_before_minutes: isSet(object.notify_before_minutes)
                ? globalThis.Number(object.notify_before_minutes)
                : 0,
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            location: isSet(object.location)
                ? exports.Promise_Location.fromJSON(object.location)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.time !== undefined) {
            obj.time = fromTimestamp(message.time).toISOString();
        }
        if (message.deleted !== false) {
            obj.deleted = message.deleted;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.notify_before_minutes !== 0) {
            obj.notify_before_minutes = Math.round(message.notify_before_minutes);
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.location !== undefined) {
            obj.location = exports.Promise_Location.toJSON(message.location);
        }
        return obj;
    },
    create(base) {
        return exports.Promise.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBasePromise();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.time = (object.time !== undefined && object.time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.time)
            : undefined;
        message.deleted = (_b = object.deleted) !== null && _b !== void 0 ? _b : false;
        message.type = (_c = object.type) !== null && _c !== void 0 ? _c : "";
        message.notify_before_minutes = (_d = object.notify_before_minutes) !== null && _d !== void 0 ? _d : 0;
        message.channel_id = (_e = object.channel_id) !== null && _e !== void 0 ? _e : "";
        message.location =
            (object.location !== undefined && object.location !== null)
                ? exports.Promise_Location.fromPartial(object.location)
                : undefined;
        return message;
    },
};
function createBasePromise_Location() {
    return { name: "", latitude: 0, longitude: 0 };
}
exports.Promise_Location = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.latitude !== 0) {
            writer.uint32(17).double(message.latitude);
        }
        if (message.longitude !== 0) {
            writer.uint32(25).double(message.longitude);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePromise_Location();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.latitude = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.longitude = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
            longitude: isSet(object.longitude)
                ? globalThis.Number(object.longitude)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.latitude !== 0) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== 0) {
            obj.longitude = message.longitude;
        }
        return obj;
    },
    create(base) {
        return exports.Promise_Location.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBasePromise_Location();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.latitude = (_b = object.latitude) !== null && _b !== void 0 ? _b : 0;
        message.longitude = (_c = object.longitude) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseImage() {
    return { id: "", url: "", width: 0, height: 0 };
}
exports.Image = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.url !== "") {
            writer.uint32(18).string(message.url);
        }
        if (message.width !== 0) {
            writer.uint32(24).int32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(32).int32(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        return obj;
    },
    create(base) {
        return exports.Image.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseImage();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.url = (_b = object.url) !== null && _b !== void 0 ? _b : "";
        message.width = (_c = object.width) !== null && _c !== void 0 ? _c : 0;
        message.height = (_d = object.height) !== null && _d !== void 0 ? _d : 0;
        return message;
    },
};
function createBaseVideo() {
    return {
        id: "",
        duration: undefined,
        width: 0,
        height: 0,
        download_url: "",
        size: "0",
        uploaded_file_name: "",
        token: "",
        state: Video_State.STATE_UNSPECIFIED,
    };
}
exports.Video = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.duration !== undefined) {
            duration_1.Duration.encode(message.duration, writer.uint32(18).fork()).ldelim();
        }
        if (message.width !== 0) {
            writer.uint32(24).int32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(32).int32(message.height);
        }
        if (message.download_url !== "") {
            writer.uint32(42).string(message.download_url);
        }
        if (message.size !== "0") {
            writer.uint32(48).int64(message.size);
        }
        if (message.uploaded_file_name !== "") {
            writer.uint32(58).string(message.uploaded_file_name);
        }
        if (message.token !== "") {
            writer.uint32(66).string(message.token);
        }
        if (message.state !== Video_State.STATE_UNSPECIFIED) {
            writer.uint32(72).int32(video_StateToNumber(message.state));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVideo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.duration = duration_1.Duration.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.download_url = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.size = longToString(reader.int64());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.uploaded_file_name = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.state = video_StateFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            duration: isSet(object.duration)
                ? duration_1.Duration.fromJSON(object.duration)
                : undefined,
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
            download_url: isSet(object.download_url)
                ? globalThis.String(object.download_url)
                : "",
            size: isSet(object.size) ? globalThis.String(object.size) : "0",
            uploaded_file_name: isSet(object.uploaded_file_name)
                ? globalThis.String(object.uploaded_file_name)
                : "",
            token: isSet(object.token) ? globalThis.String(object.token) : "",
            state: isSet(object.state)
                ? video_StateFromJSON(object.state)
                : Video_State.STATE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.duration !== undefined) {
            obj.duration = duration_1.Duration.toJSON(message.duration);
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        if (message.download_url !== "") {
            obj.download_url = message.download_url;
        }
        if (message.size !== "0") {
            obj.size = message.size;
        }
        if (message.uploaded_file_name !== "") {
            obj.uploaded_file_name = message.uploaded_file_name;
        }
        if (message.token !== "") {
            obj.token = message.token;
        }
        if (message.state !== Video_State.STATE_UNSPECIFIED) {
            obj.state = video_StateToJSON(message.state);
        }
        return obj;
    },
    create(base) {
        return exports.Video.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseVideo();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.duration =
            (object.duration !== undefined && object.duration !== null)
                ? duration_1.Duration.fromPartial(object.duration)
                : undefined;
        message.width = (_b = object.width) !== null && _b !== void 0 ? _b : 0;
        message.height = (_c = object.height) !== null && _c !== void 0 ? _c : 0;
        message.download_url = (_d = object.download_url) !== null && _d !== void 0 ? _d : "";
        message.size = (_e = object.size) !== null && _e !== void 0 ? _e : "0";
        message.uploaded_file_name = (_f = object.uploaded_file_name) !== null && _f !== void 0 ? _f : "";
        message.token = (_g = object.token) !== null && _g !== void 0 ? _g : "";
        message.state = (_h = object.state) !== null && _h !== void 0 ? _h : Video_State.STATE_UNSPECIFIED;
        return message;
    },
};
function createBaseVideoTemplate() {
    return { video: undefined, thumbnail: undefined };
}
exports.VideoTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.video !== undefined) {
            exports.Video.encode(message.video, writer.uint32(10).fork()).ldelim();
        }
        if (message.thumbnail !== undefined) {
            exports.Image.encode(message.thumbnail, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVideoTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.video = exports.Video.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.thumbnail = exports.Image.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            video: isSet(object.video) ? exports.Video.fromJSON(object.video) : undefined,
            thumbnail: isSet(object.thumbnail)
                ? exports.Image.fromJSON(object.thumbnail)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.video !== undefined) {
            obj.video = exports.Video.toJSON(message.video);
        }
        if (message.thumbnail !== undefined) {
            obj.thumbnail = exports.Image.toJSON(message.thumbnail);
        }
        return obj;
    },
    create(base) {
        return exports.VideoTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseVideoTemplate();
        message.video = (object.video !== undefined && object.video !== null)
            ? exports.Video.fromPartial(object.video)
            : undefined;
        message.thumbnail =
            (object.thumbnail !== undefined && object.thumbnail !== null)
                ? exports.Image.fromPartial(object.thumbnail)
                : undefined;
        return message;
    },
};
function createBaseSticker() {
    return { sticker_id: "", name: "", image_url: "", thumbnail_url: "" };
}
exports.Sticker = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sticker_id !== "") {
            writer.uint32(10).string(message.sticker_id);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.image_url !== "") {
            writer.uint32(26).string(message.image_url);
        }
        if (message.thumbnail_url !== "") {
            writer.uint32(34).string(message.thumbnail_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSticker();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sticker_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.thumbnail_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sticker_id: isSet(object.sticker_id)
                ? globalThis.String(object.sticker_id)
                : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            thumbnail_url: isSet(object.thumbnail_url)
                ? globalThis.String(object.thumbnail_url)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sticker_id !== "") {
            obj.sticker_id = message.sticker_id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.thumbnail_url !== "") {
            obj.thumbnail_url = message.thumbnail_url;
        }
        return obj;
    },
    create(base) {
        return exports.Sticker.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseSticker();
        message.sticker_id = (_a = object.sticker_id) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.image_url = (_c = object.image_url) !== null && _c !== void 0 ? _c : "";
        message.thumbnail_url = (_d = object.thumbnail_url) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseStickerTemplate() {
    return { sticker: undefined };
}
exports.StickerTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sticker !== undefined) {
            exports.Sticker.encode(message.sticker, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickerTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sticker = exports.Sticker.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sticker: isSet(object.sticker)
                ? exports.Sticker.fromJSON(object.sticker)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sticker !== undefined) {
            obj.sticker = exports.Sticker.toJSON(message.sticker);
        }
        return obj;
    },
    create(base) {
        return exports.StickerTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseStickerTemplate();
        message.sticker = (object.sticker !== undefined && object.sticker !== null)
            ? exports.Sticker.fromPartial(object.sticker)
            : undefined;
        return message;
    },
};
function createBaseStickerPackMeta() {
    return {
        pack_id: "",
        image_url: "",
        version: 0,
        name: undefined,
        target_uri: undefined,
    };
}
exports.StickerPackMeta = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pack_id !== "") {
            writer.uint32(10).string(message.pack_id);
        }
        if (message.image_url !== "") {
            writer.uint32(18).string(message.image_url);
        }
        if (message.version !== 0) {
            writer.uint32(24).int32(message.version);
        }
        if (message.name !== undefined) {
            writer.uint32(34).string(message.name);
        }
        if (message.target_uri !== undefined) {
            writer.uint32(42).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickerPackMeta();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pack_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.version = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pack_id: isSet(object.pack_id) ? globalThis.String(object.pack_id) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            version: isSet(object.version) ? globalThis.Number(object.version) : 0,
            name: isSet(object.name) ? globalThis.String(object.name) : undefined,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pack_id !== "") {
            obj.pack_id = message.pack_id;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if (message.target_uri !== undefined) {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.StickerPackMeta.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseStickerPackMeta();
        message.pack_id = (_a = object.pack_id) !== null && _a !== void 0 ? _a : "";
        message.image_url = (_b = object.image_url) !== null && _b !== void 0 ? _b : "";
        message.version = (_c = object.version) !== null && _c !== void 0 ? _c : 0;
        message.name = (_d = object.name) !== null && _d !== void 0 ? _d : undefined;
        message.target_uri = (_e = object.target_uri) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseStickerPack() {
    return { pack_id: "", stickers: [] };
}
exports.StickerPack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pack_id !== "") {
            writer.uint32(10).string(message.pack_id);
        }
        for (const v of message.stickers) {
            exports.Sticker.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickerPack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pack_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.stickers.push(exports.Sticker.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pack_id: isSet(object.pack_id) ? globalThis.String(object.pack_id) : "",
            stickers: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.stickers)
                ? object.stickers.map((e) => exports.Sticker.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.pack_id !== "") {
            obj.pack_id = message.pack_id;
        }
        if ((_a = message.stickers) === null || _a === void 0 ? void 0 : _a.length) {
            obj.stickers = message.stickers.map((e) => exports.Sticker.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.StickerPack.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseStickerPack();
        message.pack_id = (_a = object.pack_id) !== null && _a !== void 0 ? _a : "";
        message.stickers = ((_b = object.stickers) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Sticker.fromPartial(e))) ||
            [];
        return message;
    },
};
function createBaseStickerIcon() {
    return { active_image_url: "", inactive_image_url: "" };
}
exports.StickerIcon = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.active_image_url !== "") {
            writer.uint32(10).string(message.active_image_url);
        }
        if (message.inactive_image_url !== "") {
            writer.uint32(18).string(message.inactive_image_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickerIcon();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.active_image_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.inactive_image_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            active_image_url: isSet(object.active_image_url)
                ? globalThis.String(object.active_image_url)
                : "",
            inactive_image_url: isSet(object.inactive_image_url)
                ? globalThis.String(object.inactive_image_url)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.active_image_url !== "") {
            obj.active_image_url = message.active_image_url;
        }
        if (message.inactive_image_url !== "") {
            obj.inactive_image_url = message.inactive_image_url;
        }
        return obj;
    },
    create(base) {
        return exports.StickerIcon.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseStickerIcon();
        message.active_image_url = (_a = object.active_image_url) !== null && _a !== void 0 ? _a : "";
        message.inactive_image_url = (_b = object.inactive_image_url) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseStickerPromotion() {
    return { text: "", target_uri: "" };
}
exports.StickerPromotion = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.target_uri !== "") {
            writer.uint32(18).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStickerPromotion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.StickerPromotion.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseStickerPromotion();
        message.text = (_a = object.text) !== null && _a !== void 0 ? _a : "";
        message.target_uri = (_b = object.target_uri) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseChannel() {
    return {
        id: "",
        resource_type: "",
        resource_id: "0",
        DEPRECATED: "",
        member_ids: [],
        is_favorite: false,
        is_read_only: false,
        is_disabled: false,
        is_mute: false,
        unread_count: 0,
        last_seen_id: "0",
        last_message_time: undefined,
        create_time: undefined,
        last_message: undefined,
        receiver: undefined,
        article: undefined,
        promise: undefined,
        notice: undefined,
        is_promisable: false,
        is_reviewable: false,
        enabled_feature: undefined,
        me: undefined,
        biz_account: undefined,
        target_uri: "",
        type: Channel_Type.TYPE_UNSPECIFIED,
        members: [],
        owner: undefined,
        title: "",
        thumbnail: "",
        web_view: undefined,
        member_limit: "0",
        closed: false,
        input: undefined,
        bubble_group: undefined,
        introduction: undefined,
        toolbox_buttons: [],
        is_temporary: false,
        favorite_time: undefined,
        unread_mentions_count: 0,
        member_count: 0,
        unread_reply_count: 0,
        common_filter_id: undefined,
        service_filter_id: undefined,
        profile_image_urls: [],
        cover_image_text: undefined,
        cover_image_url: undefined,
        resource_icon_url: undefined,
        last_message_id: "0",
        badge: Badge.BADGE_UNSPECIFIED,
        has_mutual_messages: false,
    };
}
exports.Channel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.resource_type !== "") {
            writer.uint32(18).string(message.resource_type);
        }
        if (message.resource_id !== "0") {
            writer.uint32(24).int64(message.resource_id);
        }
        if (message.DEPRECATED !== "") {
            writer.uint32(34).string(message.DEPRECATED);
        }
        writer.uint32(42).fork();
        for (const v of message.member_ids) {
            writer.int64(v);
        }
        writer.ldelim();
        if (message.is_favorite !== false) {
            writer.uint32(48).bool(message.is_favorite);
        }
        if (message.is_read_only !== false) {
            writer.uint32(56).bool(message.is_read_only);
        }
        if (message.is_disabled !== false) {
            writer.uint32(64).bool(message.is_disabled);
        }
        if (message.is_mute !== false) {
            writer.uint32(72).bool(message.is_mute);
        }
        if (message.unread_count !== 0) {
            writer.uint32(80).int32(message.unread_count);
        }
        if (message.last_seen_id !== "0") {
            writer.uint32(88).int64(message.last_seen_id);
        }
        if (message.last_message_time !== undefined) {
            timestamp_1.Timestamp.encode(message.last_message_time, writer.uint32(98).fork())
                .ldelim();
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(106).fork()).ldelim();
        }
        if (message.last_message !== undefined) {
            exports.Message.encode(message.last_message, writer.uint32(114).fork()).ldelim();
        }
        if (message.receiver !== undefined) {
            exports.User.encode(message.receiver, writer.uint32(130).fork()).ldelim();
        }
        if (message.article !== undefined) {
            exports.Article.encode(message.article, writer.uint32(138).fork()).ldelim();
        }
        if (message.promise !== undefined) {
            exports.Promise.encode(message.promise, writer.uint32(146).fork()).ldelim();
        }
        if (message.notice !== undefined) {
            exports.Notice.encode(message.notice, writer.uint32(154).fork()).ldelim();
        }
        if (message.is_promisable !== false) {
            writer.uint32(160).bool(message.is_promisable);
        }
        if (message.is_reviewable !== false) {
            writer.uint32(168).bool(message.is_reviewable);
        }
        if (message.enabled_feature !== undefined) {
            exports.Channel_EnabledFeature.encode(message.enabled_feature, writer.uint32(178).fork()).ldelim();
        }
        if (message.me !== undefined) {
            exports.User.encode(message.me, writer.uint32(186).fork()).ldelim();
        }
        if (message.biz_account !== undefined) {
            exports.BizAccount.encode(message.biz_account, writer.uint32(202).fork())
                .ldelim();
        }
        if (message.target_uri !== "") {
            writer.uint32(210).string(message.target_uri);
        }
        if (message.type !== Channel_Type.TYPE_UNSPECIFIED) {
            writer.uint32(216).int32(channel_TypeToNumber(message.type));
        }
        for (const v of message.members) {
            exports.User.encode(v, writer.uint32(226).fork()).ldelim();
        }
        if (message.owner !== undefined) {
            exports.User.encode(message.owner, writer.uint32(234).fork()).ldelim();
        }
        if (message.title !== "") {
            writer.uint32(242).string(message.title);
        }
        if (message.thumbnail !== "") {
            writer.uint32(250).string(message.thumbnail);
        }
        if (message.web_view !== undefined) {
            exports.WebView.encode(message.web_view, writer.uint32(258).fork()).ldelim();
        }
        if (message.member_limit !== "0") {
            writer.uint32(264).int64(message.member_limit);
        }
        if (message.closed !== false) {
            writer.uint32(272).bool(message.closed);
        }
        if (message.input !== undefined) {
            exports.Channel_Input.encode(message.input, writer.uint32(282).fork()).ldelim();
        }
        if (message.bubble_group !== undefined) {
            exports.BubbleGroup.encode(message.bubble_group, writer.uint32(290).fork())
                .ldelim();
        }
        if (message.introduction !== undefined) {
            exports.Introduction.encode(message.introduction, writer.uint32(298).fork())
                .ldelim();
        }
        for (const v of message.toolbox_buttons) {
            exports.ToolboxButton.encode(v, writer.uint32(306).fork()).ldelim();
        }
        if (message.is_temporary !== false) {
            writer.uint32(312).bool(message.is_temporary);
        }
        if (message.favorite_time !== undefined) {
            timestamp_1.Timestamp.encode(message.favorite_time, writer.uint32(322).fork())
                .ldelim();
        }
        if (message.unread_mentions_count !== 0) {
            writer.uint32(328).int32(message.unread_mentions_count);
        }
        if (message.member_count !== 0) {
            writer.uint32(336).int32(message.member_count);
        }
        if (message.unread_reply_count !== 0) {
            writer.uint32(344).int32(message.unread_reply_count);
        }
        if (message.common_filter_id !== undefined) {
            writer.uint32(352).int32(filterIDToNumber(message.common_filter_id));
        }
        if (message.service_filter_id !== undefined) {
            writer.uint32(360).int32(filterIDToNumber(message.service_filter_id));
        }
        for (const v of message.profile_image_urls) {
            writer.uint32(386).string(v);
        }
        if (message.cover_image_text !== undefined) {
            writer.uint32(394).string(message.cover_image_text);
        }
        if (message.cover_image_url !== undefined) {
            writer.uint32(402).string(message.cover_image_url);
        }
        if (message.resource_icon_url !== undefined) {
            writer.uint32(410).string(message.resource_icon_url);
        }
        if (message.last_message_id !== "0") {
            writer.uint32(416).int64(message.last_message_id);
        }
        if (message.badge !== Badge.BADGE_UNSPECIFIED) {
            writer.uint32(424).int32(badgeToNumber(message.badge));
        }
        if (message.has_mutual_messages !== false) {
            writer.uint32(432).bool(message.has_mutual_messages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.DEPRECATED = reader.string();
                    continue;
                case 5:
                    if (tag === 40) {
                        message.member_ids.push(longToString(reader.int64()));
                        continue;
                    }
                    if (tag === 42) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.member_ids.push(longToString(reader.int64()));
                        }
                        continue;
                    }
                    break;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.is_favorite = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.is_read_only = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.is_disabled = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.is_mute = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.unread_count = reader.int32();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.last_seen_id = longToString(reader.int64());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.last_message_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.last_message = exports.Message.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.receiver = exports.User.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.article = exports.Article.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.promise = exports.Promise.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.notice = exports.Notice.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.is_promisable = reader.bool();
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.is_reviewable = reader.bool();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.enabled_feature = exports.Channel_EnabledFeature.decode(reader, reader.uint32());
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.me = exports.User.decode(reader, reader.uint32());
                    continue;
                case 25:
                    if (tag !== 202) {
                        break;
                    }
                    message.biz_account = exports.BizAccount.decode(reader, reader.uint32());
                    continue;
                case 26:
                    if (tag !== 210) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 27:
                    if (tag !== 216) {
                        break;
                    }
                    message.type = channel_TypeFromJSON(reader.int32());
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.members.push(exports.User.decode(reader, reader.uint32()));
                    continue;
                case 29:
                    if (tag !== 234) {
                        break;
                    }
                    message.owner = exports.User.decode(reader, reader.uint32());
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.thumbnail = reader.string();
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.web_view = exports.WebView.decode(reader, reader.uint32());
                    continue;
                case 33:
                    if (tag !== 264) {
                        break;
                    }
                    message.member_limit = longToString(reader.int64());
                    continue;
                case 34:
                    if (tag !== 272) {
                        break;
                    }
                    message.closed = reader.bool();
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.input = exports.Channel_Input.decode(reader, reader.uint32());
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.bubble_group = exports.BubbleGroup.decode(reader, reader.uint32());
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.introduction = exports.Introduction.decode(reader, reader.uint32());
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.toolbox_buttons.push(exports.ToolboxButton.decode(reader, reader.uint32()));
                    continue;
                case 39:
                    if (tag !== 312) {
                        break;
                    }
                    message.is_temporary = reader.bool();
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.favorite_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 41:
                    if (tag !== 328) {
                        break;
                    }
                    message.unread_mentions_count = reader.int32();
                    continue;
                case 42:
                    if (tag !== 336) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 43:
                    if (tag !== 344) {
                        break;
                    }
                    message.unread_reply_count = reader.int32();
                    continue;
                case 44:
                    if (tag !== 352) {
                        break;
                    }
                    message.common_filter_id = filterIDFromJSON(reader.int32());
                    continue;
                case 45:
                    if (tag !== 360) {
                        break;
                    }
                    message.service_filter_id = filterIDFromJSON(reader.int32());
                    continue;
                case 48:
                    if (tag !== 386) {
                        break;
                    }
                    message.profile_image_urls.push(reader.string());
                    continue;
                case 49:
                    if (tag !== 394) {
                        break;
                    }
                    message.cover_image_text = reader.string();
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.cover_image_url = reader.string();
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.resource_icon_url = reader.string();
                    continue;
                case 52:
                    if (tag !== 416) {
                        break;
                    }
                    message.last_message_id = longToString(reader.int64());
                    continue;
                case 53:
                    if (tag !== 424) {
                        break;
                    }
                    message.badge = badgeFromJSON(reader.int32());
                    continue;
                case 54:
                    if (tag !== 432) {
                        break;
                    }
                    message.has_mutual_messages = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : "",
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : "0",
            DEPRECATED: isSet(object.DEPRECATED)
                ? globalThis.String(object.DEPRECATED)
                : "",
            member_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.member_ids)
                ? object.member_ids.map((e) => globalThis.String(e))
                : [],
            is_favorite: isSet(object.is_favorite)
                ? globalThis.Boolean(object.is_favorite)
                : false,
            is_read_only: isSet(object.is_read_only)
                ? globalThis.Boolean(object.is_read_only)
                : false,
            is_disabled: isSet(object.is_disabled)
                ? globalThis.Boolean(object.is_disabled)
                : false,
            is_mute: isSet(object.is_mute)
                ? globalThis.Boolean(object.is_mute)
                : false,
            unread_count: isSet(object.unread_count)
                ? globalThis.Number(object.unread_count)
                : 0,
            last_seen_id: isSet(object.last_seen_id)
                ? globalThis.String(object.last_seen_id)
                : "0",
            last_message_time: isSet(object.last_message_time)
                ? fromJsonTimestamp(object.last_message_time)
                : undefined,
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            last_message: isSet(object.last_message)
                ? exports.Message.fromJSON(object.last_message)
                : undefined,
            receiver: isSet(object.receiver)
                ? exports.User.fromJSON(object.receiver)
                : undefined,
            article: isSet(object.article)
                ? exports.Article.fromJSON(object.article)
                : undefined,
            promise: isSet(object.promise)
                ? exports.Promise.fromJSON(object.promise)
                : undefined,
            notice: isSet(object.notice) ? exports.Notice.fromJSON(object.notice) : undefined,
            is_promisable: isSet(object.is_promisable)
                ? globalThis.Boolean(object.is_promisable)
                : false,
            is_reviewable: isSet(object.is_reviewable)
                ? globalThis.Boolean(object.is_reviewable)
                : false,
            enabled_feature: isSet(object.enabled_feature)
                ? exports.Channel_EnabledFeature.fromJSON(object.enabled_feature)
                : undefined,
            me: isSet(object.me) ? exports.User.fromJSON(object.me) : undefined,
            biz_account: isSet(object.biz_account)
                ? exports.BizAccount.fromJSON(object.biz_account)
                : undefined,
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            type: isSet(object.type)
                ? channel_TypeFromJSON(object.type)
                : Channel_Type.TYPE_UNSPECIFIED,
            members: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.members)
                ? object.members.map((e) => exports.User.fromJSON(e))
                : [],
            owner: isSet(object.owner) ? exports.User.fromJSON(object.owner) : undefined,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            thumbnail: isSet(object.thumbnail)
                ? globalThis.String(object.thumbnail)
                : "",
            web_view: isSet(object.web_view)
                ? exports.WebView.fromJSON(object.web_view)
                : undefined,
            member_limit: isSet(object.member_limit)
                ? globalThis.String(object.member_limit)
                : "0",
            closed: isSet(object.closed) ? globalThis.Boolean(object.closed) : false,
            input: isSet(object.input)
                ? exports.Channel_Input.fromJSON(object.input)
                : undefined,
            bubble_group: isSet(object.bubble_group)
                ? exports.BubbleGroup.fromJSON(object.bubble_group)
                : undefined,
            introduction: isSet(object.introduction)
                ? exports.Introduction.fromJSON(object.introduction)
                : undefined,
            toolbox_buttons: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.toolbox_buttons)
                ? object.toolbox_buttons.map((e) => exports.ToolboxButton.fromJSON(e))
                : [],
            is_temporary: isSet(object.is_temporary)
                ? globalThis.Boolean(object.is_temporary)
                : false,
            favorite_time: isSet(object.favorite_time)
                ? fromJsonTimestamp(object.favorite_time)
                : undefined,
            unread_mentions_count: isSet(object.unread_mentions_count)
                ? globalThis.Number(object.unread_mentions_count)
                : 0,
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            unread_reply_count: isSet(object.unread_reply_count)
                ? globalThis.Number(object.unread_reply_count)
                : 0,
            common_filter_id: isSet(object.common_filter_id)
                ? filterIDFromJSON(object.common_filter_id)
                : undefined,
            service_filter_id: isSet(object.service_filter_id)
                ? filterIDFromJSON(object.service_filter_id)
                : undefined,
            profile_image_urls: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.profile_image_urls)
                ? object.profile_image_urls.map((e) => globalThis.String(e))
                : [],
            cover_image_text: isSet(object.cover_image_text)
                ? globalThis.String(object.cover_image_text)
                : undefined,
            cover_image_url: isSet(object.cover_image_url)
                ? globalThis.String(object.cover_image_url)
                : undefined,
            resource_icon_url: isSet(object.resource_icon_url)
                ? globalThis.String(object.resource_icon_url)
                : undefined,
            last_message_id: isSet(object.last_message_id)
                ? globalThis.String(object.last_message_id)
                : "0",
            badge: isSet(object.badge)
                ? badgeFromJSON(object.badge)
                : Badge.BADGE_UNSPECIFIED,
            has_mutual_messages: isSet(object.has_mutual_messages)
                ? globalThis.Boolean(object.has_mutual_messages)
                : false,
        };
    },
    toJSON(message) {
        var _a, _b, _c, _d;
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.resource_type !== "") {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== "0") {
            obj.resource_id = message.resource_id;
        }
        if (message.DEPRECATED !== "") {
            obj.DEPRECATED = message.DEPRECATED;
        }
        if ((_a = message.member_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.member_ids = message.member_ids;
        }
        if (message.is_favorite !== false) {
            obj.is_favorite = message.is_favorite;
        }
        if (message.is_read_only !== false) {
            obj.is_read_only = message.is_read_only;
        }
        if (message.is_disabled !== false) {
            obj.is_disabled = message.is_disabled;
        }
        if (message.is_mute !== false) {
            obj.is_mute = message.is_mute;
        }
        if (message.unread_count !== 0) {
            obj.unread_count = Math.round(message.unread_count);
        }
        if (message.last_seen_id !== "0") {
            obj.last_seen_id = message.last_seen_id;
        }
        if (message.last_message_time !== undefined) {
            obj.last_message_time = fromTimestamp(message.last_message_time)
                .toISOString();
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.last_message !== undefined) {
            obj.last_message = exports.Message.toJSON(message.last_message);
        }
        if (message.receiver !== undefined) {
            obj.receiver = exports.User.toJSON(message.receiver);
        }
        if (message.article !== undefined) {
            obj.article = exports.Article.toJSON(message.article);
        }
        if (message.promise !== undefined) {
            obj.promise = exports.Promise.toJSON(message.promise);
        }
        if (message.notice !== undefined) {
            obj.notice = exports.Notice.toJSON(message.notice);
        }
        if (message.is_promisable !== false) {
            obj.is_promisable = message.is_promisable;
        }
        if (message.is_reviewable !== false) {
            obj.is_reviewable = message.is_reviewable;
        }
        if (message.enabled_feature !== undefined) {
            obj.enabled_feature = exports.Channel_EnabledFeature.toJSON(message.enabled_feature);
        }
        if (message.me !== undefined) {
            obj.me = exports.User.toJSON(message.me);
        }
        if (message.biz_account !== undefined) {
            obj.biz_account = exports.BizAccount.toJSON(message.biz_account);
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.type !== Channel_Type.TYPE_UNSPECIFIED) {
            obj.type = channel_TypeToJSON(message.type);
        }
        if ((_b = message.members) === null || _b === void 0 ? void 0 : _b.length) {
            obj.members = message.members.map((e) => exports.User.toJSON(e));
        }
        if (message.owner !== undefined) {
            obj.owner = exports.User.toJSON(message.owner);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.thumbnail !== "") {
            obj.thumbnail = message.thumbnail;
        }
        if (message.web_view !== undefined) {
            obj.web_view = exports.WebView.toJSON(message.web_view);
        }
        if (message.member_limit !== "0") {
            obj.member_limit = message.member_limit;
        }
        if (message.closed !== false) {
            obj.closed = message.closed;
        }
        if (message.input !== undefined) {
            obj.input = exports.Channel_Input.toJSON(message.input);
        }
        if (message.bubble_group !== undefined) {
            obj.bubble_group = exports.BubbleGroup.toJSON(message.bubble_group);
        }
        if (message.introduction !== undefined) {
            obj.introduction = exports.Introduction.toJSON(message.introduction);
        }
        if ((_c = message.toolbox_buttons) === null || _c === void 0 ? void 0 : _c.length) {
            obj.toolbox_buttons = message.toolbox_buttons.map((e) => exports.ToolboxButton.toJSON(e));
        }
        if (message.is_temporary !== false) {
            obj.is_temporary = message.is_temporary;
        }
        if (message.favorite_time !== undefined) {
            obj.favorite_time = fromTimestamp(message.favorite_time).toISOString();
        }
        if (message.unread_mentions_count !== 0) {
            obj.unread_mentions_count = Math.round(message.unread_mentions_count);
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.unread_reply_count !== 0) {
            obj.unread_reply_count = Math.round(message.unread_reply_count);
        }
        if (message.common_filter_id !== undefined) {
            obj.common_filter_id = filterIDToJSON(message.common_filter_id);
        }
        if (message.service_filter_id !== undefined) {
            obj.service_filter_id = filterIDToJSON(message.service_filter_id);
        }
        if ((_d = message.profile_image_urls) === null || _d === void 0 ? void 0 : _d.length) {
            obj.profile_image_urls = message.profile_image_urls;
        }
        if (message.cover_image_text !== undefined) {
            obj.cover_image_text = message.cover_image_text;
        }
        if (message.cover_image_url !== undefined) {
            obj.cover_image_url = message.cover_image_url;
        }
        if (message.resource_icon_url !== undefined) {
            obj.resource_icon_url = message.resource_icon_url;
        }
        if (message.last_message_id !== "0") {
            obj.last_message_id = message.last_message_id;
        }
        if (message.badge !== Badge.BADGE_UNSPECIFIED) {
            obj.badge = badgeToJSON(message.badge);
        }
        if (message.has_mutual_messages !== false) {
            obj.has_mutual_messages = message.has_mutual_messages;
        }
        return obj;
    },
    create(base) {
        return exports.Channel.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
        const message = createBaseChannel();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.resource_type = (_b = object.resource_type) !== null && _b !== void 0 ? _b : "";
        message.resource_id = (_c = object.resource_id) !== null && _c !== void 0 ? _c : "0";
        message.DEPRECATED = (_d = object.DEPRECATED) !== null && _d !== void 0 ? _d : "";
        message.member_ids = ((_e = object.member_ids) === null || _e === void 0 ? void 0 : _e.map((e) => e)) || [];
        message.is_favorite = (_f = object.is_favorite) !== null && _f !== void 0 ? _f : false;
        message.is_read_only = (_g = object.is_read_only) !== null && _g !== void 0 ? _g : false;
        message.is_disabled = (_h = object.is_disabled) !== null && _h !== void 0 ? _h : false;
        message.is_mute = (_j = object.is_mute) !== null && _j !== void 0 ? _j : false;
        message.unread_count = (_k = object.unread_count) !== null && _k !== void 0 ? _k : 0;
        message.last_seen_id = (_l = object.last_seen_id) !== null && _l !== void 0 ? _l : "0";
        message.last_message_time = (object.last_message_time !== undefined &&
            object.last_message_time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.last_message_time)
            : undefined;
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.last_message =
            (object.last_message !== undefined && object.last_message !== null)
                ? exports.Message.fromPartial(object.last_message)
                : undefined;
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? exports.User.fromPartial(object.receiver)
                : undefined;
        message.article = (object.article !== undefined && object.article !== null)
            ? exports.Article.fromPartial(object.article)
            : undefined;
        message.promise = (object.promise !== undefined && object.promise !== null)
            ? exports.Promise.fromPartial(object.promise)
            : undefined;
        message.notice = (object.notice !== undefined && object.notice !== null)
            ? exports.Notice.fromPartial(object.notice)
            : undefined;
        message.is_promisable = (_m = object.is_promisable) !== null && _m !== void 0 ? _m : false;
        message.is_reviewable = (_o = object.is_reviewable) !== null && _o !== void 0 ? _o : false;
        message.enabled_feature =
            (object.enabled_feature !== undefined && object.enabled_feature !== null)
                ? exports.Channel_EnabledFeature.fromPartial(object.enabled_feature)
                : undefined;
        message.me = (object.me !== undefined && object.me !== null)
            ? exports.User.fromPartial(object.me)
            : undefined;
        message.biz_account =
            (object.biz_account !== undefined && object.biz_account !== null)
                ? exports.BizAccount.fromPartial(object.biz_account)
                : undefined;
        message.target_uri = (_p = object.target_uri) !== null && _p !== void 0 ? _p : "";
        message.type = (_q = object.type) !== null && _q !== void 0 ? _q : Channel_Type.TYPE_UNSPECIFIED;
        message.members = ((_r = object.members) === null || _r === void 0 ? void 0 : _r.map((e) => exports.User.fromPartial(e))) || [];
        message.owner = (object.owner !== undefined && object.owner !== null)
            ? exports.User.fromPartial(object.owner)
            : undefined;
        message.title = (_s = object.title) !== null && _s !== void 0 ? _s : "";
        message.thumbnail = (_t = object.thumbnail) !== null && _t !== void 0 ? _t : "";
        message.web_view =
            (object.web_view !== undefined && object.web_view !== null)
                ? exports.WebView.fromPartial(object.web_view)
                : undefined;
        message.member_limit = (_u = object.member_limit) !== null && _u !== void 0 ? _u : "0";
        message.closed = (_v = object.closed) !== null && _v !== void 0 ? _v : false;
        message.input = (object.input !== undefined && object.input !== null)
            ? exports.Channel_Input.fromPartial(object.input)
            : undefined;
        message.bubble_group =
            (object.bubble_group !== undefined && object.bubble_group !== null)
                ? exports.BubbleGroup.fromPartial(object.bubble_group)
                : undefined;
        message.introduction =
            (object.introduction !== undefined && object.introduction !== null)
                ? exports.Introduction.fromPartial(object.introduction)
                : undefined;
        message.toolbox_buttons =
            ((_w = object.toolbox_buttons) === null || _w === void 0 ? void 0 : _w.map((e) => exports.ToolboxButton.fromPartial(e))) || [];
        message.is_temporary = (_x = object.is_temporary) !== null && _x !== void 0 ? _x : false;
        message.favorite_time =
            (object.favorite_time !== undefined && object.favorite_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.favorite_time)
                : undefined;
        message.unread_mentions_count = (_y = object.unread_mentions_count) !== null && _y !== void 0 ? _y : 0;
        message.member_count = (_z = object.member_count) !== null && _z !== void 0 ? _z : 0;
        message.unread_reply_count = (_0 = object.unread_reply_count) !== null && _0 !== void 0 ? _0 : 0;
        message.common_filter_id = (_1 = object.common_filter_id) !== null && _1 !== void 0 ? _1 : undefined;
        message.service_filter_id = (_2 = object.service_filter_id) !== null && _2 !== void 0 ? _2 : undefined;
        message.profile_image_urls = ((_3 = object.profile_image_urls) === null || _3 === void 0 ? void 0 : _3.map((e) => e)) || [];
        message.cover_image_text = (_4 = object.cover_image_text) !== null && _4 !== void 0 ? _4 : undefined;
        message.cover_image_url = (_5 = object.cover_image_url) !== null && _5 !== void 0 ? _5 : undefined;
        message.resource_icon_url = (_6 = object.resource_icon_url) !== null && _6 !== void 0 ? _6 : undefined;
        message.last_message_id = (_7 = object.last_message_id) !== null && _7 !== void 0 ? _7 : "0";
        message.badge = (_8 = object.badge) !== null && _8 !== void 0 ? _8 : Badge.BADGE_UNSPECIFIED;
        message.has_mutual_messages = (_9 = object.has_mutual_messages) !== null && _9 !== void 0 ? _9 : false;
        return message;
    },
};
function createBaseChannel_EnabledFeature() {
    return {
        gift: false,
        promise: false,
        report: false,
        block: false,
        notification: false,
        manner: false,
        abuser: false,
        favorite_phrases: false,
        location: false,
        sticker: false,
        safe_number: false,
        voip: false,
        send_money: false,
        edit_announcement: false,
        transfer_features: [],
        content_downloadable: false,
        search_message: false,
        send_video: false,
    };
}
exports.Channel_EnabledFeature = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.gift !== false) {
            writer.uint32(8).bool(message.gift);
        }
        if (message.promise !== false) {
            writer.uint32(16).bool(message.promise);
        }
        if (message.report !== false) {
            writer.uint32(24).bool(message.report);
        }
        if (message.block !== false) {
            writer.uint32(32).bool(message.block);
        }
        if (message.notification !== false) {
            writer.uint32(40).bool(message.notification);
        }
        if (message.manner !== false) {
            writer.uint32(48).bool(message.manner);
        }
        if (message.abuser !== false) {
            writer.uint32(56).bool(message.abuser);
        }
        if (message.favorite_phrases !== false) {
            writer.uint32(64).bool(message.favorite_phrases);
        }
        if (message.location !== false) {
            writer.uint32(72).bool(message.location);
        }
        if (message.sticker !== false) {
            writer.uint32(80).bool(message.sticker);
        }
        if (message.safe_number !== false) {
            writer.uint32(88).bool(message.safe_number);
        }
        if (message.voip !== false) {
            writer.uint32(96).bool(message.voip);
        }
        if (message.send_money !== false) {
            writer.uint32(104).bool(message.send_money);
        }
        if (message.edit_announcement !== false) {
            writer.uint32(112).bool(message.edit_announcement);
        }
        for (const v of message.transfer_features) {
            writer.uint32(122).string(v);
        }
        if (message.content_downloadable !== false) {
            writer.uint32(128).bool(message.content_downloadable);
        }
        if (message.search_message !== false) {
            writer.uint32(136).bool(message.search_message);
        }
        if (message.send_video !== false) {
            writer.uint32(160).bool(message.send_video);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel_EnabledFeature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.gift = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.promise = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.report = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.block = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.notification = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.manner = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.abuser = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.favorite_phrases = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.location = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.sticker = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.safe_number = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.voip = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.send_money = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.edit_announcement = reader.bool();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.transfer_features.push(reader.string());
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.content_downloadable = reader.bool();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.search_message = reader.bool();
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.send_video = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gift: isSet(object.gift) ? globalThis.Boolean(object.gift) : false,
            promise: isSet(object.promise)
                ? globalThis.Boolean(object.promise)
                : false,
            report: isSet(object.report) ? globalThis.Boolean(object.report) : false,
            block: isSet(object.block) ? globalThis.Boolean(object.block) : false,
            notification: isSet(object.notification)
                ? globalThis.Boolean(object.notification)
                : false,
            manner: isSet(object.manner) ? globalThis.Boolean(object.manner) : false,
            abuser: isSet(object.abuser) ? globalThis.Boolean(object.abuser) : false,
            favorite_phrases: isSet(object.favorite_phrases)
                ? globalThis.Boolean(object.favorite_phrases)
                : false,
            location: isSet(object.location)
                ? globalThis.Boolean(object.location)
                : false,
            sticker: isSet(object.sticker)
                ? globalThis.Boolean(object.sticker)
                : false,
            safe_number: isSet(object.safe_number)
                ? globalThis.Boolean(object.safe_number)
                : false,
            voip: isSet(object.voip) ? globalThis.Boolean(object.voip) : false,
            send_money: isSet(object.send_money)
                ? globalThis.Boolean(object.send_money)
                : false,
            edit_announcement: isSet(object.edit_announcement)
                ? globalThis.Boolean(object.edit_announcement)
                : false,
            transfer_features: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.transfer_features)
                ? object.transfer_features.map((e) => globalThis.String(e))
                : [],
            content_downloadable: isSet(object.content_downloadable)
                ? globalThis.Boolean(object.content_downloadable)
                : false,
            search_message: isSet(object.search_message)
                ? globalThis.Boolean(object.search_message)
                : false,
            send_video: isSet(object.send_video)
                ? globalThis.Boolean(object.send_video)
                : false,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.gift !== false) {
            obj.gift = message.gift;
        }
        if (message.promise !== false) {
            obj.promise = message.promise;
        }
        if (message.report !== false) {
            obj.report = message.report;
        }
        if (message.block !== false) {
            obj.block = message.block;
        }
        if (message.notification !== false) {
            obj.notification = message.notification;
        }
        if (message.manner !== false) {
            obj.manner = message.manner;
        }
        if (message.abuser !== false) {
            obj.abuser = message.abuser;
        }
        if (message.favorite_phrases !== false) {
            obj.favorite_phrases = message.favorite_phrases;
        }
        if (message.location !== false) {
            obj.location = message.location;
        }
        if (message.sticker !== false) {
            obj.sticker = message.sticker;
        }
        if (message.safe_number !== false) {
            obj.safe_number = message.safe_number;
        }
        if (message.voip !== false) {
            obj.voip = message.voip;
        }
        if (message.send_money !== false) {
            obj.send_money = message.send_money;
        }
        if (message.edit_announcement !== false) {
            obj.edit_announcement = message.edit_announcement;
        }
        if ((_a = message.transfer_features) === null || _a === void 0 ? void 0 : _a.length) {
            obj.transfer_features = message.transfer_features;
        }
        if (message.content_downloadable !== false) {
            obj.content_downloadable = message.content_downloadable;
        }
        if (message.search_message !== false) {
            obj.search_message = message.search_message;
        }
        if (message.send_video !== false) {
            obj.send_video = message.send_video;
        }
        return obj;
    },
    create(base) {
        return exports.Channel_EnabledFeature.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        const message = createBaseChannel_EnabledFeature();
        message.gift = (_a = object.gift) !== null && _a !== void 0 ? _a : false;
        message.promise = (_b = object.promise) !== null && _b !== void 0 ? _b : false;
        message.report = (_c = object.report) !== null && _c !== void 0 ? _c : false;
        message.block = (_d = object.block) !== null && _d !== void 0 ? _d : false;
        message.notification = (_e = object.notification) !== null && _e !== void 0 ? _e : false;
        message.manner = (_f = object.manner) !== null && _f !== void 0 ? _f : false;
        message.abuser = (_g = object.abuser) !== null && _g !== void 0 ? _g : false;
        message.favorite_phrases = (_h = object.favorite_phrases) !== null && _h !== void 0 ? _h : false;
        message.location = (_j = object.location) !== null && _j !== void 0 ? _j : false;
        message.sticker = (_k = object.sticker) !== null && _k !== void 0 ? _k : false;
        message.safe_number = (_l = object.safe_number) !== null && _l !== void 0 ? _l : false;
        message.voip = (_m = object.voip) !== null && _m !== void 0 ? _m : false;
        message.send_money = (_o = object.send_money) !== null && _o !== void 0 ? _o : false;
        message.edit_announcement = (_p = object.edit_announcement) !== null && _p !== void 0 ? _p : false;
        message.transfer_features = ((_q = object.transfer_features) === null || _q === void 0 ? void 0 : _q.map((e) => e)) || [];
        message.content_downloadable = (_r = object.content_downloadable) !== null && _r !== void 0 ? _r : false;
        message.search_message = (_s = object.search_message) !== null && _s !== void 0 ? _s : false;
        message.send_video = (_t = object.send_video) !== null && _t !== void 0 ? _t : false;
        return message;
    },
};
function createBaseChannel_Input() {
    return { text: undefined, button: undefined };
}
exports.Channel_Input = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== undefined) {
            exports.Channel_Input_Text.encode(message.text, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.button !== undefined) {
            exports.Button.encode(message.button, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel_Input();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = exports.Channel_Input_Text.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.button = exports.Button.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text)
                ? exports.Channel_Input_Text.fromJSON(object.text)
                : undefined,
            button: isSet(object.button) ? exports.Button.fromJSON(object.button) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== undefined) {
            obj.text = exports.Channel_Input_Text.toJSON(message.text);
        }
        if (message.button !== undefined) {
            obj.button = exports.Button.toJSON(message.button);
        }
        return obj;
    },
    create(base) {
        return exports.Channel_Input.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseChannel_Input();
        message.text = (object.text !== undefined && object.text !== null)
            ? exports.Channel_Input_Text.fromPartial(object.text)
            : undefined;
        message.button = (object.button !== undefined && object.button !== null)
            ? exports.Button.fromPartial(object.button)
            : undefined;
        return message;
    },
};
function createBaseChannel_Input_Text() {
    return { is_disabled: false, placeholder: "" };
}
exports.Channel_Input_Text = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.is_disabled !== false) {
            writer.uint32(8).bool(message.is_disabled);
        }
        if (message.placeholder !== "") {
            writer.uint32(18).string(message.placeholder);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannel_Input_Text();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.is_disabled = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.placeholder = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            is_disabled: isSet(object.is_disabled)
                ? globalThis.Boolean(object.is_disabled)
                : false,
            placeholder: isSet(object.placeholder)
                ? globalThis.String(object.placeholder)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.is_disabled !== false) {
            obj.is_disabled = message.is_disabled;
        }
        if (message.placeholder !== "") {
            obj.placeholder = message.placeholder;
        }
        return obj;
    },
    create(base) {
        return exports.Channel_Input_Text.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseChannel_Input_Text();
        message.is_disabled = (_a = object.is_disabled) !== null && _a !== void 0 ? _a : false;
        message.placeholder = (_b = object.placeholder) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseArticle() {
    return {
        id: "0",
        user_id: "0",
        title: "",
        type: "",
        first_image_url: "",
        smb: undefined,
        status: "",
        price: 0,
        has_price: false,
        review_id: "0",
        reserved_user_id: "0",
        free_share_event_enabled: false,
    };
}
exports.Article = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.user_id !== "0") {
            writer.uint32(16).int64(message.user_id);
        }
        if (message.title !== "") {
            writer.uint32(26).string(message.title);
        }
        if (message.type !== "") {
            writer.uint32(34).string(message.type);
        }
        if (message.first_image_url !== "") {
            writer.uint32(42).string(message.first_image_url);
        }
        if (message.smb !== undefined) {
            exports.Smb.encode(message.smb, writer.uint32(50).fork()).ldelim();
        }
        if (message.status !== "") {
            writer.uint32(58).string(message.status);
        }
        if (message.price !== 0) {
            writer.uint32(65).double(message.price);
        }
        if (message.has_price !== false) {
            writer.uint32(72).bool(message.has_price);
        }
        if (message.review_id !== "0") {
            writer.uint32(80).int64(message.review_id);
        }
        if (message.reserved_user_id !== "0") {
            writer.uint32(88).int64(message.reserved_user_id);
        }
        if (message.free_share_event_enabled !== false) {
            writer.uint32(96).bool(message.free_share_event_enabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseArticle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.user_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.first_image_url = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.smb = exports.Smb.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 8:
                    if (tag !== 65) {
                        break;
                    }
                    message.price = reader.double();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.has_price = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.review_id = longToString(reader.int64());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.reserved_user_id = longToString(reader.int64());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.free_share_event_enabled = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : "0",
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            first_image_url: isSet(object.first_image_url)
                ? globalThis.String(object.first_image_url)
                : "",
            smb: isSet(object.smb) ? exports.Smb.fromJSON(object.smb) : undefined,
            status: isSet(object.status) ? globalThis.String(object.status) : "",
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            has_price: isSet(object.has_price)
                ? globalThis.Boolean(object.has_price)
                : false,
            review_id: isSet(object.review_id)
                ? globalThis.String(object.review_id)
                : "0",
            reserved_user_id: isSet(object.reserved_user_id)
                ? globalThis.String(object.reserved_user_id)
                : "0",
            free_share_event_enabled: isSet(object.free_share_event_enabled)
                ? globalThis.Boolean(object.free_share_event_enabled)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.user_id !== "0") {
            obj.user_id = message.user_id;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.first_image_url !== "") {
            obj.first_image_url = message.first_image_url;
        }
        if (message.smb !== undefined) {
            obj.smb = exports.Smb.toJSON(message.smb);
        }
        if (message.status !== "") {
            obj.status = message.status;
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.has_price !== false) {
            obj.has_price = message.has_price;
        }
        if (message.review_id !== "0") {
            obj.review_id = message.review_id;
        }
        if (message.reserved_user_id !== "0") {
            obj.reserved_user_id = message.reserved_user_id;
        }
        if (message.free_share_event_enabled !== false) {
            obj.free_share_event_enabled = message.free_share_event_enabled;
        }
        return obj;
    },
    create(base) {
        return exports.Article.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseArticle();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.user_id = (_b = object.user_id) !== null && _b !== void 0 ? _b : "0";
        message.title = (_c = object.title) !== null && _c !== void 0 ? _c : "";
        message.type = (_d = object.type) !== null && _d !== void 0 ? _d : "";
        message.first_image_url = (_e = object.first_image_url) !== null && _e !== void 0 ? _e : "";
        message.smb = (object.smb !== undefined && object.smb !== null)
            ? exports.Smb.fromPartial(object.smb)
            : undefined;
        message.status = (_f = object.status) !== null && _f !== void 0 ? _f : "";
        message.price = (_g = object.price) !== null && _g !== void 0 ? _g : 0;
        message.has_price = (_h = object.has_price) !== null && _h !== void 0 ? _h : false;
        message.review_id = (_j = object.review_id) !== null && _j !== void 0 ? _j : "0";
        message.reserved_user_id = (_k = object.reserved_user_id) !== null && _k !== void 0 ? _k : "0";
        message.free_share_event_enabled = (_l = object.free_share_event_enabled) !== null && _l !== void 0 ? _l : false;
        return message;
    },
};
function createBaseSmb() {
    return {
        id: "0",
        name: "",
        status: "",
        reviewed_by_me: false,
        category_text: "",
        smb_reviews_count: 0,
        likes_count: 0,
        first_image_url: "",
    };
}
exports.Smb = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.status !== "") {
            writer.uint32(26).string(message.status);
        }
        if (message.reviewed_by_me !== false) {
            writer.uint32(32).bool(message.reviewed_by_me);
        }
        if (message.category_text !== "") {
            writer.uint32(42).string(message.category_text);
        }
        if (message.smb_reviews_count !== 0) {
            writer.uint32(48).int32(message.smb_reviews_count);
        }
        if (message.likes_count !== 0) {
            writer.uint32(56).int32(message.likes_count);
        }
        if (message.first_image_url !== "") {
            writer.uint32(66).string(message.first_image_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSmb();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.reviewed_by_me = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.category_text = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.smb_reviews_count = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.likes_count = reader.int32();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.first_image_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            status: isSet(object.status) ? globalThis.String(object.status) : "",
            reviewed_by_me: isSet(object.reviewed_by_me)
                ? globalThis.Boolean(object.reviewed_by_me)
                : false,
            category_text: isSet(object.category_text)
                ? globalThis.String(object.category_text)
                : "",
            smb_reviews_count: isSet(object.smb_reviews_count)
                ? globalThis.Number(object.smb_reviews_count)
                : 0,
            likes_count: isSet(object.likes_count)
                ? globalThis.Number(object.likes_count)
                : 0,
            first_image_url: isSet(object.first_image_url)
                ? globalThis.String(object.first_image_url)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.status !== "") {
            obj.status = message.status;
        }
        if (message.reviewed_by_me !== false) {
            obj.reviewed_by_me = message.reviewed_by_me;
        }
        if (message.category_text !== "") {
            obj.category_text = message.category_text;
        }
        if (message.smb_reviews_count !== 0) {
            obj.smb_reviews_count = Math.round(message.smb_reviews_count);
        }
        if (message.likes_count !== 0) {
            obj.likes_count = Math.round(message.likes_count);
        }
        if (message.first_image_url !== "") {
            obj.first_image_url = message.first_image_url;
        }
        return obj;
    },
    create(base) {
        return exports.Smb.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseSmb();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : "";
        message.reviewed_by_me = (_d = object.reviewed_by_me) !== null && _d !== void 0 ? _d : false;
        message.category_text = (_e = object.category_text) !== null && _e !== void 0 ? _e : "";
        message.smb_reviews_count = (_f = object.smb_reviews_count) !== null && _f !== void 0 ? _f : 0;
        message.likes_count = (_g = object.likes_count) !== null && _g !== void 0 ? _g : 0;
        message.first_image_url = (_h = object.first_image_url) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
function createBaseUser() {
    return {
        id: "0",
        nickname: "",
        display_region_name: "",
        profile_image: "",
        temperature: 0,
        message_response_time: "",
        is_do_not_disturb_on: false,
        do_not_disturb_start_time: "",
        do_not_disturb_end_time: "",
        badge_image: "",
        user_flagged_by_me: [],
        status: "",
        target_uri: "",
        type: User_Type.TYPE_UNSPECIFIED,
        display_region_checkins_count: 0,
        do_not_disturbe_time_zone: "",
        region: undefined,
        is_official_user: false,
        display_location_name: "",
        is_biz_follower: false,
        is_same_condo_member: false,
        subnickname: "",
        role: User_Role.ROLE_UNSPECIFIED,
        identification_status: User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED,
        manner_temperature: undefined,
        karrot_score: undefined,
        score_badge: undefined,
    };
}
exports.User = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.nickname !== "") {
            writer.uint32(18).string(message.nickname);
        }
        if (message.display_region_name !== "") {
            writer.uint32(26).string(message.display_region_name);
        }
        if (message.profile_image !== "") {
            writer.uint32(34).string(message.profile_image);
        }
        if (message.temperature !== 0) {
            writer.uint32(45).float(message.temperature);
        }
        if (message.message_response_time !== "") {
            writer.uint32(50).string(message.message_response_time);
        }
        if (message.is_do_not_disturb_on !== false) {
            writer.uint32(56).bool(message.is_do_not_disturb_on);
        }
        if (message.do_not_disturb_start_time !== "") {
            writer.uint32(66).string(message.do_not_disturb_start_time);
        }
        if (message.do_not_disturb_end_time !== "") {
            writer.uint32(74).string(message.do_not_disturb_end_time);
        }
        if (message.badge_image !== "") {
            writer.uint32(82).string(message.badge_image);
        }
        for (const v of message.user_flagged_by_me) {
            writer.uint32(90).string(v);
        }
        if (message.status !== "") {
            writer.uint32(98).string(message.status);
        }
        if (message.target_uri !== "") {
            writer.uint32(106).string(message.target_uri);
        }
        if (message.type !== User_Type.TYPE_UNSPECIFIED) {
            writer.uint32(112).int32(user_TypeToNumber(message.type));
        }
        if (message.display_region_checkins_count !== 0) {
            writer.uint32(120).int32(message.display_region_checkins_count);
        }
        if (message.do_not_disturbe_time_zone !== "") {
            writer.uint32(130).string(message.do_not_disturbe_time_zone);
        }
        if (message.region !== undefined) {
            exports.Region.encode(message.region, writer.uint32(138).fork()).ldelim();
        }
        if (message.is_official_user !== false) {
            writer.uint32(144).bool(message.is_official_user);
        }
        if (message.display_location_name !== "") {
            writer.uint32(154).string(message.display_location_name);
        }
        if (message.is_biz_follower !== false) {
            writer.uint32(160).bool(message.is_biz_follower);
        }
        if (message.is_same_condo_member !== false) {
            writer.uint32(168).bool(message.is_same_condo_member);
        }
        if (message.subnickname !== "") {
            writer.uint32(178).string(message.subnickname);
        }
        if (message.role !== User_Role.ROLE_UNSPECIFIED) {
            writer.uint32(184).int32(user_RoleToNumber(message.role));
        }
        if (message.identification_status !==
            User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED) {
            writer.uint32(192).int32(user_IdentificationStatusToNumber(message.identification_status));
        }
        if (message.manner_temperature !== undefined) {
            writer.uint32(813).float(message.manner_temperature);
        }
        if (message.karrot_score !== undefined) {
            exports.User_KarrotScore.encode(message.karrot_score, writer.uint32(818).fork())
                .ldelim();
        }
        if (message.score_badge !== undefined) {
            exports.User_ScoreBadge.encode(message.score_badge, writer.uint32(826).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.display_region_name = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.profile_image = reader.string();
                    continue;
                case 5:
                    if (tag !== 45) {
                        break;
                    }
                    message.temperature = reader.float();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.message_response_time = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.is_do_not_disturb_on = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.do_not_disturb_start_time = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.do_not_disturb_end_time = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.badge_image = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.user_flagged_by_me.push(reader.string());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 14:
                    if (tag !== 112) {
                        break;
                    }
                    message.type = user_TypeFromJSON(reader.int32());
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.display_region_checkins_count = reader.int32();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.do_not_disturbe_time_zone = reader.string();
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.region = exports.Region.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 144) {
                        break;
                    }
                    message.is_official_user = reader.bool();
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.display_location_name = reader.string();
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.is_biz_follower = reader.bool();
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.is_same_condo_member = reader.bool();
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.subnickname = reader.string();
                    continue;
                case 23:
                    if (tag !== 184) {
                        break;
                    }
                    message.role = user_RoleFromJSON(reader.int32());
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.identification_status = user_IdentificationStatusFromJSON(reader.int32());
                    continue;
                case 101:
                    if (tag !== 813) {
                        break;
                    }
                    message.manner_temperature = reader.float();
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.karrot_score = exports.User_KarrotScore.decode(reader, reader.uint32());
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.score_badge = exports.User_ScoreBadge.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            display_region_name: isSet(object.display_region_name)
                ? globalThis.String(object.display_region_name)
                : "",
            profile_image: isSet(object.profile_image)
                ? globalThis.String(object.profile_image)
                : "",
            temperature: isSet(object.temperature)
                ? globalThis.Number(object.temperature)
                : 0,
            message_response_time: isSet(object.message_response_time)
                ? globalThis.String(object.message_response_time)
                : "",
            is_do_not_disturb_on: isSet(object.is_do_not_disturb_on)
                ? globalThis.Boolean(object.is_do_not_disturb_on)
                : false,
            do_not_disturb_start_time: isSet(object.do_not_disturb_start_time)
                ? globalThis.String(object.do_not_disturb_start_time)
                : "",
            do_not_disturb_end_time: isSet(object.do_not_disturb_end_time)
                ? globalThis.String(object.do_not_disturb_end_time)
                : "",
            badge_image: isSet(object.badge_image)
                ? globalThis.String(object.badge_image)
                : "",
            user_flagged_by_me: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.user_flagged_by_me)
                ? object.user_flagged_by_me.map((e) => globalThis.String(e))
                : [],
            status: isSet(object.status) ? globalThis.String(object.status) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            type: isSet(object.type)
                ? user_TypeFromJSON(object.type)
                : User_Type.TYPE_UNSPECIFIED,
            display_region_checkins_count: isSet(object.display_region_checkins_count)
                ? globalThis.Number(object.display_region_checkins_count)
                : 0,
            do_not_disturbe_time_zone: isSet(object.do_not_disturbe_time_zone)
                ? globalThis.String(object.do_not_disturbe_time_zone)
                : "",
            region: isSet(object.region) ? exports.Region.fromJSON(object.region) : undefined,
            is_official_user: isSet(object.is_official_user)
                ? globalThis.Boolean(object.is_official_user)
                : false,
            display_location_name: isSet(object.display_location_name)
                ? globalThis.String(object.display_location_name)
                : "",
            is_biz_follower: isSet(object.is_biz_follower)
                ? globalThis.Boolean(object.is_biz_follower)
                : false,
            is_same_condo_member: isSet(object.is_same_condo_member)
                ? globalThis.Boolean(object.is_same_condo_member)
                : false,
            subnickname: isSet(object.subnickname)
                ? globalThis.String(object.subnickname)
                : "",
            role: isSet(object.role)
                ? user_RoleFromJSON(object.role)
                : User_Role.ROLE_UNSPECIFIED,
            identification_status: isSet(object.identification_status)
                ? user_IdentificationStatusFromJSON(object.identification_status)
                : User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED,
            manner_temperature: isSet(object.manner_temperature)
                ? globalThis.Number(object.manner_temperature)
                : undefined,
            karrot_score: isSet(object.karrot_score)
                ? exports.User_KarrotScore.fromJSON(object.karrot_score)
                : undefined,
            score_badge: isSet(object.score_badge)
                ? exports.User_ScoreBadge.fromJSON(object.score_badge)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.display_region_name !== "") {
            obj.display_region_name = message.display_region_name;
        }
        if (message.profile_image !== "") {
            obj.profile_image = message.profile_image;
        }
        if (message.temperature !== 0) {
            obj.temperature = message.temperature;
        }
        if (message.message_response_time !== "") {
            obj.message_response_time = message.message_response_time;
        }
        if (message.is_do_not_disturb_on !== false) {
            obj.is_do_not_disturb_on = message.is_do_not_disturb_on;
        }
        if (message.do_not_disturb_start_time !== "") {
            obj.do_not_disturb_start_time = message.do_not_disturb_start_time;
        }
        if (message.do_not_disturb_end_time !== "") {
            obj.do_not_disturb_end_time = message.do_not_disturb_end_time;
        }
        if (message.badge_image !== "") {
            obj.badge_image = message.badge_image;
        }
        if ((_a = message.user_flagged_by_me) === null || _a === void 0 ? void 0 : _a.length) {
            obj.user_flagged_by_me = message.user_flagged_by_me;
        }
        if (message.status !== "") {
            obj.status = message.status;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.type !== User_Type.TYPE_UNSPECIFIED) {
            obj.type = user_TypeToJSON(message.type);
        }
        if (message.display_region_checkins_count !== 0) {
            obj.display_region_checkins_count = Math.round(message.display_region_checkins_count);
        }
        if (message.do_not_disturbe_time_zone !== "") {
            obj.do_not_disturbe_time_zone = message.do_not_disturbe_time_zone;
        }
        if (message.region !== undefined) {
            obj.region = exports.Region.toJSON(message.region);
        }
        if (message.is_official_user !== false) {
            obj.is_official_user = message.is_official_user;
        }
        if (message.display_location_name !== "") {
            obj.display_location_name = message.display_location_name;
        }
        if (message.is_biz_follower !== false) {
            obj.is_biz_follower = message.is_biz_follower;
        }
        if (message.is_same_condo_member !== false) {
            obj.is_same_condo_member = message.is_same_condo_member;
        }
        if (message.subnickname !== "") {
            obj.subnickname = message.subnickname;
        }
        if (message.role !== User_Role.ROLE_UNSPECIFIED) {
            obj.role = user_RoleToJSON(message.role);
        }
        if (message.identification_status !==
            User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED) {
            obj.identification_status = user_IdentificationStatusToJSON(message.identification_status);
        }
        if (message.manner_temperature !== undefined) {
            obj.manner_temperature = message.manner_temperature;
        }
        if (message.karrot_score !== undefined) {
            obj.karrot_score = exports.User_KarrotScore.toJSON(message.karrot_score);
        }
        if (message.score_badge !== undefined) {
            obj.score_badge = exports.User_ScoreBadge.toJSON(message.score_badge);
        }
        return obj;
    },
    create(base) {
        return exports.User.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        const message = createBaseUser();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.nickname = (_b = object.nickname) !== null && _b !== void 0 ? _b : "";
        message.display_region_name = (_c = object.display_region_name) !== null && _c !== void 0 ? _c : "";
        message.profile_image = (_d = object.profile_image) !== null && _d !== void 0 ? _d : "";
        message.temperature = (_e = object.temperature) !== null && _e !== void 0 ? _e : 0;
        message.message_response_time = (_f = object.message_response_time) !== null && _f !== void 0 ? _f : "";
        message.is_do_not_disturb_on = (_g = object.is_do_not_disturb_on) !== null && _g !== void 0 ? _g : false;
        message.do_not_disturb_start_time = (_h = object.do_not_disturb_start_time) !== null && _h !== void 0 ? _h : "";
        message.do_not_disturb_end_time = (_j = object.do_not_disturb_end_time) !== null && _j !== void 0 ? _j : "";
        message.badge_image = (_k = object.badge_image) !== null && _k !== void 0 ? _k : "";
        message.user_flagged_by_me = ((_l = object.user_flagged_by_me) === null || _l === void 0 ? void 0 : _l.map((e) => e)) || [];
        message.status = (_m = object.status) !== null && _m !== void 0 ? _m : "";
        message.target_uri = (_o = object.target_uri) !== null && _o !== void 0 ? _o : "";
        message.type = (_p = object.type) !== null && _p !== void 0 ? _p : User_Type.TYPE_UNSPECIFIED;
        message.display_region_checkins_count =
            (_q = object.display_region_checkins_count) !== null && _q !== void 0 ? _q : 0;
        message.do_not_disturbe_time_zone = (_r = object.do_not_disturbe_time_zone) !== null && _r !== void 0 ? _r : "";
        message.region = (object.region !== undefined && object.region !== null)
            ? exports.Region.fromPartial(object.region)
            : undefined;
        message.is_official_user = (_s = object.is_official_user) !== null && _s !== void 0 ? _s : false;
        message.display_location_name = (_t = object.display_location_name) !== null && _t !== void 0 ? _t : "";
        message.is_biz_follower = (_u = object.is_biz_follower) !== null && _u !== void 0 ? _u : false;
        message.is_same_condo_member = (_v = object.is_same_condo_member) !== null && _v !== void 0 ? _v : false;
        message.subnickname = (_w = object.subnickname) !== null && _w !== void 0 ? _w : "";
        message.role = (_x = object.role) !== null && _x !== void 0 ? _x : User_Role.ROLE_UNSPECIFIED;
        message.identification_status = (_y = object.identification_status) !== null && _y !== void 0 ? _y : User_IdentificationStatus.IDENTIFICATION_STATUS_UNSPECIFIED;
        message.manner_temperature = (_z = object.manner_temperature) !== null && _z !== void 0 ? _z : undefined;
        message.karrot_score =
            (object.karrot_score !== undefined && object.karrot_score !== null)
                ? exports.User_KarrotScore.fromPartial(object.karrot_score)
                : undefined;
        message.score_badge =
            (object.score_badge !== undefined && object.score_badge !== null)
                ? exports.User_ScoreBadge.fromPartial(object.score_badge)
                : undefined;
        return message;
    },
};
function createBaseUser_KarrotScore() {
    return { current_score: 0 };
}
exports.User_KarrotScore = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.current_score !== 0) {
            writer.uint32(8).int32(message.current_score);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUser_KarrotScore();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.current_score = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            current_score: isSet(object.current_score)
                ? globalThis.Number(object.current_score)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.current_score !== 0) {
            obj.current_score = Math.round(message.current_score);
        }
        return obj;
    },
    create(base) {
        return exports.User_KarrotScore.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUser_KarrotScore();
        message.current_score = (_a = object.current_score) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseUser_ScoreBadge() {
    return {
        current_score: "",
        current_score_color: "",
        background_colors: [],
        image_url: "",
    };
}
exports.User_ScoreBadge = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.current_score !== "") {
            writer.uint32(10).string(message.current_score);
        }
        if (message.current_score_color !== "") {
            writer.uint32(18).string(message.current_score_color);
        }
        for (const v of message.background_colors) {
            writer.uint32(26).string(v);
        }
        if (message.image_url !== "") {
            writer.uint32(34).string(message.image_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUser_ScoreBadge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.current_score = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.current_score_color = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.background_colors.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            current_score: isSet(object.current_score)
                ? globalThis.String(object.current_score)
                : "",
            current_score_color: isSet(object.current_score_color)
                ? globalThis.String(object.current_score_color)
                : "",
            background_colors: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.background_colors)
                ? object.background_colors.map((e) => globalThis.String(e))
                : [],
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.current_score !== "") {
            obj.current_score = message.current_score;
        }
        if (message.current_score_color !== "") {
            obj.current_score_color = message.current_score_color;
        }
        if ((_a = message.background_colors) === null || _a === void 0 ? void 0 : _a.length) {
            obj.background_colors = message.background_colors;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        return obj;
    },
    create(base) {
        return exports.User_ScoreBadge.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseUser_ScoreBadge();
        message.current_score = (_a = object.current_score) !== null && _a !== void 0 ? _a : "";
        message.current_score_color = (_b = object.current_score_color) !== null && _b !== void 0 ? _b : "";
        message.background_colors = ((_c = object.background_colors) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.image_url = (_d = object.image_url) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseRegion() {
    return {
        id: 0,
        name1: "",
        name2: "",
        name3: "",
        name4: "",
        name: "",
        fullname: "",
        depth: 0,
    };
}
exports.Region = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.name1 !== "") {
            writer.uint32(18).string(message.name1);
        }
        if (message.name2 !== "") {
            writer.uint32(26).string(message.name2);
        }
        if (message.name3 !== "") {
            writer.uint32(34).string(message.name3);
        }
        if (message.name4 !== "") {
            writer.uint32(42).string(message.name4);
        }
        if (message.name !== "") {
            writer.uint32(50).string(message.name);
        }
        if (message.fullname !== "") {
            writer.uint32(58).string(message.fullname);
        }
        if (message.depth !== 0) {
            writer.uint32(64).int32(message.depth);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name1 = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name2 = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.name3 = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.name4 = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.fullname = reader.string();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.depth = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            name1: isSet(object.name1) ? globalThis.String(object.name1) : "",
            name2: isSet(object.name2) ? globalThis.String(object.name2) : "",
            name3: isSet(object.name3) ? globalThis.String(object.name3) : "",
            name4: isSet(object.name4) ? globalThis.String(object.name4) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            fullname: isSet(object.fullname)
                ? globalThis.String(object.fullname)
                : "",
            depth: isSet(object.depth) ? globalThis.Number(object.depth) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.name1 !== "") {
            obj.name1 = message.name1;
        }
        if (message.name2 !== "") {
            obj.name2 = message.name2;
        }
        if (message.name3 !== "") {
            obj.name3 = message.name3;
        }
        if (message.name4 !== "") {
            obj.name4 = message.name4;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.fullname !== "") {
            obj.fullname = message.fullname;
        }
        if (message.depth !== 0) {
            obj.depth = Math.round(message.depth);
        }
        return obj;
    },
    create(base) {
        return exports.Region.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseRegion();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.name1 = (_b = object.name1) !== null && _b !== void 0 ? _b : "";
        message.name2 = (_c = object.name2) !== null && _c !== void 0 ? _c : "";
        message.name3 = (_d = object.name3) !== null && _d !== void 0 ? _d : "";
        message.name4 = (_e = object.name4) !== null && _e !== void 0 ? _e : "";
        message.name = (_f = object.name) !== null && _f !== void 0 ? _f : "";
        message.fullname = (_g = object.fullname) !== null && _g !== void 0 ? _g : "";
        message.depth = (_h = object.depth) !== null && _h !== void 0 ? _h : 0;
        return message;
    },
};
function createBaseNotice() {
    return { type: "", message: "" };
}
exports.Notice = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNotice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.Notice.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseNotice();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.message = (_b = object.message) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseUnreadCount() {
    return {
        total: 0,
        message: 0,
        notification: 0,
        user_message: 0,
        biz_message: {},
    };
}
exports.UnreadCount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.total !== 0) {
            writer.uint32(8).int32(message.total);
        }
        if (message.message !== 0) {
            writer.uint32(16).int32(message.message);
        }
        if (message.notification !== 0) {
            writer.uint32(24).int32(message.notification);
        }
        if (message.user_message !== 0) {
            writer.uint32(32).int32(message.user_message);
        }
        Object.entries(message.biz_message).forEach(([key, value]) => {
            exports.UnreadCount_BizMessageEntry.encode({ key: key, value }, writer.uint32(42).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnreadCount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.total = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.notification = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.user_message = reader.int32();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    const entry5 = exports.UnreadCount_BizMessageEntry.decode(reader, reader.uint32());
                    if (entry5.value !== undefined) {
                        message.biz_message[entry5.key] = entry5.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            total: isSet(object.total) ? globalThis.Number(object.total) : 0,
            message: isSet(object.message) ? globalThis.Number(object.message) : 0,
            notification: isSet(object.notification)
                ? globalThis.Number(object.notification)
                : 0,
            user_message: isSet(object.user_message)
                ? globalThis.Number(object.user_message)
                : 0,
            biz_message: isObject(object.biz_message)
                ? Object.entries(object.biz_message).reduce((acc, [key, value]) => {
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.total !== 0) {
            obj.total = Math.round(message.total);
        }
        if (message.message !== 0) {
            obj.message = Math.round(message.message);
        }
        if (message.notification !== 0) {
            obj.notification = Math.round(message.notification);
        }
        if (message.user_message !== 0) {
            obj.user_message = Math.round(message.user_message);
        }
        if (message.biz_message) {
            const entries = Object.entries(message.biz_message);
            if (entries.length > 0) {
                obj.biz_message = {};
                entries.forEach(([k, v]) => {
                    obj.biz_message[k] = Math.round(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.UnreadCount.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseUnreadCount();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : 0;
        message.message = (_b = object.message) !== null && _b !== void 0 ? _b : 0;
        message.notification = (_c = object.notification) !== null && _c !== void 0 ? _c : 0;
        message.user_message = (_d = object.user_message) !== null && _d !== void 0 ? _d : 0;
        message.biz_message = Object.entries((_e = object.biz_message) !== null && _e !== void 0 ? _e : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseUnreadCount_BizMessageEntry() {
    return { key: "0", value: 0 };
}
exports.UnreadCount_BizMessageEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "0") {
            writer.uint32(8).int64(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).int32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnreadCount_BizMessageEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.key = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "0",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "0") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.UnreadCount_BizMessageEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUnreadCount_BizMessageEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "0";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseSystemMessage() {
    return {
        type: SystemMessage_Type.TYPE_UNSPECIFIED,
        text: "",
        button: undefined,
    };
}
exports.SystemMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== SystemMessage_Type.TYPE_UNSPECIFIED) {
            writer.uint32(8).int32(systemMessage_TypeToNumber(message.type));
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.button !== undefined) {
            exports.Button.encode(message.button, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSystemMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = systemMessage_TypeFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.button = exports.Button.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type)
                ? systemMessage_TypeFromJSON(object.type)
                : SystemMessage_Type.TYPE_UNSPECIFIED,
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            button: isSet(object.button) ? exports.Button.fromJSON(object.button) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== SystemMessage_Type.TYPE_UNSPECIFIED) {
            obj.type = systemMessage_TypeToJSON(message.type);
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.button !== undefined) {
            obj.button = exports.Button.toJSON(message.button);
        }
        return obj;
    },
    create(base) {
        return exports.SystemMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSystemMessage();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : SystemMessage_Type.TYPE_UNSPECIFIED;
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : "";
        message.button = (object.button !== undefined && object.button !== null)
            ? exports.Button.fromPartial(object.button)
            : undefined;
        return message;
    },
};
function createBaseGenericTemplate() {
    return {
        title: "",
        text: "",
        image_url: "",
        buttons: [],
        image_aspect_ratio: ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED,
        start_thumbnail_url: "",
        end_thumbnail_url: "",
    };
}
exports.GenericTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.image_url !== "") {
            writer.uint32(26).string(message.image_url);
        }
        for (const v of message.buttons) {
            exports.Button.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.image_aspect_ratio !==
            ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED) {
            writer.uint32(40).int32(imageAspectRatioToNumber(message.image_aspect_ratio));
        }
        if (message.start_thumbnail_url !== "") {
            writer.uint32(50).string(message.start_thumbnail_url);
        }
        if (message.end_thumbnail_url !== "") {
            writer.uint32(58).string(message.end_thumbnail_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenericTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.buttons.push(exports.Button.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.image_aspect_ratio = imageAspectRatioFromJSON(reader.int32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.start_thumbnail_url = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.end_thumbnail_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            buttons: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.buttons)
                ? object.buttons.map((e) => exports.Button.fromJSON(e))
                : [],
            image_aspect_ratio: isSet(object.image_aspect_ratio)
                ? imageAspectRatioFromJSON(object.image_aspect_ratio)
                : ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED,
            start_thumbnail_url: isSet(object.start_thumbnail_url)
                ? globalThis.String(object.start_thumbnail_url)
                : "",
            end_thumbnail_url: isSet(object.end_thumbnail_url)
                ? globalThis.String(object.end_thumbnail_url)
                : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if ((_a = message.buttons) === null || _a === void 0 ? void 0 : _a.length) {
            obj.buttons = message.buttons.map((e) => exports.Button.toJSON(e));
        }
        if (message.image_aspect_ratio !==
            ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED) {
            obj.image_aspect_ratio = imageAspectRatioToJSON(message.image_aspect_ratio);
        }
        if (message.start_thumbnail_url !== "") {
            obj.start_thumbnail_url = message.start_thumbnail_url;
        }
        if (message.end_thumbnail_url !== "") {
            obj.end_thumbnail_url = message.end_thumbnail_url;
        }
        return obj;
    },
    create(base) {
        return exports.GenericTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseGenericTemplate();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : "";
        message.image_url = (_c = object.image_url) !== null && _c !== void 0 ? _c : "";
        message.buttons = ((_d = object.buttons) === null || _d === void 0 ? void 0 : _d.map((e) => exports.Button.fromPartial(e))) || [];
        message.image_aspect_ratio = (_e = object.image_aspect_ratio) !== null && _e !== void 0 ? _e : ImageAspectRatio.IMAGE_ASPECT_RATIO_UNSPECIFIED;
        message.start_thumbnail_url = (_f = object.start_thumbnail_url) !== null && _f !== void 0 ? _f : "";
        message.end_thumbnail_url = (_g = object.end_thumbnail_url) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
function createBaseArticleTemplate() {
    return {
        target_uri: "",
        image_url: "",
        price: 0,
        has_price: false,
        title: "",
        message_type: "",
    };
}
exports.ArticleTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target_uri !== "") {
            writer.uint32(10).string(message.target_uri);
        }
        if (message.image_url !== "") {
            writer.uint32(18).string(message.image_url);
        }
        if (message.price !== 0) {
            writer.uint32(25).double(message.price);
        }
        if (message.has_price !== false) {
            writer.uint32(32).bool(message.has_price);
        }
        if (message.title !== "") {
            writer.uint32(42).string(message.title);
        }
        if (message.message_type !== "") {
            writer.uint32(50).string(message.message_type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseArticleTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.price = reader.double();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.has_price = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.message_type = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            has_price: isSet(object.has_price)
                ? globalThis.Boolean(object.has_price)
                : false,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            message_type: isSet(object.message_type)
                ? globalThis.String(object.message_type)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.has_price !== false) {
            obj.has_price = message.has_price;
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.message_type !== "") {
            obj.message_type = message.message_type;
        }
        return obj;
    },
    create(base) {
        return exports.ArticleTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseArticleTemplate();
        message.target_uri = (_a = object.target_uri) !== null && _a !== void 0 ? _a : "";
        message.image_url = (_b = object.image_url) !== null && _b !== void 0 ? _b : "";
        message.price = (_c = object.price) !== null && _c !== void 0 ? _c : 0;
        message.has_price = (_d = object.has_price) !== null && _d !== void 0 ? _d : false;
        message.title = (_e = object.title) !== null && _e !== void 0 ? _e : "";
        message.message_type = (_f = object.message_type) !== null && _f !== void 0 ? _f : "";
        return message;
    },
};
function createBaseLocationTemplate() {
    return { latitude: "", longitude: "", image_url: "", picture_id: "" };
}
exports.LocationTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.latitude !== "") {
            writer.uint32(10).string(message.latitude);
        }
        if (message.longitude !== "") {
            writer.uint32(18).string(message.longitude);
        }
        if (message.image_url !== "") {
            writer.uint32(26).string(message.image_url);
        }
        if (message.picture_id !== "") {
            writer.uint32(42).string(message.picture_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLocationTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.latitude = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.longitude = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.picture_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            latitude: isSet(object.latitude)
                ? globalThis.String(object.latitude)
                : "",
            longitude: isSet(object.longitude)
                ? globalThis.String(object.longitude)
                : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            picture_id: isSet(object.picture_id)
                ? globalThis.String(object.picture_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.latitude !== "") {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== "") {
            obj.longitude = message.longitude;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.picture_id !== "") {
            obj.picture_id = message.picture_id;
        }
        return obj;
    },
    create(base) {
        return exports.LocationTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseLocationTemplate();
        message.latitude = (_a = object.latitude) !== null && _a !== void 0 ? _a : "";
        message.longitude = (_b = object.longitude) !== null && _b !== void 0 ? _b : "";
        message.image_url = (_c = object.image_url) !== null && _c !== void 0 ? _c : "";
        message.picture_id = (_d = object.picture_id) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseIconTemplate() {
    return { text: "", image_url: "", target_uri: "" };
}
exports.IconTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.image_url !== "") {
            writer.uint32(18).string(message.image_url);
        }
        if (message.target_uri !== "") {
            writer.uint32(26).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIconTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.IconTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseIconTemplate();
        message.text = (_a = object.text) !== null && _a !== void 0 ? _a : "";
        message.image_url = (_b = object.image_url) !== null && _b !== void 0 ? _b : "";
        message.target_uri = (_c = object.target_uri) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseInlineTemplate() {
    return { rich_text: "" };
}
exports.InlineTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rich_text !== "") {
            writer.uint32(10).string(message.rich_text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInlineTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rich_text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rich_text: isSet(object.rich_text)
                ? globalThis.String(object.rich_text)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rich_text !== "") {
            obj.rich_text = message.rich_text;
        }
        return obj;
    },
    create(base) {
        return exports.InlineTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseInlineTemplate();
        message.rich_text = (_a = object.rich_text) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseButton() {
    return {
        type: Button_Type.TYPE_UNSPECIFIED,
        uri: "",
        text: "",
        target_uri: undefined,
        text_shortcut: undefined,
        postback_payload: undefined,
        postback_payload_only_for_input: undefined,
        button_target_uri: undefined,
    };
}
exports.Button = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== Button_Type.TYPE_UNSPECIFIED) {
            writer.uint32(8).int32(button_TypeToNumber(message.type));
        }
        if (message.uri !== "") {
            writer.uint32(18).string(message.uri);
        }
        if (message.text !== "") {
            writer.uint32(26).string(message.text);
        }
        if (message.target_uri !== undefined) {
            writer.uint32(802).string(message.target_uri);
        }
        if (message.text_shortcut !== undefined) {
            exports.TextShortcut.encode(message.text_shortcut, writer.uint32(810).fork())
                .ldelim();
        }
        if (message.postback_payload !== undefined) {
            writer.uint32(818).string(message.postback_payload);
        }
        if (message.postback_payload_only_for_input !== undefined) {
            exports.ButtonPostbackPayload.encode(message.postback_payload_only_for_input, writer.uint32(826).fork()).ldelim();
        }
        if (message.button_target_uri !== undefined) {
            exports.ButtonTargetURI.encode(message.button_target_uri, writer.uint32(834).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButton();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = button_TypeFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.uri = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.text_shortcut = exports.TextShortcut.decode(reader, reader.uint32());
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.postback_payload = reader.string();
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.postback_payload_only_for_input = exports.ButtonPostbackPayload
                        .decode(reader, reader.uint32());
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.button_target_uri = exports.ButtonTargetURI.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type)
                ? button_TypeFromJSON(object.type)
                : Button_Type.TYPE_UNSPECIFIED,
            uri: isSet(object.uri) ? globalThis.String(object.uri) : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : undefined,
            text_shortcut: isSet(object.text_shortcut)
                ? exports.TextShortcut.fromJSON(object.text_shortcut)
                : undefined,
            postback_payload: isSet(object.postback_payload)
                ? globalThis.String(object.postback_payload)
                : undefined,
            postback_payload_only_for_input: isSet(object.postback_payload_only_for_input)
                ? exports.ButtonPostbackPayload.fromJSON(object.postback_payload_only_for_input)
                : undefined,
            button_target_uri: isSet(object.button_target_uri)
                ? exports.ButtonTargetURI.fromJSON(object.button_target_uri)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== Button_Type.TYPE_UNSPECIFIED) {
            obj.type = button_TypeToJSON(message.type);
        }
        if (message.uri !== "") {
            obj.uri = message.uri;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.target_uri !== undefined) {
            obj.target_uri = message.target_uri;
        }
        if (message.text_shortcut !== undefined) {
            obj.text_shortcut = exports.TextShortcut.toJSON(message.text_shortcut);
        }
        if (message.postback_payload !== undefined) {
            obj.postback_payload = message.postback_payload;
        }
        if (message.postback_payload_only_for_input !== undefined) {
            obj.postback_payload_only_for_input = exports.ButtonPostbackPayload.toJSON(message.postback_payload_only_for_input);
        }
        if (message.button_target_uri !== undefined) {
            obj.button_target_uri = exports.ButtonTargetURI.toJSON(message.button_target_uri);
        }
        return obj;
    },
    create(base) {
        return exports.Button.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseButton();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : Button_Type.TYPE_UNSPECIFIED;
        message.uri = (_b = object.uri) !== null && _b !== void 0 ? _b : "";
        message.text = (_c = object.text) !== null && _c !== void 0 ? _c : "";
        message.target_uri = (_d = object.target_uri) !== null && _d !== void 0 ? _d : undefined;
        message.text_shortcut =
            (object.text_shortcut !== undefined && object.text_shortcut !== null)
                ? exports.TextShortcut.fromPartial(object.text_shortcut)
                : undefined;
        message.postback_payload = (_e = object.postback_payload) !== null && _e !== void 0 ? _e : undefined;
        message.postback_payload_only_for_input =
            (object.postback_payload_only_for_input !== undefined &&
                object.postback_payload_only_for_input !== null)
                ? exports.ButtonPostbackPayload.fromPartial(object.postback_payload_only_for_input)
                : undefined;
        message.button_target_uri = (object.button_target_uri !== undefined &&
            object.button_target_uri !== null)
            ? exports.ButtonTargetURI.fromPartial(object.button_target_uri)
            : undefined;
        return message;
    },
};
function createBaseButtonTargetURI() {
    return { app_target_uri: "", web_target_uri: "" };
}
exports.ButtonTargetURI = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.app_target_uri !== "") {
            writer.uint32(10).string(message.app_target_uri);
        }
        if (message.web_target_uri !== "") {
            writer.uint32(18).string(message.web_target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonTargetURI();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.app_target_uri = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.web_target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            app_target_uri: isSet(object.app_target_uri)
                ? globalThis.String(object.app_target_uri)
                : "",
            web_target_uri: isSet(object.web_target_uri)
                ? globalThis.String(object.web_target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.app_target_uri !== "") {
            obj.app_target_uri = message.app_target_uri;
        }
        if (message.web_target_uri !== "") {
            obj.web_target_uri = message.web_target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.ButtonTargetURI.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseButtonTargetURI();
        message.app_target_uri = (_a = object.app_target_uri) !== null && _a !== void 0 ? _a : "";
        message.web_target_uri = (_b = object.web_target_uri) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseButtonPostbackPayload() {
    return {
        type: ButtonPostbackPayload_Type.TYPE_UNSPECIFIED,
        promise_payload: undefined,
        web_logout_payload: undefined,
        webhook_payload: undefined,
    };
}
exports.ButtonPostbackPayload = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== ButtonPostbackPayload_Type.TYPE_UNSPECIFIED) {
            writer.uint32(8).int32(buttonPostbackPayload_TypeToNumber(message.type));
        }
        if (message.promise_payload !== undefined) {
            exports.ButtonPostbackPayload_HoianPromise.encode(message.promise_payload, writer.uint32(18).fork()).ldelim();
        }
        if (message.web_logout_payload !== undefined) {
            exports.ButtonPostbackPayload_WebLogout.encode(message.web_logout_payload, writer.uint32(26).fork()).ldelim();
        }
        if (message.webhook_payload !== undefined) {
            exports.ButtonPostbackPayload_Webhook.encode(message.webhook_payload, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonPostbackPayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = buttonPostbackPayload_TypeFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.promise_payload = exports.ButtonPostbackPayload_HoianPromise.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.web_logout_payload = exports.ButtonPostbackPayload_WebLogout.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.webhook_payload = exports.ButtonPostbackPayload_Webhook.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type)
                ? buttonPostbackPayload_TypeFromJSON(object.type)
                : ButtonPostbackPayload_Type.TYPE_UNSPECIFIED,
            promise_payload: isSet(object.promise_payload)
                ? exports.ButtonPostbackPayload_HoianPromise.fromJSON(object.promise_payload)
                : undefined,
            web_logout_payload: isSet(object.web_logout_payload)
                ? exports.ButtonPostbackPayload_WebLogout.fromJSON(object.web_logout_payload)
                : undefined,
            webhook_payload: isSet(object.webhook_payload)
                ? exports.ButtonPostbackPayload_Webhook.fromJSON(object.webhook_payload)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== ButtonPostbackPayload_Type.TYPE_UNSPECIFIED) {
            obj.type = buttonPostbackPayload_TypeToJSON(message.type);
        }
        if (message.promise_payload !== undefined) {
            obj.promise_payload = exports.ButtonPostbackPayload_HoianPromise.toJSON(message.promise_payload);
        }
        if (message.web_logout_payload !== undefined) {
            obj.web_logout_payload = exports.ButtonPostbackPayload_WebLogout.toJSON(message.web_logout_payload);
        }
        if (message.webhook_payload !== undefined) {
            obj.webhook_payload = exports.ButtonPostbackPayload_Webhook.toJSON(message.webhook_payload);
        }
        return obj;
    },
    create(base) {
        return exports.ButtonPostbackPayload.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseButtonPostbackPayload();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : ButtonPostbackPayload_Type.TYPE_UNSPECIFIED;
        message.promise_payload =
            (object.promise_payload !== undefined && object.promise_payload !== null)
                ? exports.ButtonPostbackPayload_HoianPromise.fromPartial(object.promise_payload)
                : undefined;
        message.web_logout_payload = (object.web_logout_payload !== undefined &&
            object.web_logout_payload !== null)
            ? exports.ButtonPostbackPayload_WebLogout.fromPartial(object.web_logout_payload)
            : undefined;
        message.webhook_payload =
            (object.webhook_payload !== undefined && object.webhook_payload !== null)
                ? exports.ButtonPostbackPayload_Webhook.fromPartial(object.webhook_payload)
                : undefined;
        return message;
    },
};
function createBaseButtonPostbackPayload_HoianPromise() {
    return {
        user_id: "0",
        channel_id: "",
        updated_at: undefined,
        promise_change_unix_timestamp: undefined,
    };
}
exports.ButtonPostbackPayload_HoianPromise = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user_id !== "0") {
            writer.uint32(8).int64(message.user_id);
        }
        if (message.channel_id !== "") {
            writer.uint32(18).string(message.channel_id);
        }
        if (message.updated_at !== undefined) {
            timestamp_1.Timestamp.encode(message.updated_at, writer.uint32(26).fork()).ldelim();
        }
        if (message.promise_change_unix_timestamp !== undefined) {
            writer.uint32(32).int64(message.promise_change_unix_timestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonPostbackPayload_HoianPromise();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.user_id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.updated_at = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.promise_change_unix_timestamp = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : "0",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            updated_at: isSet(object.updated_at)
                ? fromJsonTimestamp(object.updated_at)
                : undefined,
            promise_change_unix_timestamp: isSet(object.promise_change_unix_timestamp)
                ? globalThis.String(object.promise_change_unix_timestamp)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.user_id !== "0") {
            obj.user_id = message.user_id;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.updated_at !== undefined) {
            obj.updated_at = fromTimestamp(message.updated_at).toISOString();
        }
        if (message.promise_change_unix_timestamp !== undefined) {
            obj.promise_change_unix_timestamp = message.promise_change_unix_timestamp;
        }
        return obj;
    },
    create(base) {
        return exports.ButtonPostbackPayload_HoianPromise.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseButtonPostbackPayload_HoianPromise();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : "0";
        message.channel_id = (_b = object.channel_id) !== null && _b !== void 0 ? _b : "";
        message.updated_at =
            (object.updated_at !== undefined && object.updated_at !== null)
                ? timestamp_1.Timestamp.fromPartial(object.updated_at)
                : undefined;
        message.promise_change_unix_timestamp =
            (_c = object.promise_change_unix_timestamp) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseButtonPostbackPayload_WebLogout() {
    return { user_id: "0" };
}
exports.ButtonPostbackPayload_WebLogout = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user_id !== "0") {
            writer.uint32(8).int64(message.user_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonPostbackPayload_WebLogout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.user_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.user_id !== "0") {
            obj.user_id = message.user_id;
        }
        return obj;
    },
    create(base) {
        return exports.ButtonPostbackPayload_WebLogout.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseButtonPostbackPayload_WebLogout();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : "0";
        return message;
    },
};
function createBaseButtonPostbackPayload_Webhook() {
    return {
        http_url: "",
        http_method: ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED,
        json: undefined,
    };
}
exports.ButtonPostbackPayload_Webhook = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.http_url !== "") {
            writer.uint32(10).string(message.http_url);
        }
        if (message.http_method !==
            ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED) {
            writer.uint32(16).int32(buttonPostbackPayload_Webhook_HttpMethodToNumber(message.http_method));
        }
        if (message.json !== undefined) {
            writer.uint32(26).string(message.json);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonPostbackPayload_Webhook();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.http_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.http_method =
                        buttonPostbackPayload_Webhook_HttpMethodFromJSON(reader.int32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.json = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            http_url: isSet(object.http_url)
                ? globalThis.String(object.http_url)
                : "",
            http_method: isSet(object.http_method)
                ? buttonPostbackPayload_Webhook_HttpMethodFromJSON(object.http_method)
                : ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED,
            json: isSet(object.json) ? globalThis.String(object.json) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.http_url !== "") {
            obj.http_url = message.http_url;
        }
        if (message.http_method !==
            ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED) {
            obj.http_method = buttonPostbackPayload_Webhook_HttpMethodToJSON(message.http_method);
        }
        if (message.json !== undefined) {
            obj.json = message.json;
        }
        return obj;
    },
    create(base) {
        return exports.ButtonPostbackPayload_Webhook.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseButtonPostbackPayload_Webhook();
        message.http_url = (_a = object.http_url) !== null && _a !== void 0 ? _a : "";
        message.http_method = (_b = object.http_method) !== null && _b !== void 0 ? _b : ButtonPostbackPayload_Webhook_HttpMethod.UNSPECIFIED;
        message.json = (_c = object.json) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseButtonPostbackAction() {
    return { open_url: undefined, snackbar: undefined };
}
exports.ButtonPostbackAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.open_url !== undefined) {
            writer.uint32(10).string(message.open_url);
        }
        if (message.snackbar !== undefined) {
            exports.Snackbar.encode(message.snackbar, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseButtonPostbackAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.open_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.snackbar = exports.Snackbar.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            open_url: isSet(object.open_url)
                ? globalThis.String(object.open_url)
                : undefined,
            snackbar: isSet(object.snackbar)
                ? exports.Snackbar.fromJSON(object.snackbar)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.open_url !== undefined) {
            obj.open_url = message.open_url;
        }
        if (message.snackbar !== undefined) {
            obj.snackbar = exports.Snackbar.toJSON(message.snackbar);
        }
        return obj;
    },
    create(base) {
        return exports.ButtonPostbackAction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseButtonPostbackAction();
        message.open_url = (_a = object.open_url) !== null && _a !== void 0 ? _a : undefined;
        message.snackbar =
            (object.snackbar !== undefined && object.snackbar !== null)
                ? exports.Snackbar.fromPartial(object.snackbar)
                : undefined;
        return message;
    },
};
function createBaseSnackbar() {
    return { message: "", button: undefined };
}
exports.Snackbar = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.button !== undefined) {
            exports.Button.encode(message.button, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnackbar();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.button = exports.Button.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            button: isSet(object.button) ? exports.Button.fromJSON(object.button) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.button !== undefined) {
            obj.button = exports.Button.toJSON(message.button);
        }
        return obj;
    },
    create(base) {
        return exports.Snackbar.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSnackbar();
        message.message = (_a = object.message) !== null && _a !== void 0 ? _a : "";
        message.button = (object.button !== undefined && object.button !== null)
            ? exports.Button.fromPartial(object.button)
            : undefined;
        return message;
    },
};
function createBaseBizAccount() {
    return {
        id: "0",
        name: "",
        individual: false,
        image_url: "",
        target_uri: "",
        reviews_count: "0",
        followers_count: "0",
        region_name: "",
        msg_count: 0,
        reviewed_by_me: false,
        type: BizAccount_Type.TYPE_UNSPECIFIED,
    };
}
exports.BizAccount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.individual !== false) {
            writer.uint32(24).bool(message.individual);
        }
        if (message.image_url !== "") {
            writer.uint32(34).string(message.image_url);
        }
        if (message.target_uri !== "") {
            writer.uint32(42).string(message.target_uri);
        }
        if (message.reviews_count !== "0") {
            writer.uint32(48).int64(message.reviews_count);
        }
        if (message.followers_count !== "0") {
            writer.uint32(56).int64(message.followers_count);
        }
        if (message.region_name !== "") {
            writer.uint32(66).string(message.region_name);
        }
        if (message.msg_count !== 0) {
            writer.uint32(72).int32(message.msg_count);
        }
        if (message.reviewed_by_me !== false) {
            writer.uint32(80).bool(message.reviewed_by_me);
        }
        if (message.type !== BizAccount_Type.TYPE_UNSPECIFIED) {
            writer.uint32(88).int32(bizAccount_TypeToNumber(message.type));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBizAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.individual = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.reviews_count = longToString(reader.int64());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.followers_count = longToString(reader.int64());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.region_name = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.msg_count = reader.int32();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.reviewed_by_me = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.type = bizAccount_TypeFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            individual: isSet(object.individual)
                ? globalThis.Boolean(object.individual)
                : false,
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            reviews_count: isSet(object.reviews_count)
                ? globalThis.String(object.reviews_count)
                : "0",
            followers_count: isSet(object.followers_count)
                ? globalThis.String(object.followers_count)
                : "0",
            region_name: isSet(object.region_name)
                ? globalThis.String(object.region_name)
                : "",
            msg_count: isSet(object.msg_count)
                ? globalThis.Number(object.msg_count)
                : 0,
            reviewed_by_me: isSet(object.reviewed_by_me)
                ? globalThis.Boolean(object.reviewed_by_me)
                : false,
            type: isSet(object.type)
                ? bizAccount_TypeFromJSON(object.type)
                : BizAccount_Type.TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.individual !== false) {
            obj.individual = message.individual;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.reviews_count !== "0") {
            obj.reviews_count = message.reviews_count;
        }
        if (message.followers_count !== "0") {
            obj.followers_count = message.followers_count;
        }
        if (message.region_name !== "") {
            obj.region_name = message.region_name;
        }
        if (message.msg_count !== 0) {
            obj.msg_count = Math.round(message.msg_count);
        }
        if (message.reviewed_by_me !== false) {
            obj.reviewed_by_me = message.reviewed_by_me;
        }
        if (message.type !== BizAccount_Type.TYPE_UNSPECIFIED) {
            obj.type = bizAccount_TypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.BizAccount.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseBizAccount();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.individual = (_c = object.individual) !== null && _c !== void 0 ? _c : false;
        message.image_url = (_d = object.image_url) !== null && _d !== void 0 ? _d : "";
        message.target_uri = (_e = object.target_uri) !== null && _e !== void 0 ? _e : "";
        message.reviews_count = (_f = object.reviews_count) !== null && _f !== void 0 ? _f : "0";
        message.followers_count = (_g = object.followers_count) !== null && _g !== void 0 ? _g : "0";
        message.region_name = (_h = object.region_name) !== null && _h !== void 0 ? _h : "";
        message.msg_count = (_j = object.msg_count) !== null && _j !== void 0 ? _j : 0;
        message.reviewed_by_me = (_k = object.reviewed_by_me) !== null && _k !== void 0 ? _k : false;
        message.type = (_l = object.type) !== null && _l !== void 0 ? _l : BizAccount_Type.TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseBizAccountUser() {
    return {
        id: "0",
        user_id: "0",
        name: "",
        role: "",
        active: false,
        biz_account: undefined,
    };
}
exports.BizAccountUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.user_id !== "0") {
            writer.uint32(16).int64(message.user_id);
        }
        if (message.name !== "") {
            writer.uint32(26).string(message.name);
        }
        if (message.role !== "") {
            writer.uint32(34).string(message.role);
        }
        if (message.active !== false) {
            writer.uint32(40).bool(message.active);
        }
        if (message.biz_account !== undefined) {
            exports.BizAccount.encode(message.biz_account, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBizAccountUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.user_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.role = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.active = reader.bool();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.biz_account = exports.BizAccount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : "0",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            role: isSet(object.role) ? globalThis.String(object.role) : "",
            active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
            biz_account: isSet(object.biz_account)
                ? exports.BizAccount.fromJSON(object.biz_account)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.user_id !== "0") {
            obj.user_id = message.user_id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.role !== "") {
            obj.role = message.role;
        }
        if (message.active !== false) {
            obj.active = message.active;
        }
        if (message.biz_account !== undefined) {
            obj.biz_account = exports.BizAccount.toJSON(message.biz_account);
        }
        return obj;
    },
    create(base) {
        return exports.BizAccountUser.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseBizAccountUser();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.user_id = (_b = object.user_id) !== null && _b !== void 0 ? _b : "0";
        message.name = (_c = object.name) !== null && _c !== void 0 ? _c : "";
        message.role = (_d = object.role) !== null && _d !== void 0 ? _d : "";
        message.active = (_e = object.active) !== null && _e !== void 0 ? _e : false;
        message.biz_account =
            (object.biz_account !== undefined && object.biz_account !== null)
                ? exports.BizAccount.fromPartial(object.biz_account)
                : undefined;
        return message;
    },
};
function createBaseWebView() {
    return { app_uri: "", path_uri: "", remote_uri: "", height: 0 };
}
exports.WebView = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.app_uri !== "") {
            writer.uint32(10).string(message.app_uri);
        }
        if (message.path_uri !== "") {
            writer.uint32(18).string(message.path_uri);
        }
        if (message.remote_uri !== "") {
            writer.uint32(26).string(message.remote_uri);
        }
        if (message.height !== 0) {
            writer.uint32(32).int32(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebView();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.app_uri = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.path_uri = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.remote_uri = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            app_uri: isSet(object.app_uri) ? globalThis.String(object.app_uri) : "",
            path_uri: isSet(object.path_uri)
                ? globalThis.String(object.path_uri)
                : "",
            remote_uri: isSet(object.remote_uri)
                ? globalThis.String(object.remote_uri)
                : "",
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.app_uri !== "") {
            obj.app_uri = message.app_uri;
        }
        if (message.path_uri !== "") {
            obj.path_uri = message.path_uri;
        }
        if (message.remote_uri !== "") {
            obj.remote_uri = message.remote_uri;
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        return obj;
    },
    create(base) {
        return exports.WebView.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseWebView();
        message.app_uri = (_a = object.app_uri) !== null && _a !== void 0 ? _a : "";
        message.path_uri = (_b = object.path_uri) !== null && _b !== void 0 ? _b : "";
        message.remote_uri = (_c = object.remote_uri) !== null && _c !== void 0 ? _c : "";
        message.height = (_d = object.height) !== null && _d !== void 0 ? _d : 0;
        return message;
    },
};
function createBaseTextShortcut() {
    return { bypass: "", content: "" };
}
exports.TextShortcut = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bypass !== "") {
            writer.uint32(10).string(message.bypass);
        }
        if (message.content !== "") {
            writer.uint32(18).string(message.content);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextShortcut();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.bypass = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            bypass: isSet(object.bypass) ? globalThis.String(object.bypass) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.bypass !== "") {
            obj.bypass = message.bypass;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        return obj;
    },
    create(base) {
        return exports.TextShortcut.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTextShortcut();
        message.bypass = (_a = object.bypass) !== null && _a !== void 0 ? _a : "";
        message.content = (_b = object.content) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseBubbleGroup() {
    return { id: "0", buttons: [], tags: {} };
}
exports.BubbleGroup = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        for (const v of message.buttons) {
            exports.Button.encode(v, writer.uint32(18).fork()).ldelim();
        }
        Object.entries(message.tags).forEach(([key, value]) => {
            exports.BubbleGroup_TagsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBubbleGroup();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.buttons.push(exports.Button.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = exports.BubbleGroup_TagsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.tags[entry3.key] = entry3.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            buttons: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.buttons)
                ? object.buttons.map((e) => exports.Button.fromJSON(e))
                : [],
            tags: isObject(object.tags)
                ? Object.entries(object.tags).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if ((_a = message.buttons) === null || _a === void 0 ? void 0 : _a.length) {
            obj.buttons = message.buttons.map((e) => exports.Button.toJSON(e));
        }
        if (message.tags) {
            const entries = Object.entries(message.tags);
            if (entries.length > 0) {
                obj.tags = {};
                entries.forEach(([k, v]) => {
                    obj.tags[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.BubbleGroup.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseBubbleGroup();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.buttons = ((_b = object.buttons) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Button.fromPartial(e))) || [];
        message.tags = Object.entries((_c = object.tags) !== null && _c !== void 0 ? _c : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseBubbleGroup_TagsEntry() {
    return { key: "", value: "" };
}
exports.BubbleGroup_TagsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBubbleGroup_TagsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.BubbleGroup_TagsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseBubbleGroup_TagsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseIntroduction() {
    return { image_button: undefined, title: "", rows: [] };
}
exports.Introduction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.image_button !== undefined) {
            exports.ImageButton.encode(message.image_button, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.title !== "") {
            writer.uint32(18).string(message.title);
        }
        for (const v of message.rows) {
            exports.Introduction_Row.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntroduction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.image_button = exports.ImageButton.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.rows.push(exports.Introduction_Row.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            image_button: isSet(object.image_button)
                ? exports.ImageButton.fromJSON(object.image_button)
                : undefined,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            rows: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.rows)
                ? object.rows.map((e) => exports.Introduction_Row.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.image_button !== undefined) {
            obj.image_button = exports.ImageButton.toJSON(message.image_button);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if ((_a = message.rows) === null || _a === void 0 ? void 0 : _a.length) {
            obj.rows = message.rows.map((e) => exports.Introduction_Row.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Introduction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseIntroduction();
        message.image_button =
            (object.image_button !== undefined && object.image_button !== null)
                ? exports.ImageButton.fromPartial(object.image_button)
                : undefined;
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.rows = ((_b = object.rows) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Introduction_Row.fromPartial(e))) ||
            [];
        return message;
    },
};
function createBaseIntroduction_Row() {
    return { icon_url: "", rich_text: "" };
}
exports.Introduction_Row = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.icon_url !== "") {
            writer.uint32(10).string(message.icon_url);
        }
        if (message.rich_text !== "") {
            writer.uint32(18).string(message.rich_text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIntroduction_Row();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.icon_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.rich_text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            icon_url: isSet(object.icon_url)
                ? globalThis.String(object.icon_url)
                : "",
            rich_text: isSet(object.rich_text)
                ? globalThis.String(object.rich_text)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.icon_url !== "") {
            obj.icon_url = message.icon_url;
        }
        if (message.rich_text !== "") {
            obj.rich_text = message.rich_text;
        }
        return obj;
    },
    create(base) {
        return exports.Introduction_Row.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseIntroduction_Row();
        message.icon_url = (_a = object.icon_url) !== null && _a !== void 0 ? _a : "";
        message.rich_text = (_b = object.rich_text) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseImageButton() {
    return { image_url: "", target_uri: "", badge_url: "" };
}
exports.ImageButton = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.image_url !== "") {
            writer.uint32(10).string(message.image_url);
        }
        if (message.target_uri !== "") {
            writer.uint32(18).string(message.target_uri);
        }
        if (message.badge_url !== "") {
            writer.uint32(26).string(message.badge_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseImageButton();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.badge_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
            badge_url: isSet(object.badge_url)
                ? globalThis.String(object.badge_url)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        if (message.badge_url !== "") {
            obj.badge_url = message.badge_url;
        }
        return obj;
    },
    create(base) {
        return exports.ImageButton.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseImageButton();
        message.image_url = (_a = object.image_url) !== null && _a !== void 0 ? _a : "";
        message.target_uri = (_b = object.target_uri) !== null && _b !== void 0 ? _b : "";
        message.badge_url = (_c = object.badge_url) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseToolboxButton() {
    return {
        icon_url: "",
        text: "",
        event_name: "",
        target_uri: undefined,
        native_action: undefined,
    };
}
exports.ToolboxButton = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.icon_url !== "") {
            writer.uint32(10).string(message.icon_url);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.event_name !== "") {
            writer.uint32(26).string(message.event_name);
        }
        if (message.target_uri !== undefined) {
            writer.uint32(82).string(message.target_uri);
        }
        if (message.native_action !== undefined) {
            writer.uint32(88).int32(nativeActionToNumber(message.native_action));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToolboxButton();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.icon_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.event_name = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.native_action = nativeActionFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            icon_url: isSet(object.icon_url)
                ? globalThis.String(object.icon_url)
                : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            event_name: isSet(object.event_name)
                ? globalThis.String(object.event_name)
                : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : undefined,
            native_action: isSet(object.native_action)
                ? nativeActionFromJSON(object.native_action)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.icon_url !== "") {
            obj.icon_url = message.icon_url;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.event_name !== "") {
            obj.event_name = message.event_name;
        }
        if (message.target_uri !== undefined) {
            obj.target_uri = message.target_uri;
        }
        if (message.native_action !== undefined) {
            obj.native_action = nativeActionToJSON(message.native_action);
        }
        return obj;
    },
    create(base) {
        return exports.ToolboxButton.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseToolboxButton();
        message.icon_url = (_a = object.icon_url) !== null && _a !== void 0 ? _a : "";
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : "";
        message.event_name = (_c = object.event_name) !== null && _c !== void 0 ? _c : "";
        message.target_uri = (_d = object.target_uri) !== null && _d !== void 0 ? _d : undefined;
        message.native_action = (_e = object.native_action) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseChannelListHeader() {
    return {
        id: "",
        notice: undefined,
        notice_with_link: undefined,
        basic_banner: undefined,
    };
}
exports.ChannelListHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.notice !== undefined) {
            exports.ChannelListHeader_Notice.encode(message.notice, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.notice_with_link !== undefined) {
            exports.ChannelListHeader_NoticeWithLink.encode(message.notice_with_link, writer.uint32(90).fork()).ldelim();
        }
        if (message.basic_banner !== undefined) {
            exports.ChannelListHeader_BasicBanner.encode(message.basic_banner, writer.uint32(98).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelListHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.notice = exports.ChannelListHeader_Notice.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.notice_with_link = exports.ChannelListHeader_NoticeWithLink.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.basic_banner = exports.ChannelListHeader_BasicBanner.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            notice: isSet(object.notice)
                ? exports.ChannelListHeader_Notice.fromJSON(object.notice)
                : undefined,
            notice_with_link: isSet(object.notice_with_link)
                ? exports.ChannelListHeader_NoticeWithLink.fromJSON(object.notice_with_link)
                : undefined,
            basic_banner: isSet(object.basic_banner)
                ? exports.ChannelListHeader_BasicBanner.fromJSON(object.basic_banner)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.notice !== undefined) {
            obj.notice = exports.ChannelListHeader_Notice.toJSON(message.notice);
        }
        if (message.notice_with_link !== undefined) {
            obj.notice_with_link = exports.ChannelListHeader_NoticeWithLink.toJSON(message.notice_with_link);
        }
        if (message.basic_banner !== undefined) {
            obj.basic_banner = exports.ChannelListHeader_BasicBanner.toJSON(message.basic_banner);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelListHeader.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseChannelListHeader();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.notice = (object.notice !== undefined && object.notice !== null)
            ? exports.ChannelListHeader_Notice.fromPartial(object.notice)
            : undefined;
        message.notice_with_link = (object.notice_with_link !== undefined &&
            object.notice_with_link !== null)
            ? exports.ChannelListHeader_NoticeWithLink.fromPartial(object.notice_with_link)
            : undefined;
        message.basic_banner =
            (object.basic_banner !== undefined && object.basic_banner !== null)
                ? exports.ChannelListHeader_BasicBanner.fromPartial(object.basic_banner)
                : undefined;
        return message;
    },
};
function createBaseChannelListHeader_Notice() {
    return { rich_text: "" };
}
exports.ChannelListHeader_Notice = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rich_text !== "") {
            writer.uint32(10).string(message.rich_text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelListHeader_Notice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rich_text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rich_text: isSet(object.rich_text)
                ? globalThis.String(object.rich_text)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rich_text !== "") {
            obj.rich_text = message.rich_text;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelListHeader_Notice.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseChannelListHeader_Notice();
        message.rich_text = (_a = object.rich_text) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseChannelListHeader_NoticeWithLink() {
    return { rich_text: "", target_uri: "" };
}
exports.ChannelListHeader_NoticeWithLink = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rich_text !== "") {
            writer.uint32(10).string(message.rich_text);
        }
        if (message.target_uri !== "") {
            writer.uint32(18).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelListHeader_NoticeWithLink();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.rich_text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rich_text: isSet(object.rich_text)
                ? globalThis.String(object.rich_text)
                : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rich_text !== "") {
            obj.rich_text = message.rich_text;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelListHeader_NoticeWithLink.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseChannelListHeader_NoticeWithLink();
        message.rich_text = (_a = object.rich_text) !== null && _a !== void 0 ? _a : "";
        message.target_uri = (_b = object.target_uri) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseChannelListHeader_BasicBanner() {
    return {
        color: ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED,
        title: undefined,
        text: "",
        image_url: "",
        button: undefined,
    };
}
exports.ChannelListHeader_BasicBanner = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.color !== ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED) {
            writer.uint32(8).int32(channelListHeader_BasicBanner_ColorToNumber(message.color));
        }
        if (message.title !== undefined) {
            writer.uint32(18).string(message.title);
        }
        if (message.text !== "") {
            writer.uint32(26).string(message.text);
        }
        if (message.image_url !== "") {
            writer.uint32(34).string(message.image_url);
        }
        if (message.button !== undefined) {
            exports.ChannelListHeader_BasicBanner_Button.encode(message.button, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelListHeader_BasicBanner();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.color = channelListHeader_BasicBanner_ColorFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.button = exports.ChannelListHeader_BasicBanner_Button.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            color: isSet(object.color)
                ? channelListHeader_BasicBanner_ColorFromJSON(object.color)
                : ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED,
            title: isSet(object.title) ? globalThis.String(object.title) : undefined,
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            image_url: isSet(object.image_url)
                ? globalThis.String(object.image_url)
                : "",
            button: isSet(object.button)
                ? exports.ChannelListHeader_BasicBanner_Button.fromJSON(object.button)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.color !== ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED) {
            obj.color = channelListHeader_BasicBanner_ColorToJSON(message.color);
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.image_url !== "") {
            obj.image_url = message.image_url;
        }
        if (message.button !== undefined) {
            obj.button = exports.ChannelListHeader_BasicBanner_Button.toJSON(message.button);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelListHeader_BasicBanner.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseChannelListHeader_BasicBanner();
        message.color = (_a = object.color) !== null && _a !== void 0 ? _a : ChannelListHeader_BasicBanner_Color.COLOR_UNSPECIFIED;
        message.title = (_b = object.title) !== null && _b !== void 0 ? _b : undefined;
        message.text = (_c = object.text) !== null && _c !== void 0 ? _c : "";
        message.image_url = (_d = object.image_url) !== null && _d !== void 0 ? _d : "";
        message.button = (object.button !== undefined && object.button !== null)
            ? exports.ChannelListHeader_BasicBanner_Button.fromPartial(object.button)
            : undefined;
        return message;
    },
};
function createBaseChannelListHeader_BasicBanner_Button() {
    return {
        type: ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED,
        text: "",
        target_uri: "",
    };
}
exports.ChannelListHeader_BasicBanner_Button = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !==
            ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED) {
            writer.uint32(8).int32(channelListHeader_BasicBanner_Button_TypeToNumber(message.type));
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.target_uri !== "") {
            writer.uint32(26).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelListHeader_BasicBanner_Button();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = channelListHeader_BasicBanner_Button_TypeFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type)
                ? channelListHeader_BasicBanner_Button_TypeFromJSON(object.type)
                : ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED,
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !==
            ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED) {
            obj.type = channelListHeader_BasicBanner_Button_TypeToJSON(message.type);
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelListHeader_BasicBanner_Button.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseChannelListHeader_BasicBanner_Button();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : ChannelListHeader_BasicBanner_Button_Type.TYPE_UNSPECIFIED;
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : "";
        message.target_uri = (_c = object.target_uri) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBasePersistentMenuItem() {
    return { label: "", postback: undefined, open_url: undefined };
}
exports.PersistentMenuItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.label !== "") {
            writer.uint32(10).string(message.label);
        }
        if (message.postback !== undefined) {
            exports.PersistentMenuItem_PostbackAction.encode(message.postback, writer.uint32(82).fork()).ldelim();
        }
        if (message.open_url !== undefined) {
            exports.PersistentMenuItem_OpenURLAction.encode(message.open_url, writer.uint32(90).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistentMenuItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.label = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.postback = exports.PersistentMenuItem_PostbackAction.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.open_url = exports.PersistentMenuItem_OpenURLAction.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            label: isSet(object.label) ? globalThis.String(object.label) : "",
            postback: isSet(object.postback)
                ? exports.PersistentMenuItem_PostbackAction.fromJSON(object.postback)
                : undefined,
            open_url: isSet(object.open_url)
                ? exports.PersistentMenuItem_OpenURLAction.fromJSON(object.open_url)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.label !== "") {
            obj.label = message.label;
        }
        if (message.postback !== undefined) {
            obj.postback = exports.PersistentMenuItem_PostbackAction.toJSON(message.postback);
        }
        if (message.open_url !== undefined) {
            obj.open_url = exports.PersistentMenuItem_OpenURLAction.toJSON(message.open_url);
        }
        return obj;
    },
    create(base) {
        return exports.PersistentMenuItem.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBasePersistentMenuItem();
        message.label = (_a = object.label) !== null && _a !== void 0 ? _a : "";
        message.postback =
            (object.postback !== undefined && object.postback !== null)
                ? exports.PersistentMenuItem_PostbackAction.fromPartial(object.postback)
                : undefined;
        message.open_url =
            (object.open_url !== undefined && object.open_url !== null)
                ? exports.PersistentMenuItem_OpenURLAction.fromPartial(object.open_url)
                : undefined;
        return message;
    },
};
function createBasePersistentMenuItem_PostbackAction() {
    return { payload: "" };
}
exports.PersistentMenuItem_PostbackAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.payload !== "") {
            writer.uint32(10).string(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistentMenuItem_PostbackAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            payload: isSet(object.payload) ? globalThis.String(object.payload) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.payload !== "") {
            obj.payload = message.payload;
        }
        return obj;
    },
    create(base) {
        return exports.PersistentMenuItem_PostbackAction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBasePersistentMenuItem_PostbackAction();
        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBasePersistentMenuItem_OpenURLAction() {
    return { url: "" };
}
exports.PersistentMenuItem_OpenURLAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistentMenuItem_OpenURLAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        return obj;
    },
    create(base) {
        return exports.PersistentMenuItem_OpenURLAction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBasePersistentMenuItem_OpenURLAction();
        message.url = (_a = object.url) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBasePersistentMenu() {
    return { items: [] };
}
exports.PersistentMenu = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.items) {
            exports.PersistentMenuItem.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistentMenu();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.PersistentMenuItem.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            items: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.items)
                ? object.items.map((e) => exports.PersistentMenuItem.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.items) === null || _a === void 0 ? void 0 : _a.length) {
            obj.items = message.items.map((e) => exports.PersistentMenuItem.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PersistentMenu.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBasePersistentMenu();
        message.items =
            ((_a = object.items) === null || _a === void 0 ? void 0 : _a.map((e) => exports.PersistentMenuItem.fromPartial(e))) || [];
        return message;
    },
};
function createBaseAutoReplyMetadata() {
    return { active: false, item_count: 0, can_create_item: false };
}
exports.AutoReplyMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.active !== false) {
            writer.uint32(8).bool(message.active);
        }
        if (message.item_count !== 0) {
            writer.uint32(16).int32(message.item_count);
        }
        if (message.can_create_item !== false) {
            writer.uint32(24).bool(message.can_create_item);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAutoReplyMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.active = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.item_count = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.can_create_item = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
            item_count: isSet(object.item_count)
                ? globalThis.Number(object.item_count)
                : 0,
            can_create_item: isSet(object.can_create_item)
                ? globalThis.Boolean(object.can_create_item)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.active !== false) {
            obj.active = message.active;
        }
        if (message.item_count !== 0) {
            obj.item_count = Math.round(message.item_count);
        }
        if (message.can_create_item !== false) {
            obj.can_create_item = message.can_create_item;
        }
        return obj;
    },
    create(base) {
        return exports.AutoReplyMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseAutoReplyMetadata();
        message.active = (_a = object.active) !== null && _a !== void 0 ? _a : false;
        message.item_count = (_b = object.item_count) !== null && _b !== void 0 ? _b : 0;
        message.can_create_item = (_c = object.can_create_item) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseAutoReplyQuestion() {
    return { text: "" };
}
exports.AutoReplyQuestion = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAutoReplyQuestion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { text: isSet(object.text) ? globalThis.String(object.text) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        return obj;
    },
    create(base) {
        return exports.AutoReplyQuestion.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAutoReplyQuestion();
        message.text = (_a = object.text) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseAutoReplyAnswer() {
    return { text: "", images: [] };
}
exports.AutoReplyAnswer = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        for (const v of message.images) {
            exports.Image.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAutoReplyAnswer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.images.push(exports.Image.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            images: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.images)
                ? object.images.map((e) => exports.Image.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if ((_a = message.images) === null || _a === void 0 ? void 0 : _a.length) {
            obj.images = message.images.map((e) => exports.Image.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.AutoReplyAnswer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAutoReplyAnswer();
        message.text = (_a = object.text) !== null && _a !== void 0 ? _a : "";
        message.images = ((_b = object.images) === null || _b === void 0 ? void 0 : _b.map((e) => exports.Image.fromPartial(e))) || [];
        return message;
    },
};
function createBaseAutoReply() {
    return { id: "", question: undefined, answer: undefined };
}
exports.AutoReply = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.question !== undefined) {
            exports.AutoReplyQuestion.encode(message.question, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.answer !== undefined) {
            exports.AutoReplyAnswer.encode(message.answer, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAutoReply();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.question = exports.AutoReplyQuestion.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.answer = exports.AutoReplyAnswer.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            question: isSet(object.question)
                ? exports.AutoReplyQuestion.fromJSON(object.question)
                : undefined,
            answer: isSet(object.answer)
                ? exports.AutoReplyAnswer.fromJSON(object.answer)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.question !== undefined) {
            obj.question = exports.AutoReplyQuestion.toJSON(message.question);
        }
        if (message.answer !== undefined) {
            obj.answer = exports.AutoReplyAnswer.toJSON(message.answer);
        }
        return obj;
    },
    create(base) {
        return exports.AutoReply.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAutoReply();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.question =
            (object.question !== undefined && object.question !== null)
                ? exports.AutoReplyQuestion.fromPartial(object.question)
                : undefined;
        message.answer = (object.answer !== undefined && object.answer !== null)
            ? exports.AutoReplyAnswer.fromPartial(object.answer)
            : undefined;
        return message;
    },
};
function createBaseAnnouncement() {
    return {
        id: "",
        channel_id: "",
        content: "",
        create_time: undefined,
        create_by: undefined,
    };
}
exports.Announcement = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.channel_id !== "") {
            writer.uint32(18).string(message.channel_id);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(34).fork()).ldelim();
        }
        if (message.create_by !== undefined) {
            exports.User.encode(message.create_by, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAnnouncement();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.create_by = exports.User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            create_by: isSet(object.create_by)
                ? exports.User.fromJSON(object.create_by)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.create_by !== undefined) {
            obj.create_by = exports.User.toJSON(message.create_by);
        }
        return obj;
    },
    create(base) {
        return exports.Announcement.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseAnnouncement();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.channel_id = (_b = object.channel_id) !== null && _b !== void 0 ? _b : "";
        message.content = (_c = object.content) !== null && _c !== void 0 ? _c : "";
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.create_by =
            (object.create_by !== undefined && object.create_by !== null)
                ? exports.User.fromPartial(object.create_by)
                : undefined;
        return message;
    },
};
function createBaseSectionBlock() {
    return { text: undefined };
}
exports.SectionBlock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== undefined) {
            exports.TextNode.encode(message.text, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSectionBlock();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = exports.TextNode.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? exports.TextNode.fromJSON(object.text) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== undefined) {
            obj.text = exports.TextNode.toJSON(message.text);
        }
        return obj;
    },
    create(base) {
        return exports.SectionBlock.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseSectionBlock();
        message.text = (object.text !== undefined && object.text !== null)
            ? exports.TextNode.fromPartial(object.text)
            : undefined;
        return message;
    },
};
function createBaseTextNode() {
    return { markdown: undefined, plain_text: undefined };
}
exports.TextNode = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.markdown !== undefined) {
            exports.TextNode_Markdown.encode(message.markdown, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.plain_text !== undefined) {
            exports.TextNode_PlainText.encode(message.plain_text, writer.uint32(18).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextNode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.markdown = exports.TextNode_Markdown.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.plain_text = exports.TextNode_PlainText.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            markdown: isSet(object.markdown)
                ? exports.TextNode_Markdown.fromJSON(object.markdown)
                : undefined,
            plain_text: isSet(object.plain_text)
                ? exports.TextNode_PlainText.fromJSON(object.plain_text)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.markdown !== undefined) {
            obj.markdown = exports.TextNode_Markdown.toJSON(message.markdown);
        }
        if (message.plain_text !== undefined) {
            obj.plain_text = exports.TextNode_PlainText.toJSON(message.plain_text);
        }
        return obj;
    },
    create(base) {
        return exports.TextNode.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseTextNode();
        message.markdown =
            (object.markdown !== undefined && object.markdown !== null)
                ? exports.TextNode_Markdown.fromPartial(object.markdown)
                : undefined;
        message.plain_text =
            (object.plain_text !== undefined && object.plain_text !== null)
                ? exports.TextNode_PlainText.fromPartial(object.plain_text)
                : undefined;
        return message;
    },
};
function createBaseTextNode_Markdown() {
    return { value: "" };
}
exports.TextNode_Markdown = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextNode_Markdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.TextNode_Markdown.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTextNode_Markdown();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseTextNode_PlainText() {
    return { value: "" };
}
exports.TextNode_PlainText = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.value !== "") {
            writer.uint32(10).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTextNode_PlainText();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.TextNode_PlainText.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTextNode_PlainText();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseBlockNode() {
    return { section: undefined };
}
exports.BlockNode = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.section !== undefined) {
            exports.SectionBlock.encode(message.section, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockNode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.section = exports.SectionBlock.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            section: isSet(object.section)
                ? exports.SectionBlock.fromJSON(object.section)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.section !== undefined) {
            obj.section = exports.SectionBlock.toJSON(message.section);
        }
        return obj;
    },
    create(base) {
        return exports.BlockNode.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseBlockNode();
        message.section = (object.section !== undefined && object.section !== null)
            ? exports.SectionBlock.fromPartial(object.section)
            : undefined;
        return message;
    },
};
function createBaseBlockTemplate() {
    return { blocks: [] };
}
exports.BlockTemplate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.blocks) {
            exports.BlockNode.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBlockTemplate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.blocks.push(exports.BlockNode.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            blocks: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.blocks)
                ? object.blocks.map((e) => exports.BlockNode.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.blocks) === null || _a === void 0 ? void 0 : _a.length) {
            obj.blocks = message.blocks.map((e) => exports.BlockNode.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.BlockTemplate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBlockTemplate();
        message.blocks = ((_a = object.blocks) === null || _a === void 0 ? void 0 : _a.map((e) => exports.BlockNode.fromPartial(e))) || [];
        return message;
    },
};
function createBaseMoreMenu() {
    return { target_uri: undefined };
}
exports.MoreMenu = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target_uri !== undefined) {
            writer.uint32(10).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMoreMenu();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.target_uri !== undefined) {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.MoreMenu.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMoreMenu();
        message.target_uri = (_a = object.target_uri) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseTopBar() {
    return {
        title: "",
        title_target_uri: "",
        subtitle: "",
        subtitle_target_uri: undefined,
    };
}
exports.TopBar = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.title !== "") {
            writer.uint32(10).string(message.title);
        }
        if (message.title_target_uri !== "") {
            writer.uint32(18).string(message.title_target_uri);
        }
        if (message.subtitle !== "") {
            writer.uint32(26).string(message.subtitle);
        }
        if (message.subtitle_target_uri !== undefined) {
            writer.uint32(34).string(message.subtitle_target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTopBar();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title_target_uri = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.subtitle = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.subtitle_target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            title_target_uri: isSet(object.title_target_uri)
                ? globalThis.String(object.title_target_uri)
                : "",
            subtitle: isSet(object.subtitle)
                ? globalThis.String(object.subtitle)
                : "",
            subtitle_target_uri: isSet(object.subtitle_target_uri)
                ? globalThis.String(object.subtitle_target_uri)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.title_target_uri !== "") {
            obj.title_target_uri = message.title_target_uri;
        }
        if (message.subtitle !== "") {
            obj.subtitle = message.subtitle;
        }
        if (message.subtitle_target_uri !== undefined) {
            obj.subtitle_target_uri = message.subtitle_target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.TopBar.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseTopBar();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.title_target_uri = (_b = object.title_target_uri) !== null && _b !== void 0 ? _b : "";
        message.subtitle = (_c = object.subtitle) !== null && _c !== void 0 ? _c : "";
        message.subtitle_target_uri = (_d = object.subtitle_target_uri) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseReactionTarget() {
    return { message_id: undefined };
}
exports.ReactionTarget = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message_id !== undefined) {
            exports.ReactionTarget_MessageID.encode(message.message_id, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactionTarget();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message_id = exports.ReactionTarget_MessageID.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message_id: isSet(object.message_id)
                ? exports.ReactionTarget_MessageID.fromJSON(object.message_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message_id !== undefined) {
            obj.message_id = exports.ReactionTarget_MessageID.toJSON(message.message_id);
        }
        return obj;
    },
    create(base) {
        return exports.ReactionTarget.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseReactionTarget();
        message.message_id =
            (object.message_id !== undefined && object.message_id !== null)
                ? exports.ReactionTarget_MessageID.fromPartial(object.message_id)
                : undefined;
        return message;
    },
};
function createBaseReactionTarget_MessageID() {
    return { channel_id: "", message_id: "0" };
}
exports.ReactionTarget_MessageID = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactionTarget_MessageID();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        return obj;
    },
    create(base) {
        return exports.ReactionTarget_MessageID.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseReactionTarget_MessageID();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        return message;
    },
};
function createBaseEmoji() {
    return { id: "", icon_url: "" };
}
exports.Emoji = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.icon_url !== "") {
            writer.uint32(18).string(message.icon_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEmoji();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.icon_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            icon_url: isSet(object.icon_url)
                ? globalThis.String(object.icon_url)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.icon_url !== "") {
            obj.icon_url = message.icon_url;
        }
        return obj;
    },
    create(base) {
        return exports.Emoji.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseEmoji();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.icon_url = (_b = object.icon_url) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseReactionSummary() {
    return {
        emoji: undefined,
        preview_users: [],
        count: "0",
        has_reacted: false,
    };
}
exports.ReactionSummary = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.emoji !== undefined) {
            exports.Emoji.encode(message.emoji, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.preview_users) {
            exports.User.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.count !== "0") {
            writer.uint32(24).int64(message.count);
        }
        if (message.has_reacted !== false) {
            writer.uint32(32).bool(message.has_reacted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReactionSummary();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.emoji = exports.Emoji.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.preview_users.push(exports.User.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.count = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.has_reacted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            emoji: isSet(object.emoji) ? exports.Emoji.fromJSON(object.emoji) : undefined,
            preview_users: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.preview_users)
                ? object.preview_users.map((e) => exports.User.fromJSON(e))
                : [],
            count: isSet(object.count) ? globalThis.String(object.count) : "0",
            has_reacted: isSet(object.has_reacted)
                ? globalThis.Boolean(object.has_reacted)
                : false,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.emoji !== undefined) {
            obj.emoji = exports.Emoji.toJSON(message.emoji);
        }
        if ((_a = message.preview_users) === null || _a === void 0 ? void 0 : _a.length) {
            obj.preview_users = message.preview_users.map((e) => exports.User.toJSON(e));
        }
        if (message.count !== "0") {
            obj.count = message.count;
        }
        if (message.has_reacted !== false) {
            obj.has_reacted = message.has_reacted;
        }
        return obj;
    },
    create(base) {
        return exports.ReactionSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseReactionSummary();
        message.emoji = (object.emoji !== undefined && object.emoji !== null)
            ? exports.Emoji.fromPartial(object.emoji)
            : undefined;
        message.preview_users =
            ((_a = object.preview_users) === null || _a === void 0 ? void 0 : _a.map((e) => exports.User.fromPartial(e))) || [];
        message.count = (_b = object.count) !== null && _b !== void 0 ? _b : "0";
        message.has_reacted = (_c = object.has_reacted) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
function createBaseReaction() {
    return { emoji: undefined, user: undefined, target: undefined };
}
exports.Reaction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.emoji !== undefined) {
            exports.Emoji.encode(message.emoji, writer.uint32(10).fork()).ldelim();
        }
        if (message.user !== undefined) {
            exports.User.encode(message.user, writer.uint32(18).fork()).ldelim();
        }
        if (message.target !== undefined) {
            exports.ReactionTarget.encode(message.target, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReaction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.emoji = exports.Emoji.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.user = exports.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.target = exports.ReactionTarget.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            emoji: isSet(object.emoji) ? exports.Emoji.fromJSON(object.emoji) : undefined,
            user: isSet(object.user) ? exports.User.fromJSON(object.user) : undefined,
            target: isSet(object.target)
                ? exports.ReactionTarget.fromJSON(object.target)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.emoji !== undefined) {
            obj.emoji = exports.Emoji.toJSON(message.emoji);
        }
        if (message.user !== undefined) {
            obj.user = exports.User.toJSON(message.user);
        }
        if (message.target !== undefined) {
            obj.target = exports.ReactionTarget.toJSON(message.target);
        }
        return obj;
    },
    create(base) {
        return exports.Reaction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseReaction();
        message.emoji = (object.emoji !== undefined && object.emoji !== null)
            ? exports.Emoji.fromPartial(object.emoji)
            : undefined;
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.User.fromPartial(object.user)
            : undefined;
        message.target = (object.target !== undefined && object.target !== null)
            ? exports.ReactionTarget.fromPartial(object.target)
            : undefined;
        return message;
    },
};
function createBaseFilter() {
    return { ID: FilterID.FILTER_ID_UNSPECIFIED, name: "" };
}
exports.Filter = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ID !== FilterID.FILTER_ID_UNSPECIFIED) {
            writer.uint32(8).int32(filterIDToNumber(message.ID));
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.ID = filterIDFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ID: isSet(object.ID)
                ? filterIDFromJSON(object.ID)
                : FilterID.FILTER_ID_UNSPECIFIED,
            name: isSet(object.name) ? globalThis.String(object.name) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ID !== FilterID.FILTER_ID_UNSPECIFIED) {
            obj.ID = filterIDToJSON(message.ID);
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.Filter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseFilter();
        message.ID = (_a = object.ID) !== null && _a !== void 0 ? _a : FilterID.FILTER_ID_UNSPECIFIED;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSearchResultChannel() {
    return { id: "", name: undefined };
}
exports.SearchResultChannel = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.name !== undefined) {
            writer.uint32(18).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchResultChannel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.SearchResultChannel.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSearchResultChannel();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseSearchResultUser() {
    return {
        id: "0",
        type: User_Type.TYPE_UNSPECIFIED,
        nickname: "",
        profile_image_url: "",
        badge_image_url: undefined,
    };
}
exports.SearchResultUser = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.type !== User_Type.TYPE_UNSPECIFIED) {
            writer.uint32(16).int32(user_TypeToNumber(message.type));
        }
        if (message.nickname !== "") {
            writer.uint32(26).string(message.nickname);
        }
        if (message.profile_image_url !== "") {
            writer.uint32(34).string(message.profile_image_url);
        }
        if (message.badge_image_url !== undefined) {
            writer.uint32(42).string(message.badge_image_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchResultUser();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.type = user_TypeFromJSON(reader.int32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.profile_image_url = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.badge_image_url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            type: isSet(object.type)
                ? user_TypeFromJSON(object.type)
                : User_Type.TYPE_UNSPECIFIED,
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            profile_image_url: isSet(object.profile_image_url)
                ? globalThis.String(object.profile_image_url)
                : "",
            badge_image_url: isSet(object.badge_image_url)
                ? globalThis.String(object.badge_image_url)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.type !== User_Type.TYPE_UNSPECIFIED) {
            obj.type = user_TypeToJSON(message.type);
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.profile_image_url !== "") {
            obj.profile_image_url = message.profile_image_url;
        }
        if (message.badge_image_url !== undefined) {
            obj.badge_image_url = message.badge_image_url;
        }
        return obj;
    },
    create(base) {
        return exports.SearchResultUser.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseSearchResultUser();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : User_Type.TYPE_UNSPECIFIED;
        message.nickname = (_c = object.nickname) !== null && _c !== void 0 ? _c : "";
        message.profile_image_url = (_d = object.profile_image_url) !== null && _d !== void 0 ? _d : "";
        message.badge_image_url = (_e = object.badge_image_url) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseSearchResultReactionSummary() {
    return { emoji: undefined, count: "0", has_reacted: false };
}
exports.SearchResultReactionSummary = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.emoji !== undefined) {
            exports.Emoji.encode(message.emoji, writer.uint32(10).fork()).ldelim();
        }
        if (message.count !== "0") {
            writer.uint32(16).int64(message.count);
        }
        if (message.has_reacted !== false) {
            writer.uint32(24).bool(message.has_reacted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchResultReactionSummary();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.emoji = exports.Emoji.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.count = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.has_reacted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            emoji: isSet(object.emoji) ? exports.Emoji.fromJSON(object.emoji) : undefined,
            count: isSet(object.count) ? globalThis.String(object.count) : "0",
            has_reacted: isSet(object.has_reacted)
                ? globalThis.Boolean(object.has_reacted)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.emoji !== undefined) {
            obj.emoji = exports.Emoji.toJSON(message.emoji);
        }
        if (message.count !== "0") {
            obj.count = message.count;
        }
        if (message.has_reacted !== false) {
            obj.has_reacted = message.has_reacted;
        }
        return obj;
    },
    create(base) {
        return exports.SearchResultReactionSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSearchResultReactionSummary();
        message.emoji = (object.emoji !== undefined && object.emoji !== null)
            ? exports.Emoji.fromPartial(object.emoji)
            : undefined;
        message.count = (_a = object.count) !== null && _a !== void 0 ? _a : "0";
        message.has_reacted = (_b = object.has_reacted) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseSearchResultMessage() {
    return {
        id: "0",
        tokens: [],
        create_time: undefined,
        sender: undefined,
        reactions: [],
    };
}
exports.SearchResultMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        for (const v of message.tokens) {
            exports.SearchResultMessage_Token.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(26).fork()).ldelim();
        }
        if (message.sender !== undefined) {
            exports.SearchResultUser.encode(message.sender, writer.uint32(34).fork())
                .ldelim();
        }
        for (const v of message.reactions) {
            exports.SearchResultReactionSummary.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchResultMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tokens.push(exports.SearchResultMessage_Token.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sender = exports.SearchResultUser.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.reactions.push(exports.SearchResultReactionSummary.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            tokens: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.tokens)
                ? object.tokens.map((e) => exports.SearchResultMessage_Token.fromJSON(e))
                : [],
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            sender: isSet(object.sender)
                ? exports.SearchResultUser.fromJSON(object.sender)
                : undefined,
            reactions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.reactions)
                ? object.reactions.map((e) => exports.SearchResultReactionSummary.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if ((_a = message.tokens) === null || _a === void 0 ? void 0 : _a.length) {
            obj.tokens = message.tokens.map((e) => exports.SearchResultMessage_Token.toJSON(e));
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.sender !== undefined) {
            obj.sender = exports.SearchResultUser.toJSON(message.sender);
        }
        if ((_b = message.reactions) === null || _b === void 0 ? void 0 : _b.length) {
            obj.reactions = message.reactions.map((e) => exports.SearchResultReactionSummary.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SearchResultMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseSearchResultMessage();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.tokens =
            ((_b = object.tokens) === null || _b === void 0 ? void 0 : _b.map((e) => exports.SearchResultMessage_Token.fromPartial(e))) || [];
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? exports.SearchResultUser.fromPartial(object.sender)
            : undefined;
        message.reactions =
            ((_c = object.reactions) === null || _c === void 0 ? void 0 : _c.map((e) => exports.SearchResultReactionSummary.fromPartial(e))) || [];
        return message;
    },
};
function createBaseSearchResultMessage_Token() {
    return { plain_text: undefined, highlighted_text: undefined };
}
exports.SearchResultMessage_Token = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.plain_text !== undefined) {
            writer.uint32(10).string(message.plain_text);
        }
        if (message.highlighted_text !== undefined) {
            writer.uint32(18).string(message.highlighted_text);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchResultMessage_Token();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.plain_text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.highlighted_text = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            plain_text: isSet(object.plain_text)
                ? globalThis.String(object.plain_text)
                : undefined,
            highlighted_text: isSet(object.highlighted_text)
                ? globalThis.String(object.highlighted_text)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.plain_text !== undefined) {
            obj.plain_text = message.plain_text;
        }
        if (message.highlighted_text !== undefined) {
            obj.highlighted_text = message.highlighted_text;
        }
        return obj;
    },
    create(base) {
        return exports.SearchResultMessage_Token.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSearchResultMessage_Token();
        message.plain_text = (_a = object.plain_text) !== null && _a !== void 0 ? _a : undefined;
        message.highlighted_text = (_b = object.highlighted_text) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseSearchMessageHit() {
    return { id: "", channel: undefined, message: undefined };
}
exports.SearchMessageHit = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.channel !== undefined) {
            exports.SearchResultChannel.encode(message.channel, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.message !== undefined) {
            exports.SearchResultMessage.encode(message.message, writer.uint32(26).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchMessageHit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel = exports.SearchResultChannel.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message = exports.SearchResultMessage.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            channel: isSet(object.channel)
                ? exports.SearchResultChannel.fromJSON(object.channel)
                : undefined,
            message: isSet(object.message)
                ? exports.SearchResultMessage.fromJSON(object.message)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.channel !== undefined) {
            obj.channel = exports.SearchResultChannel.toJSON(message.channel);
        }
        if (message.message !== undefined) {
            obj.message = exports.SearchResultMessage.toJSON(message.message);
        }
        return obj;
    },
    create(base) {
        return exports.SearchMessageHit.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSearchMessageHit();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? exports.SearchResultChannel.fromPartial(object.channel)
            : undefined;
        message.message = (object.message !== undefined && object.message !== null)
            ? exports.SearchResultMessage.fromPartial(object.message)
            : undefined;
        return message;
    },
};
function createBaseSearchPagingKey() {
    return { message_id: undefined };
}
exports.SearchPagingKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message_id !== undefined) {
            writer.uint32(8).int64(message.message_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchPagingKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message_id !== undefined) {
            obj.message_id = message.message_id;
        }
        return obj;
    },
    create(base) {
        return exports.SearchPagingKey.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSearchPagingKey();
        message.message_id = (_a = object.message_id) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseUserID() {
    return { id: "0", type: UserID_Type.TYPE_UNSPECIFIED };
}
exports.UserID = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.type !== UserID_Type.TYPE_UNSPECIFIED) {
            writer.uint32(16).int32(userID_TypeToNumber(message.type));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserID();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.type = userID_TypeFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            type: isSet(object.type)
                ? userID_TypeFromJSON(object.type)
                : UserID_Type.TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.type !== UserID_Type.TYPE_UNSPECIFIED) {
            obj.type = userID_TypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.UserID.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUserID();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : UserID_Type.TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseUserSessionInfo() {
    return { user_id: undefined, session_ids: [] };
}
exports.UserSessionInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user_id !== undefined) {
            exports.UserID.encode(message.user_id, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.session_ids) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserSessionInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user_id = exports.UserID.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session_ids.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            user_id: isSet(object.user_id)
                ? exports.UserID.fromJSON(object.user_id)
                : undefined,
            session_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.session_ids)
                ? object.session_ids.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.user_id !== undefined) {
            obj.user_id = exports.UserID.toJSON(message.user_id);
        }
        if ((_a = message.session_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.session_ids = message.session_ids;
        }
        return obj;
    },
    create(base) {
        return exports.UserSessionInfo.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUserSessionInfo();
        message.user_id = (object.user_id !== undefined && object.user_id !== null)
            ? exports.UserID.fromPartial(object.user_id)
            : undefined;
        message.session_ids = ((_a = object.session_ids) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        return message;
    },
};
function createBaseUniqueMessageID() {
    return { channel_id: "", message_id: "0" };
}
exports.UniqueMessageID = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUniqueMessageID();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        return obj;
    },
    create(base) {
        return exports.UniqueMessageID.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseUniqueMessageID();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        return message;
    },
};
function createBaseSavedMessage() {
    return {
        unique_message_id: undefined,
        title: "",
        content: "",
        sender_nickname: "",
        sender_profile_image_url: "",
        sender_badge_image_url: undefined,
        thumbnail_image_url: undefined,
        thumbnail_cover_image_url: undefined,
        thumbnail_cover_text: undefined,
        create_time: undefined,
        save_time: undefined,
        is_deleted: false,
        biz_account_id: undefined,
    };
}
exports.SavedMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unique_message_id !== undefined) {
            exports.UniqueMessageID.encode(message.unique_message_id, writer.uint32(10).fork()).ldelim();
        }
        if (message.title !== "") {
            writer.uint32(18).string(message.title);
        }
        if (message.content !== "") {
            writer.uint32(26).string(message.content);
        }
        if (message.sender_nickname !== "") {
            writer.uint32(34).string(message.sender_nickname);
        }
        if (message.sender_profile_image_url !== "") {
            writer.uint32(42).string(message.sender_profile_image_url);
        }
        if (message.sender_badge_image_url !== undefined) {
            writer.uint32(50).string(message.sender_badge_image_url);
        }
        if (message.thumbnail_image_url !== undefined) {
            writer.uint32(58).string(message.thumbnail_image_url);
        }
        if (message.thumbnail_cover_image_url !== undefined) {
            writer.uint32(66).string(message.thumbnail_cover_image_url);
        }
        if (message.thumbnail_cover_text !== undefined) {
            writer.uint32(74).string(message.thumbnail_cover_text);
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(82).fork()).ldelim();
        }
        if (message.save_time !== undefined) {
            timestamp_1.Timestamp.encode(message.save_time, writer.uint32(90).fork()).ldelim();
        }
        if (message.is_deleted !== false) {
            writer.uint32(96).bool(message.is_deleted);
        }
        if (message.biz_account_id !== undefined) {
            writer.uint32(104).int64(message.biz_account_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSavedMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.unique_message_id = exports.UniqueMessageID.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.sender_nickname = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.sender_profile_image_url = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.sender_badge_image_url = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.thumbnail_image_url = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.thumbnail_cover_image_url = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.thumbnail_cover_text = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.save_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.is_deleted = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            unique_message_id: isSet(object.unique_message_id)
                ? exports.UniqueMessageID.fromJSON(object.unique_message_id)
                : undefined,
            title: isSet(object.title) ? globalThis.String(object.title) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            sender_nickname: isSet(object.sender_nickname)
                ? globalThis.String(object.sender_nickname)
                : "",
            sender_profile_image_url: isSet(object.sender_profile_image_url)
                ? globalThis.String(object.sender_profile_image_url)
                : "",
            sender_badge_image_url: isSet(object.sender_badge_image_url)
                ? globalThis.String(object.sender_badge_image_url)
                : undefined,
            thumbnail_image_url: isSet(object.thumbnail_image_url)
                ? globalThis.String(object.thumbnail_image_url)
                : undefined,
            thumbnail_cover_image_url: isSet(object.thumbnail_cover_image_url)
                ? globalThis.String(object.thumbnail_cover_image_url)
                : undefined,
            thumbnail_cover_text: isSet(object.thumbnail_cover_text)
                ? globalThis.String(object.thumbnail_cover_text)
                : undefined,
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            save_time: isSet(object.save_time)
                ? fromJsonTimestamp(object.save_time)
                : undefined,
            is_deleted: isSet(object.is_deleted)
                ? globalThis.Boolean(object.is_deleted)
                : false,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unique_message_id !== undefined) {
            obj.unique_message_id = exports.UniqueMessageID.toJSON(message.unique_message_id);
        }
        if (message.title !== "") {
            obj.title = message.title;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.sender_nickname !== "") {
            obj.sender_nickname = message.sender_nickname;
        }
        if (message.sender_profile_image_url !== "") {
            obj.sender_profile_image_url = message.sender_profile_image_url;
        }
        if (message.sender_badge_image_url !== undefined) {
            obj.sender_badge_image_url = message.sender_badge_image_url;
        }
        if (message.thumbnail_image_url !== undefined) {
            obj.thumbnail_image_url = message.thumbnail_image_url;
        }
        if (message.thumbnail_cover_image_url !== undefined) {
            obj.thumbnail_cover_image_url = message.thumbnail_cover_image_url;
        }
        if (message.thumbnail_cover_text !== undefined) {
            obj.thumbnail_cover_text = message.thumbnail_cover_text;
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.save_time !== undefined) {
            obj.save_time = fromTimestamp(message.save_time).toISOString();
        }
        if (message.is_deleted !== false) {
            obj.is_deleted = message.is_deleted;
        }
        if (message.biz_account_id !== undefined) {
            obj.biz_account_id = message.biz_account_id;
        }
        return obj;
    },
    create(base) {
        return exports.SavedMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = createBaseSavedMessage();
        message.unique_message_id = (object.unique_message_id !== undefined &&
            object.unique_message_id !== null)
            ? exports.UniqueMessageID.fromPartial(object.unique_message_id)
            : undefined;
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.content = (_b = object.content) !== null && _b !== void 0 ? _b : "";
        message.sender_nickname = (_c = object.sender_nickname) !== null && _c !== void 0 ? _c : "";
        message.sender_profile_image_url = (_d = object.sender_profile_image_url) !== null && _d !== void 0 ? _d : "";
        message.sender_badge_image_url = (_e = object.sender_badge_image_url) !== null && _e !== void 0 ? _e : undefined;
        message.thumbnail_image_url = (_f = object.thumbnail_image_url) !== null && _f !== void 0 ? _f : undefined;
        message.thumbnail_cover_image_url = (_g = object.thumbnail_cover_image_url) !== null && _g !== void 0 ? _g : undefined;
        message.thumbnail_cover_text = (_h = object.thumbnail_cover_text) !== null && _h !== void 0 ? _h : undefined;
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.save_time =
            (object.save_time !== undefined && object.save_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.save_time)
                : undefined;
        message.is_deleted = (_j = object.is_deleted) !== null && _j !== void 0 ? _j : false;
        message.biz_account_id = (_k = object.biz_account_id) !== null && _k !== void 0 ? _k : undefined;
        return message;
    },
};
function createBaseSavedMessagePagingKey() {
    return { save_time: undefined };
}
exports.SavedMessagePagingKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.save_time !== undefined) {
            timestamp_1.Timestamp.encode(message.save_time, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSavedMessagePagingKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.save_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            save_time: isSet(object.save_time)
                ? fromJsonTimestamp(object.save_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.save_time !== undefined) {
            obj.save_time = fromTimestamp(message.save_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.SavedMessagePagingKey.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseSavedMessagePagingKey();
        message.save_time =
            (object.save_time !== undefined && object.save_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.save_time)
                : undefined;
        return message;
    },
};
function createBaseEnabledFeature() {
    return {
        gift: false,
        promise: false,
        report: false,
        block: false,
        notification: false,
        manner: false,
        abuser: false,
        favorite_phrases: false,
        location: false,
        sticker: false,
        voip: false,
        send_money: false,
        edit_announcement: false,
        transfer_features: [],
        content_downloadable: false,
        search_message: false,
        send_video: false,
    };
}
exports.EnabledFeature = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.gift !== false) {
            writer.uint32(8).bool(message.gift);
        }
        if (message.promise !== false) {
            writer.uint32(16).bool(message.promise);
        }
        if (message.report !== false) {
            writer.uint32(24).bool(message.report);
        }
        if (message.block !== false) {
            writer.uint32(32).bool(message.block);
        }
        if (message.notification !== false) {
            writer.uint32(40).bool(message.notification);
        }
        if (message.manner !== false) {
            writer.uint32(48).bool(message.manner);
        }
        if (message.abuser !== false) {
            writer.uint32(56).bool(message.abuser);
        }
        if (message.favorite_phrases !== false) {
            writer.uint32(64).bool(message.favorite_phrases);
        }
        if (message.location !== false) {
            writer.uint32(72).bool(message.location);
        }
        if (message.sticker !== false) {
            writer.uint32(80).bool(message.sticker);
        }
        if (message.voip !== false) {
            writer.uint32(88).bool(message.voip);
        }
        if (message.send_money !== false) {
            writer.uint32(96).bool(message.send_money);
        }
        if (message.edit_announcement !== false) {
            writer.uint32(104).bool(message.edit_announcement);
        }
        for (const v of message.transfer_features) {
            writer.uint32(114).string(v);
        }
        if (message.content_downloadable !== false) {
            writer.uint32(120).bool(message.content_downloadable);
        }
        if (message.search_message !== false) {
            writer.uint32(128).bool(message.search_message);
        }
        if (message.send_video !== false) {
            writer.uint32(136).bool(message.send_video);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEnabledFeature();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.gift = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.promise = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.report = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.block = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.notification = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.manner = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.abuser = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.favorite_phrases = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.location = reader.bool();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.sticker = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.voip = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.send_money = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.edit_announcement = reader.bool();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.transfer_features.push(reader.string());
                    continue;
                case 15:
                    if (tag !== 120) {
                        break;
                    }
                    message.content_downloadable = reader.bool();
                    continue;
                case 16:
                    if (tag !== 128) {
                        break;
                    }
                    message.search_message = reader.bool();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.send_video = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gift: isSet(object.gift) ? globalThis.Boolean(object.gift) : false,
            promise: isSet(object.promise)
                ? globalThis.Boolean(object.promise)
                : false,
            report: isSet(object.report) ? globalThis.Boolean(object.report) : false,
            block: isSet(object.block) ? globalThis.Boolean(object.block) : false,
            notification: isSet(object.notification)
                ? globalThis.Boolean(object.notification)
                : false,
            manner: isSet(object.manner) ? globalThis.Boolean(object.manner) : false,
            abuser: isSet(object.abuser) ? globalThis.Boolean(object.abuser) : false,
            favorite_phrases: isSet(object.favorite_phrases)
                ? globalThis.Boolean(object.favorite_phrases)
                : false,
            location: isSet(object.location)
                ? globalThis.Boolean(object.location)
                : false,
            sticker: isSet(object.sticker)
                ? globalThis.Boolean(object.sticker)
                : false,
            voip: isSet(object.voip) ? globalThis.Boolean(object.voip) : false,
            send_money: isSet(object.send_money)
                ? globalThis.Boolean(object.send_money)
                : false,
            edit_announcement: isSet(object.edit_announcement)
                ? globalThis.Boolean(object.edit_announcement)
                : false,
            transfer_features: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.transfer_features)
                ? object.transfer_features.map((e) => globalThis.String(e))
                : [],
            content_downloadable: isSet(object.content_downloadable)
                ? globalThis.Boolean(object.content_downloadable)
                : false,
            search_message: isSet(object.search_message)
                ? globalThis.Boolean(object.search_message)
                : false,
            send_video: isSet(object.send_video)
                ? globalThis.Boolean(object.send_video)
                : false,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.gift !== false) {
            obj.gift = message.gift;
        }
        if (message.promise !== false) {
            obj.promise = message.promise;
        }
        if (message.report !== false) {
            obj.report = message.report;
        }
        if (message.block !== false) {
            obj.block = message.block;
        }
        if (message.notification !== false) {
            obj.notification = message.notification;
        }
        if (message.manner !== false) {
            obj.manner = message.manner;
        }
        if (message.abuser !== false) {
            obj.abuser = message.abuser;
        }
        if (message.favorite_phrases !== false) {
            obj.favorite_phrases = message.favorite_phrases;
        }
        if (message.location !== false) {
            obj.location = message.location;
        }
        if (message.sticker !== false) {
            obj.sticker = message.sticker;
        }
        if (message.voip !== false) {
            obj.voip = message.voip;
        }
        if (message.send_money !== false) {
            obj.send_money = message.send_money;
        }
        if (message.edit_announcement !== false) {
            obj.edit_announcement = message.edit_announcement;
        }
        if ((_a = message.transfer_features) === null || _a === void 0 ? void 0 : _a.length) {
            obj.transfer_features = message.transfer_features;
        }
        if (message.content_downloadable !== false) {
            obj.content_downloadable = message.content_downloadable;
        }
        if (message.search_message !== false) {
            obj.search_message = message.search_message;
        }
        if (message.send_video !== false) {
            obj.send_video = message.send_video;
        }
        return obj;
    },
    create(base) {
        return exports.EnabledFeature.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const message = createBaseEnabledFeature();
        message.gift = (_a = object.gift) !== null && _a !== void 0 ? _a : false;
        message.promise = (_b = object.promise) !== null && _b !== void 0 ? _b : false;
        message.report = (_c = object.report) !== null && _c !== void 0 ? _c : false;
        message.block = (_d = object.block) !== null && _d !== void 0 ? _d : false;
        message.notification = (_e = object.notification) !== null && _e !== void 0 ? _e : false;
        message.manner = (_f = object.manner) !== null && _f !== void 0 ? _f : false;
        message.abuser = (_g = object.abuser) !== null && _g !== void 0 ? _g : false;
        message.favorite_phrases = (_h = object.favorite_phrases) !== null && _h !== void 0 ? _h : false;
        message.location = (_j = object.location) !== null && _j !== void 0 ? _j : false;
        message.sticker = (_k = object.sticker) !== null && _k !== void 0 ? _k : false;
        message.voip = (_l = object.voip) !== null && _l !== void 0 ? _l : false;
        message.send_money = (_m = object.send_money) !== null && _m !== void 0 ? _m : false;
        message.edit_announcement = (_o = object.edit_announcement) !== null && _o !== void 0 ? _o : false;
        message.transfer_features = ((_p = object.transfer_features) === null || _p === void 0 ? void 0 : _p.map((e) => e)) || [];
        message.content_downloadable = (_q = object.content_downloadable) !== null && _q !== void 0 ? _q : false;
        message.search_message = (_r = object.search_message) !== null && _r !== void 0 ? _r : false;
        message.send_video = (_s = object.send_video) !== null && _s !== void 0 ? _s : false;
        return message;
    },
};
function createBaseChannelInput() {
    return { text: undefined, button: undefined };
}
exports.ChannelInput = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== undefined) {
            exports.ChannelInput_Text.encode(message.text, writer.uint32(10).fork()).ldelim();
        }
        if (message.button !== undefined) {
            exports.Button.encode(message.button, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelInput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = exports.ChannelInput_Text.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.button = exports.Button.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text)
                ? exports.ChannelInput_Text.fromJSON(object.text)
                : undefined,
            button: isSet(object.button) ? exports.Button.fromJSON(object.button) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== undefined) {
            obj.text = exports.ChannelInput_Text.toJSON(message.text);
        }
        if (message.button !== undefined) {
            obj.button = exports.Button.toJSON(message.button);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelInput.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseChannelInput();
        message.text = (object.text !== undefined && object.text !== null)
            ? exports.ChannelInput_Text.fromPartial(object.text)
            : undefined;
        message.button = (object.button !== undefined && object.button !== null)
            ? exports.Button.fromPartial(object.button)
            : undefined;
        return message;
    },
};
function createBaseChannelInput_Text() {
    return { is_disabled: false, placeholder: "" };
}
exports.ChannelInput_Text = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.is_disabled !== false) {
            writer.uint32(8).bool(message.is_disabled);
        }
        if (message.placeholder !== "") {
            writer.uint32(18).string(message.placeholder);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelInput_Text();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.is_disabled = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.placeholder = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            is_disabled: isSet(object.is_disabled)
                ? globalThis.Boolean(object.is_disabled)
                : false,
            placeholder: isSet(object.placeholder)
                ? globalThis.String(object.placeholder)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.is_disabled !== false) {
            obj.is_disabled = message.is_disabled;
        }
        if (message.placeholder !== "") {
            obj.placeholder = message.placeholder;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelInput_Text.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseChannelInput_Text();
        message.is_disabled = (_a = object.is_disabled) !== null && _a !== void 0 ? _a : false;
        message.placeholder = (_b = object.placeholder) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseChannelDetail() {
    return {
        id: "",
        summary: undefined,
        my_id: undefined,
        my_role: UserRole.USER_ROLE_UNSPECIFIED,
        receiver: undefined,
        biz_account_id: undefined,
        last_seen_id: "0",
        last_message_id: "0",
        last_message_time: undefined,
        favorite_time: undefined,
        has_mutual_messages: false,
    };
}
exports.ChannelDetail = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.summary !== undefined) {
            exports.ChannelSummary.encode(message.summary, writer.uint32(18).fork()).ldelim();
        }
        if (message.my_id !== undefined) {
            exports.UserID.encode(message.my_id, writer.uint32(26).fork()).ldelim();
        }
        if (message.my_role !== UserRole.USER_ROLE_UNSPECIFIED) {
            writer.uint32(32).int32(userRoleToNumber(message.my_role));
        }
        if (message.receiver !== undefined) {
            exports.User.encode(message.receiver, writer.uint32(42).fork()).ldelim();
        }
        if (message.biz_account_id !== undefined) {
            writer.uint32(48).int64(message.biz_account_id);
        }
        if (message.last_seen_id !== "0") {
            writer.uint32(80).int64(message.last_seen_id);
        }
        if (message.last_message_id !== "0") {
            writer.uint32(88).int64(message.last_message_id);
        }
        if (message.last_message_time !== undefined) {
            timestamp_1.Timestamp.encode(message.last_message_time, writer.uint32(98).fork())
                .ldelim();
        }
        if (message.favorite_time !== undefined) {
            timestamp_1.Timestamp.encode(message.favorite_time, writer.uint32(106).fork())
                .ldelim();
        }
        if (message.has_mutual_messages !== false) {
            writer.uint32(160).bool(message.has_mutual_messages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelDetail();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.summary = exports.ChannelSummary.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.my_id = exports.UserID.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.my_role = userRoleFromJSON(reader.int32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.receiver = exports.User.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.last_seen_id = longToString(reader.int64());
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.last_message_id = longToString(reader.int64());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.last_message_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.favorite_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.has_mutual_messages = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            summary: isSet(object.summary)
                ? exports.ChannelSummary.fromJSON(object.summary)
                : undefined,
            my_id: isSet(object.my_id) ? exports.UserID.fromJSON(object.my_id) : undefined,
            my_role: isSet(object.my_role)
                ? userRoleFromJSON(object.my_role)
                : UserRole.USER_ROLE_UNSPECIFIED,
            receiver: isSet(object.receiver)
                ? exports.User.fromJSON(object.receiver)
                : undefined,
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : undefined,
            last_seen_id: isSet(object.last_seen_id)
                ? globalThis.String(object.last_seen_id)
                : "0",
            last_message_id: isSet(object.last_message_id)
                ? globalThis.String(object.last_message_id)
                : "0",
            last_message_time: isSet(object.last_message_time)
                ? fromJsonTimestamp(object.last_message_time)
                : undefined,
            favorite_time: isSet(object.favorite_time)
                ? fromJsonTimestamp(object.favorite_time)
                : undefined,
            has_mutual_messages: isSet(object.has_mutual_messages)
                ? globalThis.Boolean(object.has_mutual_messages)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.summary !== undefined) {
            obj.summary = exports.ChannelSummary.toJSON(message.summary);
        }
        if (message.my_id !== undefined) {
            obj.my_id = exports.UserID.toJSON(message.my_id);
        }
        if (message.my_role !== UserRole.USER_ROLE_UNSPECIFIED) {
            obj.my_role = userRoleToJSON(message.my_role);
        }
        if (message.receiver !== undefined) {
            obj.receiver = exports.User.toJSON(message.receiver);
        }
        if (message.biz_account_id !== undefined) {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.last_seen_id !== "0") {
            obj.last_seen_id = message.last_seen_id;
        }
        if (message.last_message_id !== "0") {
            obj.last_message_id = message.last_message_id;
        }
        if (message.last_message_time !== undefined) {
            obj.last_message_time = fromTimestamp(message.last_message_time)
                .toISOString();
        }
        if (message.favorite_time !== undefined) {
            obj.favorite_time = fromTimestamp(message.favorite_time).toISOString();
        }
        if (message.has_mutual_messages !== false) {
            obj.has_mutual_messages = message.has_mutual_messages;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelDetail.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseChannelDetail();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.summary = (object.summary !== undefined && object.summary !== null)
            ? exports.ChannelSummary.fromPartial(object.summary)
            : undefined;
        message.my_id = (object.my_id !== undefined && object.my_id !== null)
            ? exports.UserID.fromPartial(object.my_id)
            : undefined;
        message.my_role = (_b = object.my_role) !== null && _b !== void 0 ? _b : UserRole.USER_ROLE_UNSPECIFIED;
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? exports.User.fromPartial(object.receiver)
                : undefined;
        message.biz_account_id = (_c = object.biz_account_id) !== null && _c !== void 0 ? _c : undefined;
        message.last_seen_id = (_d = object.last_seen_id) !== null && _d !== void 0 ? _d : "0";
        message.last_message_id = (_e = object.last_message_id) !== null && _e !== void 0 ? _e : "0";
        message.last_message_time = (object.last_message_time !== undefined &&
            object.last_message_time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.last_message_time)
            : undefined;
        message.favorite_time =
            (object.favorite_time !== undefined && object.favorite_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.favorite_time)
                : undefined;
        message.has_mutual_messages = (_f = object.has_mutual_messages) !== null && _f !== void 0 ? _f : false;
        return message;
    },
};
function createBaseChannelPreview() {
    return {
        id: "",
        summary: undefined,
        badge: Badge.BADGE_UNSPECIFIED,
        preview_message: undefined,
        unread_count: undefined,
    };
}
exports.ChannelPreview = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.summary !== undefined) {
            exports.ChannelSummary.encode(message.summary, writer.uint32(18).fork()).ldelim();
        }
        if (message.badge !== Badge.BADGE_UNSPECIFIED) {
            writer.uint32(24).int32(badgeToNumber(message.badge));
        }
        if (message.preview_message !== undefined) {
            exports.ChannelPreview_PreviewMessage.encode(message.preview_message, writer.uint32(34).fork()).ldelim();
        }
        if (message.unread_count !== undefined) {
            exports.ChannelPreview_UnreadCount.encode(message.unread_count, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelPreview();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.summary = exports.ChannelSummary.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.badge = badgeFromJSON(reader.int32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.preview_message = exports.ChannelPreview_PreviewMessage.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.unread_count = exports.ChannelPreview_UnreadCount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            summary: isSet(object.summary)
                ? exports.ChannelSummary.fromJSON(object.summary)
                : undefined,
            badge: isSet(object.badge)
                ? badgeFromJSON(object.badge)
                : Badge.BADGE_UNSPECIFIED,
            preview_message: isSet(object.preview_message)
                ? exports.ChannelPreview_PreviewMessage.fromJSON(object.preview_message)
                : undefined,
            unread_count: isSet(object.unread_count)
                ? exports.ChannelPreview_UnreadCount.fromJSON(object.unread_count)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.summary !== undefined) {
            obj.summary = exports.ChannelSummary.toJSON(message.summary);
        }
        if (message.badge !== Badge.BADGE_UNSPECIFIED) {
            obj.badge = badgeToJSON(message.badge);
        }
        if (message.preview_message !== undefined) {
            obj.preview_message = exports.ChannelPreview_PreviewMessage.toJSON(message.preview_message);
        }
        if (message.unread_count !== undefined) {
            obj.unread_count = exports.ChannelPreview_UnreadCount.toJSON(message.unread_count);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelPreview.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseChannelPreview();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.summary = (object.summary !== undefined && object.summary !== null)
            ? exports.ChannelSummary.fromPartial(object.summary)
            : undefined;
        message.badge = (_b = object.badge) !== null && _b !== void 0 ? _b : Badge.BADGE_UNSPECIFIED;
        message.preview_message =
            (object.preview_message !== undefined && object.preview_message !== null)
                ? exports.ChannelPreview_PreviewMessage.fromPartial(object.preview_message)
                : undefined;
        message.unread_count =
            (object.unread_count !== undefined && object.unread_count !== null)
                ? exports.ChannelPreview_UnreadCount.fromPartial(object.unread_count)
                : undefined;
        return message;
    },
};
function createBaseChannelPreview_PreviewMessage() {
    return { id: "", content: "", type: "" };
}
exports.ChannelPreview_PreviewMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.content !== "") {
            writer.uint32(18).string(message.content);
        }
        if (message.type !== "") {
            writer.uint32(26).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelPreview_PreviewMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            type: isSet(object.type) ? globalThis.String(object.type) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.type !== "") {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelPreview_PreviewMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseChannelPreview_PreviewMessage();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.content = (_b = object.content) !== null && _b !== void 0 ? _b : "";
        message.type = (_c = object.type) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function createBaseChannelPreview_UnreadCount() {
    return { unread_count: 0, unread_mentions_count: 0, unread_reply_count: 0 };
}
exports.ChannelPreview_UnreadCount = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unread_count !== 0) {
            writer.uint32(8).int32(message.unread_count);
        }
        if (message.unread_mentions_count !== 0) {
            writer.uint32(16).int32(message.unread_mentions_count);
        }
        if (message.unread_reply_count !== 0) {
            writer.uint32(24).int32(message.unread_reply_count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelPreview_UnreadCount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.unread_count = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.unread_mentions_count = reader.int32();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.unread_reply_count = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            unread_count: isSet(object.unread_count)
                ? globalThis.Number(object.unread_count)
                : 0,
            unread_mentions_count: isSet(object.unread_mentions_count)
                ? globalThis.Number(object.unread_mentions_count)
                : 0,
            unread_reply_count: isSet(object.unread_reply_count)
                ? globalThis.Number(object.unread_reply_count)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unread_count !== 0) {
            obj.unread_count = Math.round(message.unread_count);
        }
        if (message.unread_mentions_count !== 0) {
            obj.unread_mentions_count = Math.round(message.unread_mentions_count);
        }
        if (message.unread_reply_count !== 0) {
            obj.unread_reply_count = Math.round(message.unread_reply_count);
        }
        return obj;
    },
    create(base) {
        return exports.ChannelPreview_UnreadCount.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseChannelPreview_UnreadCount();
        message.unread_count = (_a = object.unread_count) !== null && _a !== void 0 ? _a : 0;
        message.unread_mentions_count = (_b = object.unread_mentions_count) !== null && _b !== void 0 ? _b : 0;
        message.unread_reply_count = (_c = object.unread_reply_count) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseChannelSummary() {
    return {
        id: "",
        resource_type: "",
        resource_id: "0",
        type: ChannelType.CHANNEL_TYPE_UNSPECIFIED,
        create_time: undefined,
        common_filter_id: undefined,
        service_filter_id: undefined,
        title: undefined,
        member_count: 0,
        member_limit: 0,
        is_favorite: false,
        is_read_only: false,
        is_disabled: false,
        is_mute: false,
        closed: false,
        is_temporary: false,
        last_message_id: "0",
        last_message_time: undefined,
        profile_image_urls: [],
        cover_image_text: undefined,
        cover_image_url: undefined,
        resource_icon_url: undefined,
        sort_key: "",
    };
}
exports.ChannelSummary = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.resource_type !== "") {
            writer.uint32(18).string(message.resource_type);
        }
        if (message.resource_id !== "0") {
            writer.uint32(24).int64(message.resource_id);
        }
        if (message.type !== ChannelType.CHANNEL_TYPE_UNSPECIFIED) {
            writer.uint32(32).int32(channelTypeToNumber(message.type));
        }
        if (message.create_time !== undefined) {
            timestamp_1.Timestamp.encode(message.create_time, writer.uint32(42).fork()).ldelim();
        }
        if (message.common_filter_id !== undefined) {
            writer.uint32(48).int32(filterIDToNumber(message.common_filter_id));
        }
        if (message.service_filter_id !== undefined) {
            writer.uint32(56).int32(filterIDToNumber(message.service_filter_id));
        }
        if (message.title !== undefined) {
            writer.uint32(66).string(message.title);
        }
        if (message.member_count !== 0) {
            writer.uint32(72).int32(message.member_count);
        }
        if (message.member_limit !== 0) {
            writer.uint32(80).int32(message.member_limit);
        }
        if (message.is_favorite !== false) {
            writer.uint32(160).bool(message.is_favorite);
        }
        if (message.is_read_only !== false) {
            writer.uint32(168).bool(message.is_read_only);
        }
        if (message.is_disabled !== false) {
            writer.uint32(176).bool(message.is_disabled);
        }
        if (message.is_mute !== false) {
            writer.uint32(184).bool(message.is_mute);
        }
        if (message.closed !== false) {
            writer.uint32(192).bool(message.closed);
        }
        if (message.is_temporary !== false) {
            writer.uint32(200).bool(message.is_temporary);
        }
        if (message.last_message_id !== "0") {
            writer.uint32(208).int64(message.last_message_id);
        }
        if (message.last_message_time !== undefined) {
            timestamp_1.Timestamp.encode(message.last_message_time, writer.uint32(218).fork())
                .ldelim();
        }
        for (const v of message.profile_image_urls) {
            writer.uint32(802).string(v);
        }
        if (message.cover_image_text !== undefined) {
            writer.uint32(810).string(message.cover_image_text);
        }
        if (message.cover_image_url !== undefined) {
            writer.uint32(818).string(message.cover_image_url);
        }
        if (message.resource_icon_url !== undefined) {
            writer.uint32(826).string(message.resource_icon_url);
        }
        if (message.sort_key !== "") {
            writer.uint32(226).string(message.sort_key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChannelSummary();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.type = channelTypeFromJSON(reader.int32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.create_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.common_filter_id = filterIDFromJSON(reader.int32());
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.service_filter_id = filterIDFromJSON(reader.int32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.member_count = reader.int32();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.member_limit = reader.int32();
                    continue;
                case 20:
                    if (tag !== 160) {
                        break;
                    }
                    message.is_favorite = reader.bool();
                    continue;
                case 21:
                    if (tag !== 168) {
                        break;
                    }
                    message.is_read_only = reader.bool();
                    continue;
                case 22:
                    if (tag !== 176) {
                        break;
                    }
                    message.is_disabled = reader.bool();
                    continue;
                case 23:
                    if (tag !== 184) {
                        break;
                    }
                    message.is_mute = reader.bool();
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.closed = reader.bool();
                    continue;
                case 25:
                    if (tag !== 200) {
                        break;
                    }
                    message.is_temporary = reader.bool();
                    continue;
                case 26:
                    if (tag !== 208) {
                        break;
                    }
                    message.last_message_id = longToString(reader.int64());
                    continue;
                case 27:
                    if (tag !== 218) {
                        break;
                    }
                    message.last_message_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.profile_image_urls.push(reader.string());
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.cover_image_text = reader.string();
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.cover_image_url = reader.string();
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.resource_icon_url = reader.string();
                    continue;
                case 28:
                    if (tag !== 226) {
                        break;
                    }
                    message.sort_key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : "",
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : "0",
            type: isSet(object.type)
                ? channelTypeFromJSON(object.type)
                : ChannelType.CHANNEL_TYPE_UNSPECIFIED,
            create_time: isSet(object.create_time)
                ? fromJsonTimestamp(object.create_time)
                : undefined,
            common_filter_id: isSet(object.common_filter_id)
                ? filterIDFromJSON(object.common_filter_id)
                : undefined,
            service_filter_id: isSet(object.service_filter_id)
                ? filterIDFromJSON(object.service_filter_id)
                : undefined,
            title: isSet(object.title) ? globalThis.String(object.title) : undefined,
            member_count: isSet(object.member_count)
                ? globalThis.Number(object.member_count)
                : 0,
            member_limit: isSet(object.member_limit)
                ? globalThis.Number(object.member_limit)
                : 0,
            is_favorite: isSet(object.is_favorite)
                ? globalThis.Boolean(object.is_favorite)
                : false,
            is_read_only: isSet(object.is_read_only)
                ? globalThis.Boolean(object.is_read_only)
                : false,
            is_disabled: isSet(object.is_disabled)
                ? globalThis.Boolean(object.is_disabled)
                : false,
            is_mute: isSet(object.is_mute)
                ? globalThis.Boolean(object.is_mute)
                : false,
            closed: isSet(object.closed) ? globalThis.Boolean(object.closed) : false,
            is_temporary: isSet(object.is_temporary)
                ? globalThis.Boolean(object.is_temporary)
                : false,
            last_message_id: isSet(object.last_message_id)
                ? globalThis.String(object.last_message_id)
                : "0",
            last_message_time: isSet(object.last_message_time)
                ? fromJsonTimestamp(object.last_message_time)
                : undefined,
            profile_image_urls: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.profile_image_urls)
                ? object.profile_image_urls.map((e) => globalThis.String(e))
                : [],
            cover_image_text: isSet(object.cover_image_text)
                ? globalThis.String(object.cover_image_text)
                : undefined,
            cover_image_url: isSet(object.cover_image_url)
                ? globalThis.String(object.cover_image_url)
                : undefined,
            resource_icon_url: isSet(object.resource_icon_url)
                ? globalThis.String(object.resource_icon_url)
                : undefined,
            sort_key: isSet(object.sort_key)
                ? globalThis.String(object.sort_key)
                : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.resource_type !== "") {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== "0") {
            obj.resource_id = message.resource_id;
        }
        if (message.type !== ChannelType.CHANNEL_TYPE_UNSPECIFIED) {
            obj.type = channelTypeToJSON(message.type);
        }
        if (message.create_time !== undefined) {
            obj.create_time = fromTimestamp(message.create_time).toISOString();
        }
        if (message.common_filter_id !== undefined) {
            obj.common_filter_id = filterIDToJSON(message.common_filter_id);
        }
        if (message.service_filter_id !== undefined) {
            obj.service_filter_id = filterIDToJSON(message.service_filter_id);
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.member_count !== 0) {
            obj.member_count = Math.round(message.member_count);
        }
        if (message.member_limit !== 0) {
            obj.member_limit = Math.round(message.member_limit);
        }
        if (message.is_favorite !== false) {
            obj.is_favorite = message.is_favorite;
        }
        if (message.is_read_only !== false) {
            obj.is_read_only = message.is_read_only;
        }
        if (message.is_disabled !== false) {
            obj.is_disabled = message.is_disabled;
        }
        if (message.is_mute !== false) {
            obj.is_mute = message.is_mute;
        }
        if (message.closed !== false) {
            obj.closed = message.closed;
        }
        if (message.is_temporary !== false) {
            obj.is_temporary = message.is_temporary;
        }
        if (message.last_message_id !== "0") {
            obj.last_message_id = message.last_message_id;
        }
        if (message.last_message_time !== undefined) {
            obj.last_message_time = fromTimestamp(message.last_message_time)
                .toISOString();
        }
        if ((_a = message.profile_image_urls) === null || _a === void 0 ? void 0 : _a.length) {
            obj.profile_image_urls = message.profile_image_urls;
        }
        if (message.cover_image_text !== undefined) {
            obj.cover_image_text = message.cover_image_text;
        }
        if (message.cover_image_url !== undefined) {
            obj.cover_image_url = message.cover_image_url;
        }
        if (message.resource_icon_url !== undefined) {
            obj.resource_icon_url = message.resource_icon_url;
        }
        if (message.sort_key !== "") {
            obj.sort_key = message.sort_key;
        }
        return obj;
    },
    create(base) {
        return exports.ChannelSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const message = createBaseChannelSummary();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.resource_type = (_b = object.resource_type) !== null && _b !== void 0 ? _b : "";
        message.resource_id = (_c = object.resource_id) !== null && _c !== void 0 ? _c : "0";
        message.type = (_d = object.type) !== null && _d !== void 0 ? _d : ChannelType.CHANNEL_TYPE_UNSPECIFIED;
        message.create_time =
            (object.create_time !== undefined && object.create_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.create_time)
                : undefined;
        message.common_filter_id = (_e = object.common_filter_id) !== null && _e !== void 0 ? _e : undefined;
        message.service_filter_id = (_f = object.service_filter_id) !== null && _f !== void 0 ? _f : undefined;
        message.title = (_g = object.title) !== null && _g !== void 0 ? _g : undefined;
        message.member_count = (_h = object.member_count) !== null && _h !== void 0 ? _h : 0;
        message.member_limit = (_j = object.member_limit) !== null && _j !== void 0 ? _j : 0;
        message.is_favorite = (_k = object.is_favorite) !== null && _k !== void 0 ? _k : false;
        message.is_read_only = (_l = object.is_read_only) !== null && _l !== void 0 ? _l : false;
        message.is_disabled = (_m = object.is_disabled) !== null && _m !== void 0 ? _m : false;
        message.is_mute = (_o = object.is_mute) !== null && _o !== void 0 ? _o : false;
        message.closed = (_p = object.closed) !== null && _p !== void 0 ? _p : false;
        message.is_temporary = (_q = object.is_temporary) !== null && _q !== void 0 ? _q : false;
        message.last_message_id = (_r = object.last_message_id) !== null && _r !== void 0 ? _r : "0";
        message.last_message_time = (object.last_message_time !== undefined &&
            object.last_message_time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.last_message_time)
            : undefined;
        message.profile_image_urls = ((_s = object.profile_image_urls) === null || _s === void 0 ? void 0 : _s.map((e) => e)) || [];
        message.cover_image_text = (_t = object.cover_image_text) !== null && _t !== void 0 ? _t : undefined;
        message.cover_image_url = (_u = object.cover_image_url) !== null && _u !== void 0 ? _u : undefined;
        message.resource_icon_url = (_v = object.resource_icon_url) !== null && _v !== void 0 ? _v : undefined;
        message.sort_key = (_w = object.sort_key) !== null && _w !== void 0 ? _w : "";
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (globalThis.Number(t.seconds) || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new globalThis.Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
